
import { HttpClient, HttpStatusCode } from '@angular/common/http';
import {
  Component,
  ElementRef,
  HostListener,
  Inject,
  OnInit,
  PLATFORM_ID,
  Renderer2,
  ViewChild,
  ViewChildren,
  QueryList,
  DOCUMENT
} from '@angular/core';
import { CodeEditorComponent } from '../../shared/component/code-editor/code-editor.component';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'moment';
import {ToastrService} from 'ngx-toastr';
import {WebcamImage} from 'ngx-webcam';
import {finalize, firstValueFrom, Subject, Subscription, takeUntil,} from 'rxjs';
import {AdminPermissionDto} from 'src/app/shared/model/admin-permission-dto';
import {FileDocumentDto} from 'src/app/shared/model/file-document-dto';
import {ExaminationEventService} from '../services/examination-event.service';
import {ProctoringDataDto} from 'src/app/shared/model/proctoring-data-dto';
import {CommonService} from 'src/app/shared/service/common.service';
import {MediaAccessService} from 'src/app/shared/service/media-access.service';
import {ExaminationService} from '../examination.service';
import {ValidationUtils} from 'src/app/shared/utils/Validators';
import {breadCrumbDto, ExaminationTopBarComponent,} from '../examination-top-bar/examination-top-bar.component';
import {ChunkType} from 'src/app/shared/utils/chunk-type-enums';
import initSqlJs from 'sql.js';
import {MobileFeedDto} from 'src/app/shared/model/mobile-feed-dto';
import {LoggedInUserKeys, LoggedInUserService,} from 'src/app/shared/service/logged-in-user.service';
import {DomSanitizer, SafeResourceUrl, Title,} from '@angular/platform-browser';
import {
  ProgressivePayloadDtoForDumpApi,
  ProgressiveResponseDto,
  SectionQuestionDto,
  SubCategoryDetailsDto,
  SubCategoryResponseDto,
  SubmitSectionDto,
  SubmitSectionResponseDto,
} from 'src/app/shared/model/submit-section-response-dto';
import {QuestionReportDto} from 'src/app/shared/model/QuestionReport-dto';
import {AppUsersDto} from 'src/app/shared/model/app-users-dto';
import {Editor, schema, toHTML, Toolbar} from 'ngx-editor';
import {ElectronService} from 'src/app/shared/service/electron.service';
import {ApiPriorityService} from 'src/app/shared/service/ApiPriorityService.service';
import {StopCodeServerDto} from 'src/app/shared/model/assessment-dto';
import {TechnicalQuestionDto} from 'src/app/shared/model/newQuestion-dto';
import {WebSocketResponse, WebSocketService,} from 'src/app/shared/service/websocket-mobile-status.service';
import JSZip from 'jszip';
import {SqlStorageService} from 'src/app/shared/service/sql-storage.service';
import {ThemeService} from 'src/app/shared/service/colourTheme.service';
import {VideoUploadService} from 'src/app/shared/service/VideoUploadService.service';
import {AppClient} from "../../../environments/client";
import { environment } from 'src/environments/environment';
import * as Sentry from "@sentry/angular";

export enum QuestionTypesEnums {
  SINGLE_CHOICE = 'SINGLE_CHOICE',
  FILL_IN_THE_BLANKS = 'FILL_IN_THE_BLANKS',
  AUDIO = 'AUDIO',
  VIDEO = 'VIDEO',
}
@Component({
    selector: 'app-attempt-test',
    templateUrl: './attempt-test.component.html',
    styleUrls: ['./attempt-test.component.scss'],
    standalone: false
})
export class AttemptTestComponent implements OnInit {
  constructor(
    private readonly themeService: ThemeService,
    private readonly toastr: ToastrService,
    private readonly _router: Router,
    public readonly mediaAccessService: MediaAccessService,
    public readonly _examinationService: ExaminationService,
    private readonly _examinationEventService: ExaminationEventService,
    private readonly http: HttpClient,
    @Inject(DOCUMENT) private document: any,
    public readonly _commonService: CommonService,
    private readonly loggedInUserService: LoggedInUserService,
    public readonly _sanitizer: DomSanitizer,
    private readonly _title: Title,
    private readonly renderer: Renderer2,
    private readonly electronService: ElectronService,
    private apiPriorityService: ApiPriorityService,
    @Inject(PLATFORM_ID) private platformId: object,
    private readonly route: ActivatedRoute,
    private readonly mobileFeedWebSocketService: WebSocketService,
    private readonly sqlStorageService: SqlStorageService,
    private readonly videoUploaderService: VideoUploadService
  ) {
    this._title.setTitle(`${_commonService.Enums.IQIGAI} || Proctoring-setup`);
    window.onpopstate = () => {
      if (this.startedExamination) {
        window.history.pushState(null, '', window.location.pathname);
      }
    };

    // Listen for Web Feed video upload processing events
    window.addEventListener('processVideoUpload', (event: any) => {
      const item = event.detail;
      console.log('9 processQueuedVideoUpload');

      this.processQueuedVideoUpload(
        item.videoBlob,
        item.chunkType,
        item.filePath
      );
    });

    // Listen for screen video upload processing events
    window.addEventListener('processScreenVideoUpload', (event: any) => {
      const item = event.detail;
      this.processQueuedScreenVideoUpload(
        item.videoBlob,
        item.chunkType,
        item.filePath
      );
    });
  }

  deployedClient = environment.deployedClient;

  private readonly mediaRecorderStarterTime = 100;
  canDeactivate(): boolean {
    if (this.startedExamination) {
      this.modalConfirmation.heading =
        'Are you sure you want to close the examination?';
      this.ristrictExitingAssessment = true;
      return false;
    }
    return true;
  }

  enablestepOne: boolean = false;
  enableStepTwo: boolean = false;
  enableStepThree: boolean = false;
  enablestepZero: boolean = false;
  enableStepFour: boolean = false;
  enableStepFive: any = false;
  aadharPhotoCaptured: boolean;
  imageData: any;
  audioEnabled: boolean = false;
  ableToAccessCamera: boolean = true;
  videoEnabled: boolean = false;
  /** Set once the candidate completes the in-proctoring audio/video test (records + listen-back consent). */
  audioVideoTestPassed: boolean = false;
  extensionEnabled: boolean = false;
  networkConnection: boolean = false;
  preAssessmentChecksInProgress: boolean = false;
  preAssessmentChecksPassed: boolean = false;
  isInterviewBotDrive: boolean = false;
  lastNetworkSpeedMbps: number | null = null;
  lastNetworkEffectiveType: string = '';
  preCheckModalOpen: boolean = false;
  preCheckHasFailures: boolean = false;
  preCheckPopUpContinue:boolean=false;
  preCheckResults: {
    key: string;
    label: string;
    required: boolean;
    status: 'pending' | 'pass' | 'fail' | 'warn';
    detail?: string;
  }[] = [];
  pictureCaptureEnabled: boolean = false;
  screenRecordingEnabled: boolean = false;
  groundRulesVerification: boolean = false;
  fullScreenModeEnabled: boolean = false;
  mobileFeedDto: MobileFeedDto = new MobileFeedDto();
  screenShareData: MediaStream;
  webFeedData: MediaStream;
  private mediaPermissionSubscription: Subscription;
  proctoringDto: ProctoringDataDto = new ProctoringDataDto();
  permissionsSucceed: boolean = false;
  getAllAdminPermissions: AdminPermissionDto;
  allQuestions: questionDto[] = [];
  recordedVideoDto: RecordedVideoDto = new RecordedVideoDto();
  allQuestionsData: any;
  currentPage: number = 0;
  totalPages: number;
  showImageForCloseExamination: boolean;
  numButtonsToShow: number;
  screenShareEnabled: boolean;
  attemptedQuestionsCount: number = 0;
  linkForQrCode: string = '';
  ristrictExitingAssessment: boolean = false;
  openPopUp: boolean;
  @ViewChild('userVideo', { static: false })
  userVideoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('displayRecording', { static: false })
  displayVideoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('displayVideoSetup', { static: false })
  displayVideoSetup!: ElementRef<HTMLVideoElement>;
  @ViewChild('displayAudioSetup', { static: false })
  displayAudioSetup!: ElementRef<HTMLVideoElement>;
  @ViewChild('appTopBar') appTopBar: ExaminationTopBarComponent;
  @ViewChildren(CodeEditorComponent) codeEditors: QueryList<CodeEditorComponent>;

  /** Python (id 70 = Py2, 92 = Py3) has significant whitespace — no auto-format. */
  get isPythonLanguageSelected(): boolean {
    return this.selectedLanguageId === '70' || this.selectedLanguageId === '92';
  }

  /** Re-indent the active code editor on demand (Format Code button). */
  formatCurrentCode(): void {
    // Only the editable code editor(s) opt into formatOnLoad; skip the output panel.
    this.codeEditors?.forEach((ed) => {
      if (ed.formatOnLoad) {
        ed.formatCode();
      }
    });
  }
  elem: any;
  modalConfirmation = {
    heading: '',
    alertMessageType: '',
    enableButtons: false,
    description: null,
  };
  activeTab: number = -1;
  driveData: any;
  breadCrumbList: breadCrumbDto[] = [];
  submitTestModal: boolean;
  breakTimeScreen: boolean;
  assessmentDriveSetId: any;
  allQuestionsDataForTopBar: any;
  totalQuestionDtos: any[] = [];
  sectionTimer: number;
  currentSectionIndex = 0;
  currentQuestionIndex = 0;
  currentSectionName: string;
  currentSubSectionIndex = 0;
  subSectionDetails: any[] = [];
  totalQuestionsCount: any
  currentSection: any;
  userAssessmentDriveSetId?: string;
  isLastSection?: boolean;
  stopScreenShare: boolean;
  enableStep5: any;
  isRecordedChunkMissed: boolean;
  loginUser: AppUsersDto;
  isLoading: boolean = false;
  codingLanguages: any;
  codingQuestionDto: CodingQuestionDto = new CodingQuestionDto();
  lastStatusApiResponseSuccess: boolean = false;
  makeStatusApiCall: boolean = true;
  isStatusApiRequestPending: boolean = false;
  chatGptSection: boolean = false;
  mobileConnectionModal: boolean;
  // mobileConnectionModal: boolean;
  shouldCheckMobileConnection = true;
  scanQRCodeModal: boolean = false;
  verifyUserResponseModal: boolean;
  isMobileFeedConnected: boolean = true;
  multipleDisplayWarning: boolean = false;
  multipleWindowWarning: boolean = false;
  matchingApps: any;
  lastMultipleWindowWarning = false;
  lastMatchingAppsList: string[] = [];
  lastMultipleDisplayWarning = false;
  multipleDeviceWarning = false;
  isDesktopApp: boolean;
  editorMode: string = 'python';
  externalDeviceLable: any;
  externalDeviceWarning: boolean = false;
  files: { name: string; path: string }[] = [];
  lastApiResponseSuccess: boolean = false;
  makeApiCall: boolean = true;
  isApiRequestPending: boolean = false;
  webFeedCounter: number;
  screenShareCounter: number;
  jupyterNotebookName: SafeResourceUrl | null = null;
  jupyterContainerName: any;
  StopCodeServerDto: StopCodeServerDto = new StopCodeServerDto();
  technicalQuestionDto: TechnicalQuestionDto = new TechnicalQuestionDto();
  jupyterNotebookObject: any = { id: '01', name: 'Jupyter Notebook' };
  isFullWidthIDEQuestion: boolean;
  destroy$ = new Subject<void>();
  isWebSocketInitialized = false;
  dbHasData: boolean = false;
  error: string = '';
  results: any;
  allQuestionsFiles: any[] = [];
  isLiteAppVersion: boolean;
  isIqigaiOfflineDrive: boolean = false;
  allQuestionIds: string[] = [];
  isOfflineExamStarted: boolean = false;
  technicalErrorModal: boolean;
  connectedDriveId: string;
  driveId: string;
  activeProctoringTabIndex: number;
  
  //One way audio related variables :-  
  private timerRef: any;
  // Single source of truth for current state
  seconds: number=0;

  editor = new Editor({
    content: '',
    plugins: [],
    schema,
    nodeViews: {},
    history: true,
    keyboardShortcuts: true,
    inputRules: true,
  });
  toolbar: Toolbar = [
    ['bold', 'italic'],
    ['underline', 'strike'],
    ['code', 'blockquote'],
    ['ordered_list', 'bullet_list'],
    [{ heading: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'] }],
    // ['link', 'image'],
    ['text_color', 'background_color'],
    ['align_left', 'align_center', 'align_right', 'align_justify'],
    ['horizontal_rule', 'format_clear', 'indent', 'outdent'],
    ['superscript', 'subscript'],
    ['undo', 'redo'],
  ];

  disallowedCommands = [
    // Data Manipulation
    'INSERT',
    'UPDATE',
    'DELETE',
    'MERGE',
    'REPLACE',
    'TRUNCATE',
    // Data Definition
    'CREATE',
    'ALTER',
    'DROP',
    'RENAME',
    // Data Control
    'GRANT',
    'REVOKE',
    // Transaction Control
    'BEGIN',
    'START',
    'COMMIT',
    'ROLLBACK',
    //
    'PRAGMA',
    'ATTACH',
  ];

  code: any = ``;
  editorOptions: any = {
    lineNumbers: true,
    mode: this.editorMode,
    theme: 'monokai',
    autofocus: true,
    lineWrapping: true,
    highlightSelectionMatches: true,
    styleActiveLine: true,
    autoCloseBrackets: true,
    matchBrackets: true,
    smartIndent: true,
    indentUnit: 4,
    tabSize: 4,
    indentWithTabs: false,
    electricChars: true,
    lineNumberFormatter: (number: number) => `${number}.`,
    extraKeys: {
      Enter: (cm: any) => {
        this.onEnterPress(cm);
        cm.execCommand('newlineAndIndent');
      },
      // 'Ctrl-V': (cm: any) => this.onOutputPaste(null),
      // 'Cmd-V': (cm: any) => this.onOutputPaste(null),
    },
    // onPaste: (editor: any, event: ClipboardEvent) => this.onOutputPaste(event),
  };

  outputOptions: any = {
    mode: 'javascript',
    theme: 'monokai',
    lineNumbers: false,
    lineWrapping: true,
    extraKeys: {
      Enter: (cm: any) => {
        this.onEnterPress(cm);
        cm.execCommand('newlineAndIndent');
      },
      'Ctrl-V': (cm: any) => this.onOutputPaste(null),
      'Cmd-V': (cm: any) => this.onOutputPaste(null),
    },
    onPaste: (editor: any, event: ClipboardEvent) => this.onOutputPaste(event),
  };

  onOutputPaste(event: ClipboardEvent | null) {
    if (event) {
      event.stopPropagation();
      event.preventDefault();
    }
    this.toastr.info('', 'Pasting content is not allowed');
  }

  initializeWebSocketConnection(): void {
    if (this.isWebSocketInitialized) {
      return;
    }

    // Set up WebSocket subscriptions
    this.mobileFeedWebSocketService.connectionStatus$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isConnected) => {
        this.isMobileFeedConnected = isConnected;
        if (!isConnected) {
          // logger.* takes FLAT attributes as its 2nd arg — there is no
          // `tags`/`extra`/`level` options object here. Nesting them produced
          // an attribute literally named "tags" and left driveId unsearchable.
          Sentry.logger.warn("Mobile Feed Disconnected", {
            driveId: String(this.driveData),
          });
          this.mobileConnectionModal = true;
          sessionStorage.setItem('isMobileConnectionLost', 'true');
        } else {
          Sentry.logger.info("Mobile Feed Connected", {
            driveId: String(this.driveData),
          });
          this.mobileConnectionModal = false;
          sessionStorage.removeItem('isMobileConnectionLost');

          // Send initial status when connected

          const loggedInUserRaw = localStorage.getItem('loggedInUser');
          const userAssessmentIdRaw = sessionStorage.getItem(
            'userAssessmentDriveSetId'
          );
          if (!loggedInUserRaw || !userAssessmentIdRaw) {
            throw new Error('Missing required credentials');
          }

          const parsedUser = JSON.parse(loggedInUserRaw);
          const token = parsedUser?.authToken;
          this.mobileFeedWebSocketService.sendMobileFeedStatus(
            token,
            userAssessmentIdRaw
          );
        }
      });

    this.mobileFeedWebSocketService.messages$
      .pipe(takeUntil(this.destroy$))
        .subscribe((message: any) => {
        console.log(message, 'message');
        this.mobileFeedDto = message.content;

        switch (message.type) {
          case 'success':
            console.log('WebSocket:', message.content);
            console.log(this.mobileFeedDto, ' this.mobileFeedDto');

            break;
          case 'error':
            Sentry.logger.warn('WebSocket error:', message.content);
            // this.toastr.error(typeof message.content === 'string' ? message.content : 'Connection error');
            break;
          case 'info':
            console.info('WebSocket:', message.content);
            break;
        }
      });

    this.mobileFeedWebSocketService.responses$
      .pipe(takeUntil(this.destroy$))
      .subscribe((response: WebSocketResponse) => {
        if (response.disconnect) {
          this.handleDisconnect(response);
        } else {
          this.handleWebSocketResponse(response);
        }
      });

    // Connect to WebSocket
    this.mobileFeedWebSocketService.connect();
    this.isWebSocketInitialized = true;
  }
  themeBlue: boolean = false;

  // isSlowNetwork: boolean;
  // prevIsSlowNetwork:boolean;
  isOfflineNonProgressiveSections: boolean;
  isOfflineQuestionBankSections: boolean;
  async ngOnInit() {
    // (window as any).electronAPI?.setReloadBlocked(true);

    window.addEventListener('message', this.previewMessageHandler);

    this.connectedDriveId =  sessionStorage.getItem('connectedDriveId');
    this.driveId = sessionStorage.getItem('driveId');

    if(this.connectedDriveId == this.driveId){
      this.activeProctoringTabIndex = Number(sessionStorage.getItem('activeProctoringTabIndex'));
    }

    this.themeBlue = this.themeService.isBlueTheme();
    this.checkScreenRatio(window.innerWidth);
    this.driveData = this.loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.DRIVE_DETAILS
    );
    this.loginUser = this.loggedInUserService.getLoggedInUser(
      LoggedInUserKeys.LOGGED_IN_USER
    );

    const isLiteAppDrive = sessionStorage.getItem('isLiteAppDrive');
    const isOfflineNonProgressiveSections = sessionStorage.getItem(
      'isOfflineNonProgressiveSections'
    );
    const isOfflineQuestionBankSections = sessionStorage.getItem(
      'isOfflineQuestionBankSections'
    );

    if (isLiteAppDrive) {
      this.isIqigaiOfflineDrive = JSON.parse(isLiteAppDrive);
      this.isLiteAppVersion = JSON.parse(isLiteAppDrive);
      this.isOfflineNonProgressiveSections = JSON.parse(
        isOfflineNonProgressiveSections
      );
      this.isOfflineQuestionBankSections = JSON.parse(
        isOfflineQuestionBankSections
      );
    }

    // Initialize screenshot prevention
    this.initializeScreenshotPrevention();

    // this.route.paramMap.subscribe(params => {
    //   const driveId = params.get('driveId');
    //   const encryptedMobile = params.get('encryptedMobile');
    //   console.log(encryptedMobile,'encryptedMobile');

    //   if (driveId) {
    //     sessionStorage.setItem('driveId', driveId);
    //   }
    // });

    this.route.queryParamMap.subscribe((params) => {
      const token = params.get('token')?.replace(/ /g, '+');
      if (token) {
        console.log(token, 'token');
        sessionStorage.setItem('token', token);
        this._router.navigate([this._commonService.Navigations.APP_ENTRY_PAGE]);
        // this.verifyInviteLink(token);
      }
    });

    // setInterval(() => {
    //   this.checkNetworkSpeed();
    // }, 2000);
    this.mediaAccessService.activeTab = this.activeTab;
    this.elem = document.documentElement;
    this.getIpAndLocation();
    this.getAdminPermissions();
    this.editor = new Editor();

    this.enableStep5 = sessionStorage.getItem('enableStep5');
    if (this.enableStep5) {
      this._router.navigate([
        this._commonService.Navigations.DASHBOARD_ASSESSMENT,
      ]);
    }
    // Don't show ground rules screen yet - wait for pre-checks to pass in getAdminPermissions
    this.isDesktopApp = navigator.userAgent.includes('Electron');

    this.disablePrintKeys();
    // this.disableScreenCapture();
    this.isIqigaiLiteApp();
    // if(this.isLiteAppVersion){
    //  this.restrictBackgroundApps()
    //  this.getOfflineUserAssessmentData();
    // }

    this.startCamera();

    if (this.isLiteAppVersion) {
      window.addEventListener('online', () => {
        this.networkConnection = true;

        if (this.technicalErrorModal) {
          this.technicalErrorModal = false;
        }

        if (!this.loading) {
          this.getSectionProgressiveOrNonProgrossiveForStartAssessment();
        }
      });

      window.addEventListener('offline', () => {
        this.networkConnection = false;
      });
    }
  }

  // checkNetworkSpeed() {
  //   const conn = (navigator as any).connection;
  //   if (conn) {
  //     let networkSpeed = conn.downlink * 1000;

  //      console.log(networkSpeed,'networkspeed');

  //     const effectiveType = conn.effectiveType;
  //     const currentIsSlowNetwork = effectiveType === '2g' || effectiveType === '3g' || (networkSpeed && networkSpeed <= 5000);

  //     if (currentIsSlowNetwork !== this.prevIsSlowNetwork) {
  //       this.sendSlowInternetSpeed(currentIsSlowNetwork, this.driveData);
  //     }

  //     this.prevIsSlowNetwork = currentIsSlowNetwork;

  //     if (effectiveType === '2g' || effectiveType === '3g' || (networkSpeed && networkSpeed <= 5000)) {
  //       this.isSlowNetwork = true;
  //     } else {
  //       this.isSlowNetwork = false;
  //     }
  //     console.log(this.isSlowNetwork,'isSlowNetwork');

  //   }
  // }

  sendSlowInternetSpeed(isSlowNetwork: boolean, driveId: any) {
    this._examinationService
      .sendSlowInternetSpeed(isSlowNetwork, driveId)
      .subscribe((response) => {});
  }

  private buildPreCheckList(admin: AdminPermissionDto) {
    const checks = [
      { key: 'network', label: 'Internet connection available', required: true },
      { key: 'audio', label: 'Microphone access', required: !!admin.audio || this.isInterviewBotDrive },
      { key: 'video', label: 'Camera access', required: !!admin.video || this.isInterviewBotDrive },
      { key: 'extension', label: 'Assessment extension detected', required: !!admin.tabLimit },
      { key: 'speed', label: 'Network speed', required: true },
    ];

    return checks
      .filter((c) => c.required)
      .map((c) => ({ ...c, status: 'pending' as const }));
  }

  private updatePreCheckStatus(
    key: string,
    status: 'pending' | 'pass' | 'fail' | 'warn',
    detail?: string
  ) {
    const item = this.preCheckResults.find((c) => c.key === key);
    if (item) {
      item.status = status;
      item.detail = detail;
    }
  }

  /**
   * Lightweight readiness check before starting assessment.
   * Verifies audio/video/screen-share/extension (as per admin config) and network quality.
   */
  async runPreAssessmentChecks(): Promise<boolean> {
    if (this.preAssessmentChecksInProgress) {
      return false;
    }
    this.preAssessmentChecksInProgress = true;
    const admin = this.getAllAdminPermissions || {};

    // seed modal checklist
    this.preCheckResults = this.buildPreCheckList(admin);
    this.preCheckModalOpen = true;
    this.preCheckHasFailures = false;

    try {
      // Network connectivity
      this.networkConnection = this.mediaAccessService.isNetworkConnectionEnabled();
      this.updatePreCheckStatus(
        'network',
        this.networkConnection ? 'pass' : 'fail',
        this.networkConnection ? '' : 'No internet connection detected.'
      );

      // Audio
      if (admin.audio || this.isInterviewBotDrive) {
        this.audioEnabled = await this.mediaAccessService.isAudioEnabled();
        this.updatePreCheckStatus(
          'audio',
          this.audioEnabled ? 'pass' : 'fail',
          this.audioEnabled ? '' : 'Allow microphone from the lock icon in the address bar, then retry.'
        );
      }

      // Video
      if (admin.video || this.isInterviewBotDrive) {
        this.videoEnabled = await this.mediaAccessService.isVideoEnabled();
        this.updatePreCheckStatus(
          'video',
          this.videoEnabled ? 'pass' : 'fail',
          this.videoEnabled ? '' : 'Camera access is required.'
        );
      }

      // Extension (tab limit)
      if (admin.tabLimit) {
        const ok = !!this.extensionEnabled;
        this.updatePreCheckStatus(
          'extension',
          ok ? 'pass' : 'fail',
          ok ? '' : 'Assessment extension not detected.'
        );
      }

      // Network speed check – never block user, just warn if slow or unavailable
      const { speedMbps, effectiveType } = this.getNetworkMetrics();
      this.lastNetworkSpeedMbps = speedMbps;
      this.lastNetworkEffectiveType = effectiveType;
      const speedGood = speedMbps !== null && speedMbps >= 1;
      const speedSlow = speedMbps !== null && speedMbps < 1;
      let speedStatus: 'pass' | 'warn' = speedGood ? 'pass' : 'warn';
      let speedDetail = '';
      if (speedMbps === null) {
        speedDetail = 'Unable to determine network speed. Please ensure you are in a good network area.';
      } else if (speedSlow) {
        speedDetail = `${speedMbps.toFixed(2)} Mbps${effectiveType ? ` (${effectiveType})` : ''} – Network is slow, please move to a better network area.`;
      } else {
        speedDetail = `${speedMbps.toFixed(2)} Mbps${effectiveType ? ` (${effectiveType})` : ''}`;
      }
      this.updatePreCheckStatus('speed', speedStatus, speedDetail);

      this.preCheckHasFailures = this.preCheckResults.some((c) => c.status === 'fail');

      if (!this.preCheckHasFailures) {
        this.preCheckPopUpContinue=true;
        // Goes to the Logs section, not Issues — a passing pre-check is not an
        // error. It was previously a captureException, which burned error
        // quota and fired alert rules on a success.
        Sentry.logger.info("Pre-Assessment Checks Passed", {
          driveId: String(this.driveData),
          network: String(this.networkConnection),
          audio: String(admin.audio ? this.audioEnabled : 'not_required'),
          video: String(admin.video ? this.videoEnabled : 'not_required'),
          extension: String(admin.tabLimit ? !!this.extensionEnabled : 'not_required'),
          speedMbps: this.lastNetworkSpeedMbps ?? -1,
          effectiveType: String(this.lastNetworkEffectiveType ?? ''),
        });
        // close modal shortly; allow user to see green ticks
        setTimeout(() => {
          this.preCheckModalOpen = true;
        }, 100);
        return true;
      }

      // logger.warn, so severity is real — the old `level: 'warning'` inside
      // the attributes object was ignored and this arrived as info.
      // failedChecks is the single most useful field for "why can't the
      // candidate start", so keep it flat and searchable.
      Sentry.logger.warn("Pre-Assessment Checks Failed", {
        driveId: String(this.driveData),
        network: String(this.networkConnection),
        audio: String(admin.audio ? this.audioEnabled : 'not_required'),
        video: String(admin.video ? this.videoEnabled : 'not_required'),
        extension: String(admin.tabLimit ? !!this.extensionEnabled : 'not_required'),
        speedMbps: this.lastNetworkSpeedMbps ?? -1,
        effectiveType: String(this.lastNetworkEffectiveType ?? ''),
        failedChecks: this.preCheckResults
          .filter((c) => c.status === 'fail')
          .map((c) => c.key)
          .join(','),
      });

      return false;
    } finally {
      this.preAssessmentChecksInProgress = false;
    }
  }

  /**
   * Reads browser connection info; returns Mbps + effectiveType (if supported).
   */
  private getNetworkMetrics(): { speedMbps: number | null; effectiveType: string } {
    const conn = (navigator as any).connection || (navigator as any).mozConnection || (navigator as any).webkitConnection;
    if (!conn) {
      return { speedMbps: null, effectiveType: '' };
    }
    const speedMbps = typeof conn.downlink === 'number' ? conn.downlink : null;
    const effectiveType = conn.effectiveType || '';
    return { speedMbps, effectiveType };
  }

  /**
   * Runs pre-assessment checks immediately after loading proctoring settings.
   * Only shows the ground rules/proctoring screens if all checks pass.
   */
  async runInitialPreChecks(): Promise<void> {
    // For a connected (child) drive the candidate has already cleared the
    // System Requirements Check while starting the parent drive in this same
    // session, so don't ask again — skip straight to the ground rules screen.
    const alreadyChecked =
      sessionStorage.getItem('preAssessmentChecksDone') === 'true';
    if (
      this.connectedDriveId &&
      this.connectedDriveId == this.driveId &&
      alreadyChecked
    ) {
      this.preAssessmentChecksPassed = true;
      this.enablestepZero = true;
      this.preCheckModalOpen = false;
      return;
    }

    const preCheckPassed = await this.runPreAssessmentChecks();

    if (preCheckPassed) {
      // All checks passed, mark as completed and show ground rules screen
      this.preAssessmentChecksPassed = true;
      this.enablestepZero = true;
      // Remember success so a subsequent connected drive can skip the modal.
      sessionStorage.setItem('preAssessmentChecksDone', 'true');
    } else {
      // Checks failed, keep modal open with Cancel/Retry buttons
      this.preAssessmentChecksPassed = false;
      this.enablestepZero = false;
      // Modal stays open, user can click Cancel or Retry buttons
    }
  }

  /**
   * Retry the pre-assessment checks
   */
  async retryPreChecks(): Promise<void> {
    await this.runInitialPreChecks();
  }

  /**
   * Cancel pre-checks and go back to dashboard
   */
  cancelPreChecks(): void {
    this.preCheckModalOpen = false;
    this._router.navigate([this._commonService.Navigations.DASHBOARD_ASSESSMENT]);
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event: Event): void {
    history.pushState(null, null, location.href);
  }

  groundRulesVerificationDone(event) {
    if (event.length >= 1) {
      this.groundRulesVerification = true;
    } else if (event.length == 0) {
      this.groundRulesVerification = false;
    }
  }

  activeTabChange(activeTabAndBreadCrumbList) {
    let { activeTab, breadCrumbList } = activeTabAndBreadCrumbList;

    if (this.connectedDriveId == this.driveId && this.activeProctoringTabIndex && activeTab<=this.activeProctoringTabIndex) {
      console.log(this.activeProctoringTabIndex,'activeProctoringTabIndex');
      // this.screenRecordingEnabled  = true
      activeTab = this.activeProctoringTabIndex;
    }
    if (activeTab != undefined) {
      this.enablestepOne = true;
      this.enablestepZero = false;
    }

    if (activeTab == 0) {
      this.enablestepZero = false;
      this.enablestepOne = true;
      this.enableStepTwo = false;
      this.activeTab = activeTab;
    } else if (activeTabAndBreadCrumbList == 'start') {
       this.loading=true;
      // console.log('start');
      setTimeout(() => {
        this.proceedTest();
      }, 500);
    } else if (ValidationUtils.isObjectExists(activeTabAndBreadCrumbList)) {
      this.breadCrumbList = breadCrumbList;
      this.activeTab = activeTab;
      if (this.activeTab == this.breadCrumbList.length) {
        this.showHonorCodeOrSkip();
      }
    }

    if (activeTab == 4 && this.getAllAdminPermissions.mobileFeedCapture) {
      this.getMobileQRLink();
    }
  }

  private showHonorCodeOrSkip(): void {
    this.enablestepOne = false;
    const alreadySigned =
      sessionStorage.getItem('honorCodeSigned') === 'true';
    const isConnectedDrive =
      !!this.connectedDriveId && this.connectedDriveId == this.driveId;
    if (isConnectedDrive && alreadySigned) {
      // Interview bot drives don't use the assessment-instructions page 
      if (sessionStorage.getItem('isInterviewBotDrive') === 'true') {
        this.enableStepTwo = false;
        this.enableStepThree = false;
        this.openFullscreen();
        this._router.navigate([`main/interview-agent`]);
        return;
      }
      this.enableStepTwo = false;
      this.enableStepThree = true;
    } else {
      this.enableStepTwo = true;
    }
  }

  navToContinueSlide(event) {
    this.enablestepZero = true;
  }
  ngOnDestroy(): void {

    // (window as any).electronAPI?.setReloadBlocked(false);

    if (this.connectedDriveId == null || this.connectedDriveId == this.driveId) {
      if (this.webFeedData) {
        this.webFeedData.getTracks().forEach((obj) => obj.stop());
      }
      if (this.screenShareData) {
        this.screenShareData.getTracks().forEach((obj) => obj.stop());
      }
    }
      this.editor.destroy();
      this.mediaAccessService?.stopContinuousPermissionCheck();
      this.mediaPermissionSubscription?.unsubscribe();
      localStorage.removeItem('fileInformationList');
      sessionStorage.removeItem('enableStep5');
      sessionStorage.removeItem('isMobileConnectionLost');
      // sessionStorage.removeItem('isLiteAppDrive');
      window.onpopstate = null;
      window.removeEventListener('message', this.previewMessageHandler);
      this.onConsoleDragEnd();

      // document.removeEventListener('mousemove', this.boundOnDragging);
      // document.removeEventListener('mouseup', this.boundOnDragEnd);
      document.body.style.userSelect = '';
      document.body.style.cursor = '';
      if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
        // this.stopCodeServer();
        this.stopAllContainers();
      }
      if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
        this.stopJupyterServer();
      }

    this.destroy$.next();
    this.destroy$.complete();
  }

  cameraPlugged = true;
  audioPlugged = true;
  displayInfo: any;
  mobileSocketKey: boolean = true;
  webSocketKey: boolean = false;
  hasStartedMobileCheck: boolean;
  async checkAllAccess() {
    if (this.activeTab >= 1) {
      if (this.proctoringDto.adminPermissions.audio) {
        this.audioEnabled = await this.mediaAccessService.isAudioEnabled();
      }
      if (this.proctoringDto.adminPermissions.video) {
        this.videoEnabled = await this.mediaAccessService.isVideoEnabled();
      }
    }
    if (this.proctoringDto.adminPermissions.tabLimit) {
      this.extensionEnabled = this.mediaAccessService.checkExtensionPresence();
    }
    if (this.proctoringDto.adminPermissions.fullScreenMode) {
      this.fullScreenModeEnabled =
        this.mediaAccessService.isFullScreenEnabled();
    }

    if (!this.videoEnabled) {
      this.cameraPlugged = false;
    }

    if (!this.audioEnabled) {
      this.audioPlugged = false;
    }

    if (this.videoEnabled && !this.cameraPlugged) {
      if (this.startedExamination) {
        this.startRecording();
      }
      this.cameraPlugged = true;
    }

    if (this.audioEnabled && !this.audioPlugged) {
      if (this.startedExamination) {
        this.startRecording();
      }
      this.audioPlugged = true;
    }

    this.networkConnection =
      this.mediaAccessService.isNetworkConnectionEnabled();
    if (this.networkConnection)
      if (
        !this.isWebSocketInitialized &&
        (this.getAllAdminPermissions.mobileFeedCapture ||
          this.getAllAdminPermissions.verifySurroundings)
      ) {
        //Old Implementation
        // if (
        //   (this.getAllAdminPermissions.mobileFeedCapture ||
        //    this.getAllAdminPermissions.verifySurroundings) &&
        //   !this.hasStartedMobileCheck
        // ) {
        //   this.hasStartedMobileCheck = true;
        //   this.checkMobileConnection();
        // }
        //////////////////////////////////

        this.initializeWebSocketConnection();
      }
    if (this.activeTab == 4) {
      if (this.mobileFeedDto.isMobileSetUpDone) {
        setTimeout(() => {
          this.activeTab = 5;
        }, 1000);
        // }
      }
    }
    if (this.activeTab == 5) {
      if (this.getAllAdminPermissions.verifySurroundings) {
        if (!this.mobileFeedDto.isSurroundingsVerified) {
          return;
        }
      }
      // if (this.getAllAdminPermissions.mobileFeedCapture) {
      //   if (!this.mobileFeedDto.mobileFeedCaptured) {
      //     return;
      //   }
      // }
      this.activeTab = 5;
      if (this.activeTab == this.breadCrumbList.length) {
        this.showHonorCodeOrSkip();
      }
    }
    if (
      this.startedExamination ||
      this.breakTimeScreen ||
      (this.enableStepFive && (this.networkConnection || this.isLiteAppVersion))
    ) {
      this.displayAssessmentValidations();
    }
  }

  statusCheckTimeoutId: any = null;
  stopStatusCheck = false;
   pollIntervalBeforeExam = 5000;    // 5 sec
   pollIntervalAfterExam = 300000;   // 5 min
  async checkMobileConnection() {
    if (this.isStatusApiRequestPending || this.stopStatusCheck) {
      return;
    }
    if (this.mobileFeedDto) {
      this.isStatusApiRequestPending = true;

      try {
        this.mobileFeedDto =
          await this.mediaAccessService.getMobileFeedProctoringStatus(
            this.mobileFeedDto.mobileFeedCaptured
          );
        this.lastStatusApiResponseSuccess = true;
        this.makeStatusApiCall = true;
      } catch (error) {
        // Handle API failure
        console.error('Error fetching mobile feed proctoring status:', error);
        this.lastStatusApiResponseSuccess = false;
        this.makeStatusApiCall = false;
      } finally {
        this.isStatusApiRequestPending = false;
        this.scheduleNextStatusCheck();
      }
    }
  }

  // Schedule next status check after a delay
  // scheduleNextStatusCheck() {
  //   if (this.makeStatusApiCall) {
  //     setTimeout(() => {
  //       this.checkMobileConnection();
  //     }, 10000);
  //   }
  // }

  scheduleNextStatusCheck() {
  if (this.statusCheckTimeoutId) {
    clearTimeout(this.statusCheckTimeoutId);
  }

  // if (this.makeStatusApiCall) {
    const delay = this.startedExamination
      ? this.pollIntervalAfterExam  // 5 min after exam starts
      : this.pollIntervalBeforeExam; // 5 sec before exam starts

    this.statusCheckTimeoutId = setTimeout(() => {
        this.checkMobileConnection();
    }, delay);
  // }
    }


  openConfirmationPopup: boolean = false;
  async displayAssessmentValidations() {
    this.openConfirmationPopup = false;
    if (!this.openPopUp && !this.ristrictExitingAssessment) {
      if (!this.audioEnabled && this.getAllAdminPermissions.audio) {
        this.autoSubmitAssessment = true;
        this.breakTimeScreen = false;
        this.enablePopupAndDisplayModalText(
          this._commonService.Enums.CANCEL_AUDIO_TEXT,
          this._commonService.Enums.DISABLE_AUDIO,
          false
        );
      }
      if (!this.videoEnabled && this.getAllAdminPermissions.video) {
        this.autoSubmitAssessment = true;
        this.breakTimeScreen = false;
        this.enablePopupAndDisplayModalText(
          this._commonService.Enums.CANCEL_VIDEO_TEXT,
          this._commonService.Enums.DISABLE_VIDEO,
          false
        );
      }
      if (this.getAllAdminPermissions.fullScreenMode) {
        let userHasNetworkConnectionOrNot =
          this.mediaAccessService.isNetworkConnectionEnabled();
        // network exists
        if (userHasNetworkConnectionOrNot) {
          if (
            (!this.fullScreenModeEnabled || !document.fullscreenElement) &&
            !this.stopScreenShare
          ) {
            this.autoSubmitAssessment = true;
            this.breakTimeScreen = false;
            this.changeWindowWarning = false;
            this.enablePopupAndDisplayModalText(
              this._commonService.Enums.DISABLE_FULL_SCREEN_TEXT,
              this._commonService.Enums.DISABLE_FULL_SCREEN,
              true
            );
          }
        }
      }
      // if (
      //   !this.extensionEnabled &&
      //   this.proctoringDto.adminPermissions.tabLimit
      // ) {
      //   this.autoSubmitAssessment = true;
      //   this.breakTimeScreen = false;
      //   this.enablePopupAndDisplayModalText(
      //     this._commonService.Enums.DISABLE_EXTENSION_TEXT,
      //     this._commonService.Enums.DISABLE_EXTENSION,
      //     true
      //   );
      // }
      if (!this.networkConnection && !this.isLiteAppVersion) {
        console.log(
          this.isLiteAppVersion,
          'networkConnection',
          this.networkConnection
        );

        // this.autoSubmitAssessment = true;
        if (this.breakTimeScreen) {
          this._commonService.breakTimeContinueDisable.next('disable');
        } else {
          this._commonService.breakTimeContinueDisable.next('');
        }
        this.breakTimeScreen = false;
        this.enablePopupAndDisplayModalText(
          this._commonService.Enums.LOST_INTERNET_CONNECTION_HEADING,
          this._commonService.Enums.DISABLE_CONNECTION,
          false
        );
        sessionStorage.setItem('isNetworkConnectionLost', JSON.stringify(true));
      } else if (!this.startedExamination && this.isSectionStarted) {
        if (this.sectionBreakTime > 0) {
          this.breakTimeScreen = true;
          this._commonService.breakTimeContinueDisable.next('');
        } else {
          this.breakTimeScreen = false;
          if (this.getAllAdminPermissions.video) {
            setTimeout(() => {
              navigator.mediaDevices
                .getUserMedia({ video: true, audio: true })
                .then((stream: MediaStream) => {
                  this.userVideoElement.nativeElement.srcObject = stream;
                });
            }, 1000);
          }
          this.startedExamination = true;
        }
      } else {
        this._commonService.breakTimeContinueDisable.next('');
        this.autoSubmitAssessment = false;
        sessionStorage.removeItem('isNetworkConnectionLost');
      }
      if (
        !this.screenRecordingEnabled &&
        this.getAllAdminPermissions.screenShare
      ) {
        // this.stopScreenShare = true;
        this.modalConfirmation.heading =
          this._commonService.Enums.DISABLE_SCREEN_SHARE_TEXT_NOT_POSSIBLE;
        this.autoSubmitAssessment = true;
        this.breakTimeScreen = false;
        // this.mobileConnectionModal = false;
        this.openPopUp = true;
        this.openConfirmationPopup = false;
        this.startTimerForFifteenSeconds();
      } else {
        this.stopScreenShare = false;
      }

      //mobile feed capture error handling
      // if (
      //   this.getAllAdminPermissions.verifySurroundings ||
      //   this.getAllAdminPermissions.mobileFeedCapture
      // ) {
      //   if (
      //     !this.mobileFeedDto.isMobileNetworkAvailable &&
      //     this.shouldCheckMobileConnection
      //   ) {
      //     this.toastr.warning(
      //       'We are unable to connect to your mobile device. Please check your mobile internet connection or ensure the mobile feed is active.',
      //       ''
      //     );
      //     this.shouldCheckMobileConnection = false;

      //     setTimeout(() => {
      //       this.shouldCheckMobileConnection = true;
      //     }, 30000);
      //   }
      // }

      let isFirstCheck = true;
      const checkMobileFeed = () => {
        if (
          this.getAllAdminPermissions.mobileFeedCapture &&
          !this.isLiteAppVersion
        ) {
          if (
            !this.mobileFeedDto.mobileFeedCaptured &&
            this.isMobileFeedConnected
          ) {
            // this.toastr.warning(
            //   'Mobile feed has not started yet. Please start your mobile feed to proceed.',
            //   ''
            // );
            this.isMobileFeedConnected = false;

            setTimeout(() => {
              this.isMobileFeedConnected = true;
            }, 30000);
          }
        }
      };

      if (isFirstCheck) {
        setTimeout(() => {
          checkMobileFeed();
          isFirstCheck = false;
        }, 180000);
      } else {
        checkMobileFeed();
      }

      if (this.isDesktopApp) {
        //Restricted Background Application
        this.restrictBackgroundApps();

        const isWarning = await this.getMediaDevicesInfo();
        if (isWarning) {
          return;
        }

        //Restricted Multiple Display
        this.checkMultipleDisplays();

        // this.files = await this.electronService.getFiles();
        // console.log("Files from Electron:", this.files);
      }

      this.checkNetworkSpeedForCode();

      // if (
      //   this.getAllAdminPermissions.verifySurroundings ||
      //   this.getAllAdminPermissions.mobileFeedCapture
      // ) {
      //   if (!this.mobileFeedDto.isMobileNetworkAvailable) {
      //     this.mobileConnectionModal = true;
      //     sessionStorage.setItem(
      //       'isMobileConnectionLost',
      //       JSON.stringify(true)
      //     );

      //     // if (this.shouldCheckMobileConnection) {
      //     //   this.mobileConnectionModal = true;
      //     //   this.shouldCheckMobileConnection = false;

      //     //   setTimeout(() => {
      //     //     this.shouldCheckMobileConnection = true;
      //     //   }, 120000); // 2 minutes in milliseconds
      //     // }

      //     // this.modalConfirmation.heading =
      //     //   this._commonService.Enums.DISABLE_MOBILE_NETWORK_NOT_POSSIBLE;
      //     // this.autoSubmitAssessment = true;
      //     // this.openPopUp = true;
      //     // this.openConfirmationPopup = false;
      //     // this.startTimerForFifteenSeconds();
      //   } else {
      //     this.mobileConnectionModal = false;
      //     sessionStorage.removeItem('isMobileConnectionLost');
      //   }
      // }
    }
  }

  async restrictBackgroundApps() {
    const matchingRestrictedApps =
      await this._commonService.restrictBackgroundApps();

    const updatedMatchingAppsList = matchingRestrictedApps.map(
      (app) => app.charAt(0).toUpperCase() + app.slice(1)
    );

    const isNewAppAdded = updatedMatchingAppsList.some(
      (app) => !this.lastMatchingAppsList.includes(app)
    );

    const isAppDetected = matchingRestrictedApps.length > 0 && this.isDesktopApp;
    const shouldRestrictAppDetection =
      this._commonService.shouldRestrictOnAppDetection(this.getAllAdminPermissions);

    if (isAppDetected) {
      this.matchingApps = updatedMatchingAppsList.join(', ');

      if (!this.lastMultipleWindowWarning || isNewAppAdded) {
        this.saveCandidateMonitoring(this.matchingApps,false);
      }
      this.multipleWindowWarning = shouldRestrictAppDetection;
    } else {
      this.multipleWindowWarning = false;
      this.matchingApps = '';
    }
    this.lastMatchingAppsList = updatedMatchingAppsList;
    this.lastMultipleWindowWarning = isAppDetected;

    return this.multipleWindowWarning;
  }

  checkMultipleDisplays() {
    const displayInfo = localStorage.getItem('displayInfo');

    if (!displayInfo) {
      console.warn('No display info found in localStorage.');
      return false;
    }

    let parsedDisplayInfo;

    try {
      parsedDisplayInfo = JSON.parse(displayInfo);
    } catch (error) {
      console.error('Error parsing displayInfo from localStorage:', error);
      return false;
    }

    if (parsedDisplayInfo?.electronDisplays) {
      this.displayInfo = parsedDisplayInfo.electronDisplays;
    } else {
      this.displayInfo = parsedDisplayInfo;
    }

    if (this.displayInfo && this.displayInfo.length > 1 && this.isDesktopApp) {
      if (!this.lastMultipleDisplayWarning) {
        this.multipleDisplayWarning = true;
        this.saveCandidateMonitoring('Multiple Display',false);
      }
    } else {
      this.multipleDisplayWarning = false;
    }

    this.lastMultipleDisplayWarning = this.multipleDisplayWarning;

    return this.multipleDisplayWarning;
  }

  previousExternalDeviceWarning = false;

  async getMediaDevicesInfo() {
    const devices = await navigator?.mediaDevices?.enumerateDevices();

    const filteredDevices = devices?.filter(
      (device) =>
        device.deviceId !== 'default' &&
        !device.label.toLowerCase().includes('virtual')
    );

    const internalKeywords = [
      'integrated',
      'built-in',
      'laptop',
      'facetime',
      'realtek',
    ];

    const allDevices = {
      inbuilt: [],
      external: [],
    };

    const deviceCount: Record<string, number> = {};
    const deviceKindMap: Record<string, { kindLabel: string; devices: any[] }> =
      {
        videoinput: { kindLabel: 'Camera', devices: [] },
        audiooutput: { kindLabel: 'Speaker', devices: [] },
        audioinput: { kindLabel: 'Microphone', devices: [] },
      };

    filteredDevices?.forEach((device) => {
      const label = device.label.toLowerCase();
      let category = 'external';

      if (
        internalKeywords.some((keyword) => label.includes(keyword)) ||
        device.deviceId === 'communications'
      ) {
        category = 'inbuilt';
      }

      const deviceInfo = {
        kind: device.kind,
        label: device.label,
        deviceId: device.deviceId,
      };

      allDevices[category].push(deviceInfo);

      if (category === 'external') {
        if (device.kind in deviceKindMap) {
          deviceKindMap[device.kind].devices.push(device);
        }
      }

      if (device.kind !== 'audioinput' && category === 'external') {
        deviceCount[device.kind] = (deviceCount[device.kind] || 0) + 1;
      }
    });

    const isProjectorConnected =
      window.screen.width > 1920 || window.screen.height > 1080;

    const externalDeviceLabel: string[] = [];

    ['videoinput', 'audiooutput'].forEach((kind) => {
      const kindData = deviceKindMap[kind];
      if (kindData.devices.length > 1) {
        const extras = kindData.devices.slice(1);
        extras.forEach((device) => {
          externalDeviceLabel.push(`${kindData.kindLabel} - ${device.label}`);
        });
      }
    });

    this.externalDeviceLable = [...new Set(externalDeviceLabel)];
    const isExternalDeviceDetected = this.externalDeviceLable.length > 0;
    const shouldRestrictExternalDevice =
      this._commonService.shouldRestrictOnExternalDevice(this.getAllAdminPermissions);

    if (isExternalDeviceDetected && !this.previousExternalDeviceWarning) {
      this.multipleDeviceWarning = true;
      this.saveCandidateMonitoring(this.externalDeviceLable[0],true);
    }

    this.previousExternalDeviceWarning = isExternalDeviceDetected;
    this.externalDeviceWarning = isExternalDeviceDetected && shouldRestrictExternalDevice;

    return this.externalDeviceWarning;
  }

  saveCandidateMonitoring(monitoringName: any,isExternalHardware:boolean) {
    let payload = {
      appName: monitoringName,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
      isExternalHardware:isExternalHardware
      // date: moment(new Date()).toString()
    };

    if (this.isLiteAppVersion) {
      const currentSectionIndex = (this.offlineSectionIndex + 1).toString();
      this._examinationEventService.addMonitoringEvent(currentSectionIndex, {
        monitoringName: payload.appName,
        isExternalHardware:payload.isExternalHardware
      });
    } else {
      this._commonService
        .saveCandidateMonitoring(payload)
        .subscribe((res: any) => {
          if (res && res.statusCode === HttpStatusCode.Ok) {
          }
        });
    }
  }

  initializeScreenshotPrevention(): void {
    document.addEventListener(
      'keydown',
      (e: KeyboardEvent) => {
        if (
          this.startedExamination &&
          !['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(
            this.allQuestionsData?.questionType
          )
        ) {
          const key = e.key?.toLowerCase();
          const keyCode = e.keyCode || e.which;

          const isPrintScreen =
            key === 'printscreen' || keyCode === 44 || e.code === 'PrintScreen';

          const hasFnKey =
            e.getModifierState('Fn') || e.getModifierState('FnLock');

          const hasModifiers = e.ctrlKey || e.metaKey || e.altKey || e.shiftKey;

          const keyLower = e.key.toLowerCase();
          const hasSystemModifiers = e.ctrlKey || e.metaKey || e.altKey;

          if (
            isPrintScreen ||
            (hasFnKey && (keyCode === 44 || isPrintScreen)) ||
           (hasSystemModifiers &&
            (keyLower === 's' || ['3', '4', '5'].includes(e.key) || keyLower === 'k'))
            ) {
               e.preventDefault();
                e.stopImmediatePropagation();
                try { navigator.clipboard.writeText(''); } catch (_) {}
               this.toastr.info('', 'Screenshots are disabled during examination');
}
        }
      },
      true
    );
  }

  @HostListener('keyup', ['$event'])
  onKeyUp(event: KeyboardEvent) {
    if (this.startedExamination) {
      if (event.key === 'PrintScreen' || event.keyCode === 44) {
        navigator.clipboard.writeText('');
        this.toastr.info('', 'Screenshots disabled!');
      }
    }
  }

  focusOutTime: Date | null = null;
  focusInTime: Date | null = null;
  timeDifference: number | null = null;

  // @HostListener('window:blur', ['$event'])
  // onWindowBlur(event: any) {
  //   if (
  //     this.allQuestionsData?.questionType === 'IDE_TYPE' ||
  //     this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
  //   ) {
  //     return;
  //   }
  //   this.assessmentDriveSetId = sessionStorage.getItem('assessmentDriveSetId');
  //   let obj = {
  //     focusedOut: true,
  //     focusedIn: false,
  //     date: moment(new Date()).toString(),
  //     assessmentDriveSetId: this.assessmentDriveSetId,
  //   };
  //   if (this.startedExamination || this.breakTimeScreen) {
  //     this.focusOutTime = new Date();
  //     this._examinationService
  //       .enableOrDisableFocussedInOrOut(obj)
  //       .subscribe((res) => {});
  //   }
  // }

  // @HostListener('window:focus', ['$event'])
  // onWindowFocus(event: any) {
  //   if (
  //     this.allQuestionsData?.questionType === 'IDE_TYPE' ||
  //     this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
  //   ) {
  //     return;
  //   }
  //   this.assessmentDriveSetId = sessionStorage.getItem('assessmentDriveSetId');
  //   let obj = {
  //     focusedOut: false,
  //     focusedIn: true,
  //     date: moment(new Date()).toString(),
  //     assessmentDriveSetId: this.assessmentDriveSetId,
  //   };
  //   if (
  //     (this.startedExamination || this.breakTimeScreen) &&
  //     this.networkConnection &&
  //     this.screenRecordingEnabled &&
  //     this.getAllAdminPermissions.screenShare
  //     //  && (this.fullScreenModeEnabled || document.fullscreenElement) &&
  //     // this.getAllAdminPermissions.fullScreenMode
  //   ) {
  //     this.focusInTime = new Date();
  //     this.calculateTimeDifference();
  //     if (this.timeDifference > 2) {
  //       this.getWindowRestrictModal();
  //     }
  //     this._examinationService
  //       .enableOrDisableFocussedInOrOut(obj)
  //       .subscribe((res) => {});
  //   }
  // }

  @HostListener('window:blur', ['$event'])
  onWindowBlur(event: any) {
   if (this.showExecutionError) {
      this.showExecutionError = false;
    }

    if (
      this.allQuestionsData?.questionType === 'IDE_TYPE' ||
      this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
    ) {
      return;
    }

    this.assessmentDriveSetId = sessionStorage.getItem('assessmentDriveSetId');
    const obj = {
      focusedOut: true,
      focusedIn: false,
      date: moment(new Date()).toString(),
      assessmentDriveSetId: this.assessmentDriveSetId,
    };

    if (this.startedExamination || this.breakTimeScreen) {
      this.focusOutTime = new Date();

      if (this.isLiteAppVersion) {
        const questionId = this.allQuestionsData?.questionId;
        if (questionId) {
          this._examinationEventService.addFocusEvent(
            this.allQuestionsDataForTopBar.sequence.toString(),
            {
              focusedOut: true,
              focusedIn: false,
              date: moment(new Date()).toString(),
              questionId,
            }
          );
        }
      } else {
        this._examinationService
          .enableOrDisableFocussedInOrOut(obj)
          .subscribe((res) => {});
      }
    }
  }

  @HostListener('window:focus', ['$event'])
  onWindowFocus(event: any) {
    if (
      this.allQuestionsData?.questionType === 'IDE_TYPE' ||
      this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
    ) {
      return;
    }

    this.assessmentDriveSetId = sessionStorage.getItem('assessmentDriveSetId');
    const obj = {
      focusedOut: false,
      focusedIn: true,
      date: moment(new Date()).toString(),
      assessmentDriveSetId: this.assessmentDriveSetId,
    };

    if(this.multipleWindowWarning){
      return;
    }
    
    // remove these two from if when need to add tab switch auto submission withour proctoring
    // this.screenRecordingEnabled && this.getAllAdminPermissions.screenShare
    if(this.deployedClient == AppClient.QA_MAIN){
      if (  
        (this.startedExamination || this.breakTimeScreen) &&
        (this.networkConnection || this.isLiteAppVersion) && this.screenRecordingEnabled && this.getAllAdminPermissions.screenShare
      ) {
        this.focusInTime = new Date();
        this.calculateTimeDifference();
  
        if (this.isLiteAppVersion) {
          const questionId = this.allQuestionsData?.questionId;
          if (questionId) {
            this._examinationEventService.addFocusEvent(
              this.allQuestionsDataForTopBar.sequence.toString(),
              {
                focusedOut: false,
                focusedIn: true,
                date: moment(new Date()).toString(),
                questionId,
              }
            );
          }
  
          if (this.timeDifference > 2) {
            this.getWindowRestrictModal();
          }
        } else {
          if (this.timeDifference > 2) {
            this.getWindowRestrictModal();
          }
  
          this._examinationService
            .enableOrDisableFocussedInOrOut(obj)
            .subscribe((res) => {});
        }
      }
    }
    else{
      if (  
        (this.startedExamination || this.breakTimeScreen) &&
        (this.networkConnection || this.isLiteAppVersion) 
      ) {
        this.focusInTime = new Date();
        this.calculateTimeDifference();
  
        if (this.isLiteAppVersion) {
          const questionId = this.allQuestionsData?.questionId;
          if (questionId) {
            this._examinationEventService.addFocusEvent(
              this.allQuestionsDataForTopBar.sequence.toString(),
              {
                focusedOut: false,
                focusedIn: true,
                date: moment(new Date()).toString(),
                questionId,
              }
            );
          }
  
          if (this.timeDifference > 2) {
            this.getWindowRestrictModal();
          }
        } else {
          if (this.timeDifference > 2) {
            this.getWindowRestrictModal();
          }
  
          this._examinationService
            .enableOrDisableFocussedInOrOut(obj)
            .subscribe((res) => {});
        }
      }
    }
  }

  @HostListener('contextmenu', ['$event'])
  onContextMenu(event: MouseEvent) {
    event.preventDefault();
  }

  @HostListener('keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
      // if (event.ctrlKey && event.key === 'p') {
      //   this.toastr.info(
      //     '',
      //     'This section is not allowed to print or export to PDF'
      //   );
      //   event.cancelBubble = true;
      //   event.preventDefault();
      //   event.stopImmediatePropagation();
      // }
      const mod = event.ctrlKey || event.metaKey;
      const key = event.key.toLowerCase();
   
      if (mod && key === 's') {
        this.toastr.info('', 'Saving or downloading this page is not allowed.');
        event.cancelBubble = true;
        event.preventDefault();
        event.stopImmediatePropagation();
        return;
      }
   
      if (mod && key === 'p') {
        this.toastr.info(
          '',
          'This section is not allowed to print or export to PDF'
        );
        event.cancelBubble = true;
        event.preventDefault();
        event.stopImmediatePropagation();
      }
    
  }

  @HostListener('copy', ['$event'])
  onCopy(event: ClipboardEvent) {
    if (
      this.startedExamination &&
      this.proctoringDto.adminPermissions.disableCopy
    ) {
      event.preventDefault();
      this.toastr.info('', 'Copying content is not allowed.');
    }
  }

  @HostListener('document:paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    if (
      this.startedExamination &&
      this.proctoringDto.adminPermissions.disablePaste
    ) {
      event.preventDefault();
    }
  }

  async proceedTest() {
     Sentry.logger.info("Exam Started", {
      driveId: String(this.driveData),
    });

    // if (
    //   !this.extensionEnabled &&
    //   this.proctoringDto.adminPermissions.tabLimit
    // ) {
    //   this.toastr.show(
    //     'Please enable the extension and refresh the page',
    //     'Info'
    //   );
    //   this.permissionsSucceed = false;
    //   return;
    // }

    // if (window.electron) {
    //   window.electron.ipcRenderer.send('toggle-kiosk', true);
    // }

    if (!this.audioEnabled && this.getAllAdminPermissions.audio) {
      this.toastr.show('Please enable microphone', 'Info');
      this.permissionsSucceed = false;
      return;
    }
    if (!this.videoEnabled && this.getAllAdminPermissions.video) {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        stream.getTracks().forEach((track) => track.stop());

        // User granted access to the microphone.
        // You can use the stream object to do something with the audio stream if needed.
      } catch (error: any) {
        let text: string;
        if (error.name == 'NotFoundError') {
          text = 'Web Cam is not connected to the device.';
          this.toastr.error(text, 'Info');
          return;
        }
      }
    }
    if (!this.videoEnabled && this.getAllAdminPermissions.video) {
      this.toastr.show('Please enable web cam', 'Info');
      this.permissionsSucceed = false;
      return;
    }

    if (
      !this.screenRecordingEnabled &&
      this.getAllAdminPermissions.screenShare
    ) {
      this.toastr.show('Please enable the screen share', 'Info');
      this.permissionsSucceed = false;
      return;
    }
    // if (this.getAllAdminPermissions.verifySurroundings) {
    //   if (!this.mobileFeedDto.isSurroundingsVerified) {
    //     this.toastr.show(
    //       'Please record the 360 degree surroundings view from mobile ',
    //       'Info'
    //     );
    //     this.permissionsSucceed = false;
    //     return;
    //   }
    // }

    // if (this.getAllAdminPermissions.mobileFeedCapture) {
    //   if (!this.mobileFeedDto.mobileFeedCaptured) {
    //     this.toastr.show(
    //       'Please allow the mobile feed view from mobile ',
    //       'Info'
    //     );
    //     this.permissionsSucceed = false;
    //     return;
    //   }
    // }

    await this.openFullscreen();
    setTimeout(() => {
      if (
        (!this.fullScreenModeEnabled || !document.fullscreenElement) &&
        this.getAllAdminPermissions.fullScreenMode
      ) {
        this.toastr.show('Please enable the full screen', 'Info');
        this.permissionsSucceed = false;
        return;
      }
      this.permissionsSucceed = true;
      this.enablestepZero = false;
      this.enablestepOne = false;
      this.enableStepTwo = false;
      this.enableStepThree = false;
      this.enableStepFour = false;
      this.enableStepFive = true;
      sessionStorage.setItem(
        'enableStep5',
        JSON.stringify(this.enableStepFive)
      );
      this.proctoringDto.adminPermissions.audio = this.audioEnabled;
      this.proctoringDto.adminPermissions.video = this.videoEnabled;
      this.proctoringDto.adminPermissions.aadharPhotoCapture =
        this.pictureCaptureEnabled;
      this.proctoringDto.adminPermissions.screenShare =
        this.screenRecordingEnabled;
      this.proctoringDto.adminPermissions.fullScreenMode =
        this.fullScreenModeEnabled;
      this.proctoringDto.adminPermissions.isExtensionInstalled = false;
      this.proctoringDto.adminPermissions.id =
        sessionStorage.getItem('driveId');
      if (this.permissionsSucceed) {
        this.getSectionProgressiveOrNonProgrossiveForStartAssessment();
      }
      const displayInfoRaw = localStorage.getItem('displayInfo');

      this.displayInfo =
        displayInfoRaw && displayInfoRaw !== 'undefined'
          ? JSON.parse(displayInfoRaw)
          : [];

      // console.log(JSON.parse(displayInfo), 'displayInfo');
      // this.displayInfo = JSON.parse(displayInfo);
    }, 200);
  }

  sectionSequence: any;
  isProgressiveSection: boolean;
  isQuestionBankSection: boolean;
  // getSectionProgressiveOrNonProgrossiveForStartAssessment() {
  //   this._examinationService
  //     .getSectionProgressiveOrNonProgrossive(this.driveData)
  //     .subscribe((response) => {
  //       if (response.statusCode === HttpStatusCode.Ok) {
  //         this.sectionSequence = response.data.sectionSequence;
  //         this.isProgressiveSection = response.data.isProgressiveSection;
  //         this.isQuestionBankSection = response.data.isQuestionBankSection;
  //         this.startRecording();
  //         if (!this.isLiteAppVersion) {
  //           if (this.isProgressiveSection) {
  //             this.getSubCategoriesDataForSections();
  //             this.getSectionProgressiveQuestions();
  //           } else if (this.isQuestionBankSection) {
  //             this.getQuestionBankData();
  //           } else {
  //             this.getUserAssessmentData();
  //           }
  //         } else {
  //           this.getOfflineUserAssessmentData();
  //         }

  //         setTimeout(() => {
  //           if (
  //             this.allQuestionsData?.questionType === 'CODING_TYPE' ||
  //             this.allQuestionsData?.questionType === 'SQL_CODING' ||
  //             this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
  //           ) {
  //             this.getCodingLanguages();
  //             this.getCodingLanguageSelected();
  //           }

  //           if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
  //             setTimeout(() => {
  //               this.toggleLanguageSelection(this.jupyterNotebookObject);
  //             }, 1000);
  //           }

  //           if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
  //             this.createCodeServer();
  //             this.toggleIDE();
  //           }
  //         }, this.timeoutDuration);
  //       }
  //     });
  // }

  getSectionProgressiveOrNonProgrossiveForStartAssessment() {
    this.loading = true;
    // this.technicalErrorModal = false;

    // if (!this.networkConnection) {
    //   this.loading = false;
    //   this.technicalErrorModal = true;
    //   return;
    // }

    // let retryCount = 0;
    // let apiSucceeded = false;

    // const fallbackTimeout = setTimeout(() => {
    //   if (this.loading && !apiSucceeded) {
    //     this.loading = false;
    //     this.technicalErrorModal = !this.networkConnection;
    //   }
    // }, 30000);

    this._examinationService
      .getSectionProgressiveOrNonProgrossive(this.driveData)
      // .pipe(
      //   timeout(5000),
      //   retryWhen((errors) =>
      //     errors.pipe(
      //       delay(3000),
      //       take(4),
      //       tap(() => retryCount++),
      //       finalize(() => {
      //         clearTimeout(fallbackTimeout);
      //         if (retryCount >= 4 && !apiSucceeded) {
      //           this.loading = false;
      //           this.technicalErrorModal = !this.networkConnection;
      //         }
      //       })
      //     )
      //   )
      // )
      .subscribe({
        next: (response) => {
          // apiSucceeded = true;
          // clearTimeout(fallbackTimeout);
          this.loading = false;
          this.technicalErrorModal = false;

          if (response.statusCode === HttpStatusCode.Ok) {
            this.sectionSequence = response.data.sectionSequence;
            this.isProgressiveSection = response.data.isProgressiveSection;
            this.isQuestionBankSection = response.data.isQuestionBankSection;
            this.startRecording();
            if (!this.isLiteAppVersion) {
              if (this.isProgressiveSection) {
                this.getSubCategoriesDataForSections();
                this.getSectionProgressiveQuestions();
              } else if (this.isQuestionBankSection) {
                this.getQuestionBankData();
              } else if(!this.isProgressiveSection){
                this.getUserAssessmentData();
              }
            } 
            // else {
            //   this.getOfflineUserAssessmentData();
            // }

            // setTimeout(() => {
            //   console.log(this.allQuestionsData, 'allQuestionsData');

            //   const type = this.allQuestionsData?.questionType;
            //   if (
            //     ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)
            //   ) {
            //     this.getCodingLanguages();
            //     this.getCodingLanguageSelected();
            //   }

            //   if (type === 'JUPYTER_NOTEBOOK') {
            //     setTimeout(() => {
            //       this.createJupyterServer();
            //       // this.toggleLanguageSelection(this.jupyterNotebookObject);
            //     }, 1000);
            //   }

            //   if (type === 'IDE_TYPE') {
            //     this.createCodeServer();
            //     this.toggleIDE();
            //   }
            // }, this.timeoutDuration);
          }
        },
        error: () => {
          // this.loading = false;
          this.toastr.error('Something went wrong, please try again later');
          setTimeout(() => {
            this._router
              .navigate([this._commonService.Navigations.DASHBOARD_ASSESSMENT])
              .then(() => {
                this.exitFullScreen();
                //  localStorage.removeItem('websocketSessionId')
              });
          }, 3000);
          // this.technicalErrorModal = !this.networkConnection;
        },
      });
  }

  // getDriveStatus() {
  //   this._examinationService
  //     .getDriveStatus(this.driveData)
  //     .subscribe((response) => {
  //       if (response.statusCode === HttpStatusCode.Ok) {
  //         this.isLiteAppVersion = response.data?.isOffline;
  //         sessionStorage.setItem(
  //           'isLiteAppVersion', JSON.stringify(this.isLiteAppVersion)
  //         );
  //         this.getSectionProgressiveOrNonProgrossiveForStartAssessment();
  //       }
  //     });
  // }

  SubCategoryDetails: SubCategoryDetailsDto = new SubCategoryDetailsDto();
  subCategoriesData: any;
  getSubCategoriesDataForSections() {
    this.SubCategoryDetails.driveConfigId = this.driveData;
    this.SubCategoryDetails.sectionSequence = this.sectionSequence;
    this._examinationService
      .getSubCategoriesDataForSection(this.SubCategoryDetails)
      .subscribe((response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this.subCategoriesData = response.data.sectionsData;
        }
      });
  }

  isSectionStarted: boolean;
  loading: boolean = false;
  progressiveResponseData: ProgressiveResponseDto =
    new ProgressiveResponseDto();
  isLastQuestions: boolean;
  getSectionProgressiveQuestions() {
    this.loading = true;

    this.apiPriorityService.setHighPriorityRequestInProgress(true);

    this.progressiveResponseData.driveId = this.driveData;
    this.progressiveResponseData.sequence = this.sectionSequence;
    this.progressiveResponseData.sectionStatus = '';
    if(this.progressiveResponseData?.subCategories?.length > 0){
      // Appening languageType  based on  languageId
       this.progressiveResponseData?.subCategories.forEach(subCat => {
         subCat.sectionQuestionDtos?.forEach(question => {
           question.languageType =this.getLanguageName(question.languageId);
         });
       });
    }
    this._examinationService
      .getSectionProgressiveQuestions(this.progressiveResponseData)
      .subscribe({
        next:(response:any) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            this.breakTimeScreen = false;
            this.enablestepOne = false;
            this.enableStepThree = false;
            this.enableStepFour = false;
            this.enableStepFive = true;
            this.startedExamination = true;
            this.sectionBreakTime = 0;
            this.startTimer(this.sectionBreakTime);
            this.breakTimeScreen = false;
            this.allQuestionsDataForTopBar = response.data.sectionDto;
            this.userAssessmentDriveSetId = response.data.userAssessmentSetId;
            if (window.electron) {
              window.electron.ipcRenderer.send(
                'create-directory',
                this.userAssessmentDriveSetId
              );
            }
            this.isLastQuestions = response.data.isLastQuestions;
            this.isLastSection = response.data.isLastSection;
            this.isNextSectionProgressive =
              response.data.isNextSectionProgressive;
            this.isNextSectionQuestionBank =
              response.data.isNextSectionQuestionBank;
            this.isCurrentSectionProgressive =
              response?.data?.isCurrentSectionProgressive;
            this.isCurrentSectionQuestionBank =
              response?.data?.isCurrentSectionQuestionBank;
            this.sectionTimer = response.data.sectionDto.sectionTimeInMins;
            let token = response.data.foreignDriveToken;
            sessionStorage.setItem('token', token);

            if (this.appTopBar != null) {
              this.appTopBar.startTimerManually(
                this.sectionTimer,
                this.allQuestionsDataForTopBar
              );
            }
            this.loading = false;
            this.apiPriorityService.setHighPriorityRequestInProgress(false);
            this.isSectionStarted = true;
            setTimeout(() => {
              for (let i = 0; i < this.totalProgressiveQuestions; i++) {
                this.allQuestions.push(new questionDto());
              }
            }, 1000);

            this.getSubcategory();
          }
        },
        error:(error) => {
          this.loading = false;
      if (error.statusCode >= 500) {
        this.toastr.error('Something went wrong');
      } 
      else {
        this.toastr.error(error?.error?.message );
      }
          this.apiPriorityService.setHighPriorityRequestInProgress(false);
        }
  });
  }

  isShuffleSections: boolean = false;
  isNextSectionProgressive: boolean;
  isNextSectionQuestionBank: boolean;
  getUserAssessmentData() {
    this.loading = true;
    this.subSectionDto.sectionStatus = '';
    this._examinationService
      .pollNonProgressiveSection(this.driveData)
      .subscribe(
        async (response) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            this.breakTimeScreen = false;
            this.enablestepOne = false;
            this.enableStepThree = false;
            this.enableStepFour = false;
            this.enableStepFive = true;
            this.startedExamination = true;
            this.sectionBreakTime = 0;
            this.startTimer(this.sectionBreakTime);
            this.breakTimeScreen = false;
            this.allQuestionsDataForTopBar = response.data.sectionDto;
            this.userAssessmentDriveSetId = response.data.userAssessmentSetId;
            if (window.electron) {
              window.electron.ipcRenderer.send(
                'create-directory',
                this.userAssessmentDriveSetId
              );
            }
            this.isLastSection = response.data.isLastSection;
            this.sectionTimer = response?.data?.sectionDto?.sectionTimeInMins;
            this.isNextSectionProgressive =
              response.data.isNextSectionProgressive;
            this.isNextSectionQuestionBank =
              response.data.isNextSectionQuestionBank;
            this.isCurrentSectionProgressive =
              response?.data?.isCurrentSectionProgressive;
            this.isCurrentSectionQuestionBank =
              response?.data?.isCurrentSectionQuestionBank;
            if (this.appTopBar != null) {
              this.appTopBar.startTimerManually(
                this.sectionTimer,
                this.allQuestionsDataForTopBar
              );
            }
            this.isShuffleSections = response?.data?.isShuffleSections;

            if (this.isShuffleSections) {
              this.allQuestions = [
                ...this.allQuestionsDataForTopBar.questionDtos,
              ];
            } else {
              this.allQuestionsDataForTopBar.subCategories.forEach(
                (subCategory) => {
                  subCategory.questionDtos.forEach((question) => {
                    this.allQuestions.push(question);
                  });
                }
              );
            }
            console.log(this.allQuestions, 'all questions non progressive');
            this.totalQuestionsCount=this.allQuestions.length;
            this.makeAllContainersActive();

            this.getSubcategory();
            this.loading = false;
            this.isSectionStarted = true;
          }
        },
        (error) => {
          this.loading = false;
          console.error('API error:', error);
        }
      );
  }

  allIDEQuestionsIds: any;
  allJupyterQuestionsIds: any;
  statusApiCallTime = 10000;
  activatedIDEIds: Set<number> = new Set();
  activatedJupyterIds: Set<number> = new Set();

  makeAllContainersActive() {
    this.statusApiCallTime = 10000
    this.allIDEQuestionsIds = this.allQuestions
      .filter((q) => q.questionType === 'IDE_TYPE')
      .map((q) => q.questionId);

    this.allJupyterQuestionsIds = this.allQuestions
      .filter((q) => q.questionType === 'JUPYTER_NOTEBOOK')
      .map((q) => q.questionId);

    const currentIDEIds = this.allQuestions
      .filter((q) => q.questionType === 'IDE_TYPE')
      .map((q) => q.questionId);

    const currentJupyterIds = this.allQuestions
      .filter((q) => q.questionType === 'JUPYTER_NOTEBOOK')
      .map((q) => q.questionId);

    // Filter only NEW (non-activated) IDs
    const newIDEIds = currentIDEIds.filter(
      (id: any) => !this.activatedIDEIds.has(id)
    );
    const newJupyterIds = currentJupyterIds.filter(
      (id: any) => !this.activatedJupyterIds.has(id)
    );

    console.log(this.allIDEQuestionsIds, 'questionIds to activate');
    this.IDELoader = true;

    const requestPayload = {
      question_ids: newIDEIds,
      jupyter_question_ids: newJupyterIds,
      candidate_id: this.loginUser.id,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
    };
    if (
      this.allIDEQuestionsIds.length !== 0 ||
      this.allJupyterQuestionsIds.length !== 0
    ) {
      this._examinationService.createCodeServerDrive(requestPayload).subscribe({
        next: (response: any) => {
          console.log(response, 'createCodeServerDrive response');

          if (response.statusCode === HttpStatusCode.Ok) {
            if (this.isBlackObject(response?.data?.error)) {
              console.log('✅ All containers activated successfully');
              newIDEIds.forEach((id: any) => this.activatedIDEIds.add(id));
              newJupyterIds.forEach((id: any) =>
                this.activatedJupyterIds.add(id)
              );
            } else {
              this.retryFailedContainers(response.data.error);
            }
          }
        },
        error: (err) => {
          console.error('❌ Error creating containers:', err);
          if (err?.error) {
            this.retryFailedContainers(err.error);
          }
        },
      });
    }
  }

  retryFailedContainers(errorObj: any, retryCount: number = 0) {
    const failedIds = Object.keys(errorObj);

    console.warn('⚠ Retrying failed container IDs:', failedIds);

    if (!failedIds.length) {
      console.log('No failed containers to retry.');
      return;
    }

    if (retryCount >= 5) {
      // logger.error — a coding section with no container means the candidate
      // cannot attempt it at all.
      Sentry.logger.error('Container creation failed after max retries', {
        driveId: String(this.driveData),
        retries: retryCount,
        failedIdCount: Array.isArray(failedIds) ? failedIds.length : 0,
        failedIds: JSON.stringify(failedIds).slice(0, 500),
      });
      return;
    }

    const retryPayload = {
      question_ids: failedIds,
      candidate_id: this.loginUser.id,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
    };

    this._examinationService.createCodeServerDrive(retryPayload).subscribe({
      next: (retryResponse: any) => {
        if (retryResponse.statusCode === HttpStatusCode.Ok) {
          if (this.isBlackObject(retryResponse?.data.error)) {
            console.log('✅ Retried containers activated successfully');
          } else {
            console.warn('⚠ Some containers still failed. Retrying...');
            setTimeout(() => {
              this.retryFailedContainers(
                retryResponse.data.error,
                retryCount + 1
              );
            }, 2000);
          }
        } else {
          console.error('⚠ Retry failed with response:', retryResponse);
        }
      },
      error: (retryErr) => {
        setTimeout(() => {
          this.retryFailedContainers(errorObj, retryCount + 1);
        }, 2000); // Retry after a delay
      },
    });
  }

  isBlackObject(errorObj: any): boolean {
    return errorObj && Object.keys(errorObj).length === 0;
  }

  allSectionsData: any[] = [];
  offlineSectionIndex: number = 0;
  apiCalled: boolean = false;
  isCodingLaguageForLiteVersion: boolean = false;
  codingLanguagesLoaded: boolean = false;
  // async getOfflineUserAssessmentData() {
  //   this.loading = true;
  //   this.subSectionDto.sectionStatus = '';

  //   if (!this.apiCalled) {
  //     this.apiCalled = true;

  //     try {
  //       let allSectionsData = [];

  //       if (this.isLiteAppVersion) {
  //         if (this.isOfflineNonProgressiveSections) {
  //           const nonProgressiveResponse = await this._examinationService
  //             .getOfflineNonProgressiveSection(this.driveData)
  //             .toPromise();

  //           if (nonProgressiveResponse?.statusCode === HttpStatusCode.Ok) {
  //             allSectionsData = [...nonProgressiveResponse.data];
  //           }
  //           else if (nonProgressiveResponse?.statusCode >= 500) {
  //             this.toastr.error('Something went wrong');
  //           } 
  //           else {
  //             this.toastr.error(nonProgressiveResponse?.error?.message);
  //           }                     
            
  //         }

  //         if (this.isOfflineQuestionBankSections) {
  //           const questionBankResponse = await this._examinationService
  //             .getOfflineQuestionBankSection(this.driveData)
  //             .toPromise();

  //           if (questionBankResponse?.statusCode === HttpStatusCode.Ok) {
  //             allSectionsData = [
  //               ...allSectionsData,
  //               ...questionBankResponse.data,
  //             ];
  //           }
  //         }
  //       }

  //       // Sort all sections by sequence number
  //       this.allSectionsData = allSectionsData.sort(
  //         (a, b) =>
  //           (a.sectionDto?.sequence || 0) - (b.sectionDto?.sequence || 0)
  //       );

  //       // Process SQL coding questions if we have any sections
  //       if (this.allSectionsData.length > 0) {
  //         const allQuestionIds = this.allSectionsData.flatMap((section) => {
  //           const subCategories = section.sectionDto.subCategories || [];
  //           return subCategories.flatMap((subCategory: any) => {
  //             return subCategory.questionDtos
  //               .filter(
  //                 (question: any) => question.questionType === 'SQL_CODING'
  //               )
  //               .map((question: any) => question.questionId);
  //           });
  //         });

  //         if (allQuestionIds.length > 0) {
  //           this.initializeAllQuestions(allQuestionIds);
  //         }

  //         // Load coding languages for lite version if needed
  //         if (
  //           this.isLiteAppVersion &&
  //           !this.codingLanguagesLoaded &&
  //           !this.isFetchingCodingLanguages
  //         ) {
  //           this.isFetchingCodingLanguages = true;
  //           await new Promise<void>((resolve) => {
  //             this._examinationService.getCodingLanguages().subscribe(
  //               (langResponse) => {
  //                 this.isFetchingCodingLanguages = false;
  //                 if (
  //                   langResponse &&
  //                   langResponse.statusCode === HttpStatusCode.Ok
  //                 ) {
  //                   this.allCodingLanguages = langResponse.data;
  //                   this.codingLanguages = this.allCodingLanguages;

  //                   this.codingLanguagesLoaded = true;
  //                   this.isCodingLaguageForLiteVersion = true;
  //                   resolve();
  //                 } else {
  //                   resolve();
  //                 }
  //               },
  //               (error) => {
  //                 this.isFetchingCodingLanguages = false;
  //                 console.error('Error loading coding languages:', error);
  //                 resolve();
  //               }
  //             );
  //           });
  //         }
  //       }

  //       // Process section data if we have any sections
  //       if (!this.allSectionsData || this.allSectionsData.length === 0) {
  //         this.loading = false;
  //         return;
  //       }
  //       await this.processSectionData();
  //     } catch (error) {
  //       console.error('API error:', error);
  //     } finally {
  //       this.loading = false;
  //     }
  //   } else {
  //     try {
  //       if (!this.allSectionsData || this.allSectionsData.length === 0) {
  //         this.loading = false;
  //         return;
  //       }
  //       await this.processSectionData();
  //     } finally {
  //       this.loading = false;
  //     }
  //   }
  // }

  async processSectionData(): Promise<void> {
    console.log('Processing section data:', {
      allSectionsData: this.allSectionsData,
      offlineSectionIndex: this.offlineSectionIndex,
      totalSections: this.allSectionsData?.length,
    });

    // Validate section data
    if (!this.allSectionsData || this.allSectionsData.length === 0) {
      console.error('No sections data available');
      return;
    }

    if (this.offlineSectionIndex >= this.allSectionsData.length) {
      console.error('Section index out of bounds');
      return;
    }

    const currentSectionData = this.allSectionsData[this.offlineSectionIndex];
    console.log('Current section data:', {
      sectionData: currentSectionData,
      sequence: currentSectionData?.sectionDto?.sequence,
      type: currentSectionData?.isCurrentSectionQuestionBank
        ? 'QuestionBank'
        : 'NonProgressive',
    });

    this.allQuestionsDataForTopBar = currentSectionData.sectionDto;
    this.userAssessmentDriveSetId = currentSectionData.userAssessmentSetId;

    if (this.isOfflineExamStarted) {
      console.log('Starting lite exam for offline section');
      this.liteExamStart();
    }

    if (window.electron) {
      window.electron.ipcRenderer.send(
        'create-directory',
        this.userAssessmentDriveSetId
      );
    }

    // Check if this is the last section - validate array bounds first
    const hasNextSection =
      this.offlineSectionIndex < this.allSectionsData?.length - 1;
    this.isLastSection = !hasNextSection;
    this.sectionTimer = currentSectionData?.sectionDto?.sectionTimeInMins;

    // Determine current and next section types
    const nextSection = hasNextSection
      ? this.allSectionsData[this.offlineSectionIndex + 1]
      : null;

    // Set next section flags only if there is a next section
    this.isNextSectionProgressive = hasNextSection
      ? nextSection?.isCurrentSectionProgressive || false
      : false;
    this.isNextSectionQuestionBank = hasNextSection
      ? nextSection?.isCurrentSectionQuestionBank || false
      : false;
    this.isCurrentSectionProgressive =
      currentSectionData?.isCurrentSectionProgressive;
    this.isCurrentSectionQuestionBank =
      currentSectionData?.isCurrentSectionQuestionBank;
    this.sectionSequence = currentSectionData?.nextSectionSequence;
    this.sectionBreakTime = currentSectionData?.breakTimeInSeconds;
    const nextSectionData = this.allSectionsData[this.offlineSectionIndex + 1];
    this.totalQuestionForNextSection =
      nextSectionData?.data?.totalQuestionsCount;
    this.nextSectionName = nextSectionData?.sectionDto?.name;
    this.totalTimeForSection = nextSectionData?.sectionDto?.sectionTimeInMins;

    if (this.appTopBar != null) {
      this.appTopBar.startTimerManually(
        this.sectionTimer,
        this.allQuestionsDataForTopBar
      );
    }

    this.isShuffleSections = currentSectionData?.isShuffleSections;

    if (this.isShuffleSections) {
      this.allQuestions = [...this.allQuestionsDataForTopBar.questionDtos];
    } else {
      this.allQuestions = [];
      this.allQuestionsDataForTopBar.subCategories.forEach((subCategory) => {
        subCategory.questionDtos.forEach((question) => {
          this.allQuestions.push(question);
        });
      });
    }
    this.getSubcategory();
    this.isSectionStarted = true;
  }

  isCurrentSectionQuestionBank: boolean;
  getQuestionBankData() {
    this._examinationService
      .getQuestionBankSectionQuestions(this.driveData)
      .subscribe(
        (response) => {
          if (response && response.statusCode === HttpStatusCode.Ok) {
            this.breakTimeScreen = false;
            this.enablestepOne = false;
            this.enableStepThree = false;
            this.enableStepFour = false;
            this.enableStepFive = true;
            this.startedExamination = true;
            this.sectionBreakTime = 0;
            this.startTimer(this.sectionBreakTime);
            this.breakTimeScreen = false;
            this.allQuestionsDataForTopBar = response.data.sectionDto;
            this.userAssessmentDriveSetId = response.data.userAssessmentSetId;
            this.isLastSection = response.data.isLastSection;
            this.sectionTimer = response?.data?.sectionDto?.sectionTimeInMins;
            this.isNextSectionProgressive =
              response.data.isNextSectionProgressive;
            this.isNextSectionQuestionBank =
              response.data.isNextSectionQuestionBank;
            this.isCurrentSectionProgressive =
              response?.data?.isCurrentSectionProgressive;
            this.isCurrentSectionQuestionBank =
              response?.data?.isCurrentSectionQuestionBank;
            if (this.appTopBar != null) {
              this.appTopBar.startTimerManually(
                this.sectionTimer,
                this.allQuestionsDataForTopBar
              );
            }
            this.allQuestionsDataForTopBar.subCategories.forEach(
              (subCategory) => {
                subCategory.questionDtos.forEach((question) => {
                  // const dto = new questionDto();
                  // dto.questionId = question.questionId;
                  this.allQuestions.push(question);
                });
              }
            );

            this.getSubcategory();
            this.loading = false;
            this.isSectionStarted = true;
          }
        },
        (error) => {
          this.loading = false;
          console.error('API error:', error);
        }
      );
  }

  subCategoriesId?: string;
  questionStartTime: Date;
  questionEndTime: Date;
  questionTimeSpentInSeconds: number;
  async getSubcategory() {
    this.sectionQuestionDto = {};
    this.totalQuestionDtos = [];

    if (this.isShuffleSections) {
      const shuffledQuestions = this.allQuestionsDataForTopBar.questionDtos;
      this.totalQuestionDtos = [...shuffledQuestions];
    } else {
      this.allQuestionsDataForTopBar?.subCategories.forEach(
        (subCategory: any) => {
          if (subCategory?.questionDtos?.length) {
            this.totalQuestionDtos.push(...subCategory.questionDtos);
          }
        }
      );
    }

    this.allQuestionsDataForTopBar?.subCategories.forEach(
      (subCategory: any) => {
        this.subCategoriesId = subCategory.id;

        subCategory.questionDtos.forEach((question) => {
          this.questionStartTime = new Date();

          let questionDtos;
          if (this.isCurrentSectionProgressive) {
            let ind = this.currentQuestionIndex;
            ind =
              this.currentQuestionIndex % 2 === 0 ||
              this.totalQuestionDtos.length === 1
                ? 0
                : 1;
            questionDtos = this.totalQuestionDtos[ind];
          } else {
            // console.log(this.totalQuestionDtos,"this.totalQuestionDtos");

            questionDtos = this.totalQuestionDtos[this.currentQuestionIndex];
          }

          this.allQuestionsData = questionDtos;
          // this.allQuestionsData = {
          //   "id": "69818b3ff0c02dab3629a631",
          //   "questionId": "111111759239779648_1",
          //   "sectionQuestionId": "6992a4ba34f45e3159fbb1az",
          //   "questionContentDto": {
          //     "Text": "BIGQUERY_CODING questions text",
          //     "Image": [],
          //     "Table": [],
          //     "DropDown": null,
          //     "OrderOfElement": [
          //       "Text"
          //     ],
          //     "Schema": null,
          //     "ImageBase64": []
          //   },
          //   "options": [],
          //   "questionType": "BIGQUERY_CODING",
          //   "sequence": 1,
          //   "actualDifficultyLevel": 4,
          //   "difficultyLevel": "MEDIUM"
          // };
          console.log(this.allQuestionsData, 'allQuestionsData in getSubcategory');
          const type = this.allQuestionsData?.questionType;
          if (
            ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)
          ) {
            console.log(
              type,
              'Inside the timeout this.allQuestionsData?.questionType',
              this.allQuestionsData?.questionType
            );

            this.getCodingLanguages();
            this.getCodingLanguageSelected();
          }
          if (
            this.allQuestionsData?.questionType == 'VIDEO' ||
            this.allQuestionsData?.questionType == 'AUDIO' ||
            this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
          ) {
            this.compareAndLogObject(this.currentQuestionIndex);
          }
          if (
            this.allQuestionsData?.questionType === 'AUDIO' &&
            this.allQuestionsData?.recordedAudioTime
          ) {
            this.recordedAudioTime = this.allQuestionsData.recordedAudioTime;
          }

          if (
            this.allQuestionsData?.questionType == 'VIDEO' ||
            this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
          ) {
            this.recorderOne = true;
            navigator.mediaDevices
              .getUserMedia({ video: true, audio: false })
              .then((stream) => {
                setTimeout(() => {
                  this.displayVideoSetup.nativeElement.srcObject = stream;
                }, 1000);
              });
          }

          if (this.allQuestionsData?.questionType === 'AUDIO') {
            this.recorderOne = true;
            navigator.mediaDevices
              .getUserMedia({ audio: true })
              .then((stream) => {
                setTimeout(() => {
                  this.displayAudioSetup.nativeElement.srcObject = stream;
                }, 1000);
              });
          }

          setTimeout(() => {
            // console.log(this.allQuestionsData, 'allQuestionsData');

            // const type = this.allQuestionsData?.questionType;
            // if (
            //   ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)
            // ) {
            //   this.getCodingLanguages();
            //   this.getCodingLanguageSelected();
            // }

            if (type === 'JUPYTER_NOTEBOOK') {
              // setTimeout(() => {
                this.createJupyterServer();
                setTimeout(() => {
                  this.loading = false;
                }, 2000);
                this.toggleLanguageSelection(this.jupyterNotebookObject);
              // }, 1000);
            }

            if (type === 'IDE_TYPE') {
              this.createCodeServer();
              this.toggleIDE();
            }
          }, this.timeoutDuration);
        });
      }
    );
    this.loadQuestion(this.allQuestionsDataForTopBar);
    this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar);
  }

  loadQuestion(sectionData: any) {
    this.currentSectionName = sectionData?.name;
    this.subSectionDetails = [];
    if (!sectionData) {
      console.error('Section data is missing.');
      return;
    }
    sectionData?.subCategories.forEach((subcategory) => {
      this.subSectionDetails.push(subcategory);
    });
  }

  getCurrentSubcategories() {
    let currentIndex = 0;
    if (this.isCurrentSectionProgressive) {
      for (const data of this.subCategoriesData) {
        if (
          this.currentProgressiveIndex <
          currentIndex + parseInt(data.value, 10)
        ) {
          const truncatedName =
            data.key.length > 25 ? data.key.substring(0, 25) + '...' : data.key;
          return truncatedName;
        }
        currentIndex += parseInt(data.value, 10);
      }
    } else {
      for (const category of this.subSectionDetails) {
        if (
          this.currentQuestionIndex <
          currentIndex + category.questionDtos?.length
        ) {
          const truncatedName =
            category.name?.length > 25
              ? category.name.substring(0, 25) + '...'
              : category.name;
          return category?.name;
        }
        currentIndex += category.questionDtos?.length;
      }
    }
    return 'No subcategory found';
  }

  moveToNextQuestion(data) {
    this.clearPendingLoaderTimers();
    if (!this.allQuestionsData.questionType) {
      this.allQuestionsData.questionType = this.originalQuestionType;
    }
    if (
      (this.allQuestionsData?.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
      this.isRecording
    ) {
      this.toastr.info(
        'Please record and Submit the video to proceed',
        'Error'
      );
      return;
    }

    if (this.allQuestionsData?.questionType == 'AUDIO' && this.isRecording) {
      this.toastr.info(
        'Please record and Submit the audio to proceed',
        'Error'
      );
      return;
    }

    // Capture any typed coding/SQL response before currentQuestionIndex is
    // incremented below. Skipped on "Attempt later" since that path is meant
    // to leave the question unsaved/unattempted.
    if (data !== 'attemptLater') {
      this.saveCodingResponseOnSwitch();
    }

    if (data == 'attemptLater') {
      let openedQuestion = this.getQuestionObject(this.currentQuestionIndex);

      if (!this.getQuestionObject(this.currentQuestionIndex).skipped) {
        if(this.attemptedQuestionsCount > 0 && this.getQuestionObject(this.currentQuestionIndex).attempted){
          this.attemptedQuestionsCount--;
        }
        this.getQuestionObject(this.currentQuestionIndex).skipped = true;
        this.getQuestionObject(this.currentQuestionIndex).attempted = false;
      }

      this.subSectionDto.sectionQuestionList =
        this.subSectionDto.sectionQuestionList.filter(
          (q: any) => q.questionId !== openedQuestion.questionId
        );
    }
    this.scrollToTop();
    let noOfQuestionsToShow = 10; // Set the desired count of questions to show
    let noOfQuestions = this.totalQuestionsCount;

    if (
      this.allQuestionsData?.questionType == 'VIDEO' ||
      this.allQuestionsData?.questionType == 'AUDIO' ||
      this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
    ) {
      this.compareAndLogObject(this.currentQuestionIndex);
    }
    this.commonQuestionTime = true;
    // if (!this.isCurrentSectionProgressive) {
    //   this.nonProgressiveQuestionsList();
    //   this.optionsForQuestion = [];
    // }
    if (this.currentQuestionIndex >= noOfQuestionsToShow) {
      // Adjust the total number of questions to show
      this.numButtonsToShow = noOfQuestionsToShow;
    }
    this.currentQuestionIndex++;
    if (this.currentQuestionIndex < noOfQuestions) {
      // if (data != 'attemptLater') {
      this.goToPage(this.currentQuestionIndex, data);
      // }
    } else {
      // this.goToPage(this.currentQuestionIndex, data);
      this.getSubcategory();
    }
    this.showLoaderForCurrentQuestion();
    this.goBackFromIDE();
    this.resetBooleanResponse();
    this.checkAndResetInput();
    this.resetCodingQuestion();
    this.checkAndResetTextAnswer();
    this.commonQuestionTime = false;
    this.minimizeQuestionSection = true;
    this.maximizeQuestionSection = false;
    this.bottomPanelExpanded = false;
    this.restoreCompiledCodeState();
    setTimeout(() => {
      const type = this.allQuestionsData?.questionType;
      if (['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)) {
        this.getCodingLanguages();
        this.getCodingLanguageSelected();
      }
      // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      //   this.stopJupyterServer();
      //   setTimeout(() => {
      //     this.toggleLanguageSelection(this.jupyterNotebookObject);
      //   }, 1000);
      // }
      // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      //   this.stopCodeServer();
      // }
    }, this.timeoutDuration);
  }

  commonQuestionTime: boolean;
  moveToprevQuestion() {
    this.clearPendingLoaderTimers();
    if (
      (this.allQuestionsData?.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
      this.isRecording
    ) {
      this.toastr.info(
        'Please record and Submit the video to proceed',
        'Error'
      );
      return;
    }

    if (this.allQuestionsData?.questionType == 'AUDIO' && this.isRecording) {
      this.toastr.info(
        'Please record and Submit the audio to proceed',
        'Error'
      );
      return;
    }

    // Capture any typed coding/SQL response before currentQuestionIndex is
    // decremented below.
    this.saveCodingResponseOnSwitch();

    this.scrollToTop();
    let noOfQuestions = this.totalQuestionsCount;
    if (
      this.allQuestionsData?.questionType == 'VIDEO' ||
      this.allQuestionsData?.questionType == 'AUDIO' ||
      this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
    ) {
      this.compareAndLogObject(this.currentQuestionIndex);
    }
    this.commonQuestionTime = true;
    // if (!this.isCurrentSectionProgressive) {
    //   this.nonProgressiveQuestionsList();
    //   this.optionsForQuestion = [];
    // }
    this.currentQuestionIndex--;
    if (this.currentQuestionIndex <= noOfQuestions) {
      this.goToPage(this.currentQuestionIndex);
    } else {
      this.getSubcategory();
    }
    this.showLoaderForCurrentQuestion();
    this.goBackFromIDE();
    this.resetBooleanResponse();
    this.checkAndResetInput();
    this.resetCodingQuestion();
    this.checkAndResetTextAnswer();
    this.commonQuestionTime = false;
    this.minimizeQuestionSection = true;
    this.maximizeQuestionSection = false;
    // this.bottomPanelExpanded = false;
    this.restoreCompiledCodeState();
    setTimeout(() => {
      const type = this.allQuestionsData?.questionType;
      if (['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)) {
        this.getCodingLanguages();
        this.getCodingLanguageSelected();
      }
      // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      //   this.stopJupyterServer();
      //   setTimeout(() => {
      //     this.toggleLanguageSelection(this.jupyterNotebookObject);
      //   }, 1000);
      // }
      // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      //   this.stopCodeServer();
      // }
      // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      //   this.stopJupyterServer();
      // }
    }, this.timeoutDuration);
  }

  restoreCompiledCodeState(): void {
    const idx = this.currentQuestionIndex;
    if (!this.compiledCodeMap) {
      this.compiledCodeMap = {};
    }
    if (idx != null && this.compiledCodeMap[idx] !== undefined) {
      this.compiledCode = this.compiledCodeMap[idx];
      this.visibleCorrectCases = this.visibleCorrectCasesMap[idx] || 0;
      this.visibleTestCaseCount = this.visibleTestCaseCountMap[idx] || 0;
      this.totalCorrectCases = this.totalCorrectCasesMap[idx] || 0;
    } else {
      this.compiledCode = null;
      this.visibleCorrectCases = 0;
      this.visibleTestCaseCount = 0;
      this.totalCorrectCases = 0;
    }
  }

  getTotalQuestionsInSection(sectionData) {
    return sectionData?.subCategories.reduce((total, subcategory) => {
      return total + subcategory.questionDtos.length;
    }, 0);
  }

  savePermissionForTest() {
    this._examinationService
      .saveAdminPermissionsForTest(this.proctoringDto)
      .subscribe((response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this.enablestepOne = false;
          this.enableStepThree = false;
          this.enableStepFour = false;
          this.enableStepFive = true;
          this.startRecording();
        }
      });
  }
  enbleStep2(data: { webcamImage: WebcamImage; image: FileDocumentDto }) {
    this.aadharPhotoCaptured = true;
    this.imageData = data.webcamImage;
    this.pictureCaptureEnabled = data && data != null ? true : false;
    this.proctoringDto.imageData = new FileDocumentDto();
    this.proctoringDto.imageData = data.image;
  }

  getOptionSelectedOrNot(
    option?: optionDto,
    questionIndex?: number,
    videoId?: string
  ) {
    let optionExists: boolean;
    if (option) {
      optionExists = this.allQuestions[
        questionIndex
      ]?.selectedAnswers?.includes(option?.id);
    } else if (videoId) {
      optionExists =
        this.allQuestions[questionIndex]?.selectedAnswers?.includes(videoId);
    }
    return optionExists;
  }

  attemptLater(currentPage: number) {
    this.scrollToTop();
    if (!this.getQuestionObject(currentPage).skipped) {
      this.getQuestionObject(currentPage).skipped = true;
      this.getQuestionObject(currentPage).attempted = false;

      this.currentPage++;
    }
  }

  submitSection: SubmitSectionResponseDto = new SubmitSectionResponseDto();
  finalSectionDataForProgressive:ProgressivePayloadDtoForDumpApi = new ProgressivePayloadDtoForDumpApi();
  subSectionDto: SubmitSectionDto = new SubmitSectionDto();
  sectionQuestionDto: SectionQuestionDto = new SectionQuestionDto();
  currentProgressiveIndex: number = 0;
  attemptedQuestionsList: any;
  vedioAnsId: string;
  TimeSpentInSeconds: number;
  previousIndex: number;
  verifySurroundingModal: boolean;

  // Persists the in-progress CODING_TYPE / SQL_CODING response into
  // subSectionDto.sectionQuestionList without running the full saveAndProceed
  // navigation flow (no currentQuestionIndex mutation, no recursive goToPage,
  // no submitTest). Used when the candidate switches questions via Next/Prev
  // arrow or the question-palette so typed code is captured automatically.
  saveCodingResponseOnSwitch(): void {
    if (this.isCurrentSectionProgressive) return;
    const type = this.allQuestionsData?.questionType;
    if (type !== 'CODING_TYPE' && type !== 'SQL_CODING') return;

    const currentQuestion = this.getQuestionObject(this.currentQuestionIndex);
    if (!currentQuestion) return;

    const selected:any = currentQuestion.selectedAnswers;
    const hasTypedContent =
      typeof selected === 'string'
        ? selected.length > 0
        : Array.isArray(selected)
        ? selected.length > 0
        : false;

    if (!hasTypedContent) {
      if (!currentQuestion.attempted && !currentQuestion.skipped) {
        currentQuestion.visited = true;
      }
      return;
    }

    if (!currentQuestion.attempted) {
      currentQuestion.attempted = true;
      currentQuestion.skipped = false;
      this.attemptedQuestionsCount++;
    }

    this.nonProgressiveQuestionsList();
    this.attemptedQuestionsList = this.subSectionDto.sectionQuestionList;
  }

  // method used in save & proceed
  saveAndProceed(currentPage) {
    this.resetBooleanResponse();
    this.maximizeQuestionSection = false;
    this.IDECompiledTestCase = null;
    this.clearPendingLoaderTimers();
    this.bottomPanelExpanded = false;
    const currentQuestion = this.getQuestionObject(this.currentQuestionIndex);

    const isLastQuestion = this.isCurrentSectionProgressive
      ? this.currentProgressiveIndex === this.totalProgressiveQuestions - 1
      : this.currentQuestionIndex ===
        this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar) - 1;

    // Skip validation on last question
    if (!isLastQuestion) {
      if (
        (this.allQuestionsData?.questionType === 'MCQ' ||
          this.allQuestionsData?.questionType === 'BOOLEAN_TYPE' ||
          this.allQuestionsData?.questionType === 'MULTIPLE_IMAGE') &&
        (!currentQuestion?.selectedAnswers ||
          currentQuestion.selectedAnswers.length === 0)
      ) {
        this.toastr.error('Please select an option to proceed', 'Error');
        return;
      }

      if (
        (this.allQuestionsData?.questionType === 'TEXT_TYPE' ||
          this.allQuestionsData?.questionType === 'FIB' || this.allQuestionsData?.questionType === 'CASE_STUDY' || this.allQuestionsData?.questionType === 'BIGQUERY_CODING') &&
        (!currentQuestion?.selectedAnswers ||
          currentQuestion.selectedAnswers.length === 0 ||
          currentQuestion.selectedAnswers.includes(''))
      ) {
        this.toastr.error('Please enter the response to proceed', 'Error');
        return;
      }
    }

    if (
      (this.isCurrentSectionProgressive &&
        (this.allQuestionsData?.questionType == 'VIDEO' ||
          this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION')) ||
      (!this.isCurrentSectionProgressive &&
        (this.allQuestionsData?.questionType == 'VIDEO' ||
          this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
        this.isRecording)
    ) {
      if (!this.recordedVideoAns) {
        this.toastr.error(
          'Please record and Submit the video to proceed',
          'Error'
        );
        return;
      }
    }

    if (
      (this.isCurrentSectionProgressive &&
        this.allQuestionsData?.questionType == 'AUDIO') ||
      (!this.isCurrentSectionProgressive &&
        this.allQuestionsData?.questionType == 'AUDIO' &&
        this.isRecording)
    ) {
      if (!this.recordedAudioAns) {
        this.toastr.error(
          'Please record and Submit the audio to proceed',
          'Error'
        );
        return;
      }
    }

    if (
      (this.allQuestionsData?.questionType === 'MCQ' ||
        this.allQuestionsData?.questionType === 'BOOLEAN_TYPE' ||
        this.allQuestionsData?.questionType === 'MULTIPLE_IMAGE') &&
      this.isCurrentSectionProgressive &&
      currentQuestion?.selectedAnswers?.length == 0 &&
      (this.allQuestionsData?.questionType !== 'VIDEO' ||
        this.allQuestionsData?.questionType !== 'AUDIO' ||
        this.allQuestionsData?.questionType !== 'TECHNICAL_QUESTION')
    ) {
      this.toastr.error('Please select an option to proceed', 'Error');
      return;
    }

    if (
      (this.allQuestionsData?.questionType === 'TEXT_TYPE' ||
        this.allQuestionsData?.questionType === 'FIB' || this.allQuestionsData?.questionType === 'CASE_STUDY' || this.allQuestionsData?.questionType === 'BIGQUERY_CODING') &&
      this.isCurrentSectionProgressive &&
      (!currentQuestion?.selectedAnswers ||
        currentQuestion.selectedAnswers.length === 0) &&
      (this.allQuestionsData?.questionType !== 'VIDEO' ||
        this.allQuestionsData?.questionType !== 'AUDIO' ||
        this.allQuestionsData?.questionType !== 'TECHNICAL_QUESTION')
    ) {
      this.toastr.error('Please enter the response to proceed', 'Error');
      return;
    }

    if (
      (this.allQuestionsData?.questionType === 'CODING_TYPE' ||
        this.allQuestionsData?.questionType === 'SQL_CODING' ||
        this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') &&
      this.isCurrentSectionProgressive &&
      this.code == ''
    ) {
      this.toastr.error('Please enter the response to proceed', 'Error');
      return;
    }

    if (
      this.allQuestionsData?.questionType == 'VIDEO' ||
      this.allQuestionsData?.questionType == 'AUDIO' ||
      this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
    ) {
      this.compareAndLogObject(currentPage + 1);
    }
    if (
      this.allQuestionsData?.questionType !== 'CODING_TYPE' &&
      this.allQuestionsData?.questionType !== 'SQL_CODING' &&
      this.allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK'
    ) {
      this.scrollToTop();
    }

    if (this.isExecutingCode) {
      this.toastr.info('Processing your request, please wait...', 'Info');
      return;
    }
    this.sectionQuestionDto.responseFileId = this.vedioAnsId;
    this.sectionQuestionDto.responseFileId = this.audioAnsId;

    const totalQuestionsInSection = this.getTotalQuestionsInSection(
      this.allQuestionsDataForTopBar
    );

    if (this.isCurrentSectionProgressive) {
      if (currentQuestion?.selectedAnswers.length === 0) {
        currentQuestion.visited = true;
      } else if (!currentQuestion?.attempted) {
        currentQuestion.attempted = true;
        currentQuestion.skipped = false;
        this.attemptedQuestionsCount++;
      }

      if (this.recordedVideoAns || this.recordedAudioAns) {
        currentQuestion.attempted = true;
        currentQuestion.skipped = false;
        this.attemptedQuestionsCount++;
      }

      // if(this.currentQuestionIndex == 4) {
      //   this.verifySurroundingModal = true;
      //   this.getMobileQRLink();
      //   sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
      // }

      let ind = this.currentQuestionIndex;

      if (
        this.currentQuestionIndex % 2 == 0 ||
        this.totalQuestionDtos.length == 1
      ) {
        // For even indices or if there's only one question
        if (this.currentQuestionIndex % 2 == 0 && this.previousIndex == 0) {
          ind = 1; // Switch to 1 if the previous index was 0
        } else {
          ind = 0; // Otherwise, stay at 0
        }
      } else {
        // For odd indices
        if (
          this.currentQuestionIndex % 2 !== 0 &&
          this.previousIndex == 1 &&
          !this.isProgressiveLastQuestion
        ) {
          ind = 0; // Switch to 0 if previous index was 1 and it's not the last progressive question
        } else {
          ind = 1; // Otherwise, set to 1
        }
      }

      if (this.isSubCategoryLastQuestion) {
        ind = 0;
        this.isSubCategoryLastQuestion = false;
      }

      this.previousIndex = ind;

      if (ind < totalQuestionsInSection - 1) {
        this.progressiveQuestionsList();
        this.recordedVideoAns = false;
        this.recordedAudioAns = false;
        if (
          this.sectionQuestionDto.selectedOptionsIds?.length > 0 &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }

        if (
          this.sectionQuestionDto.responseFileId &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        this.subSectionDto.sequence = this?.allQuestionsDataForTopBar?.sequence;
        this.currentQuestionIndex++;
        this.currentProgressiveIndex++;
        if (
          this.currentQuestionIndex >=
          this.displayedPageRange[this.numButtonsToShow - 1]
        ) {
          this.getNextRangeForProgressive(this.currentProgressiveIndex);
        }
        this.getSubcategory();
        this.showLoaderForCurrentQuestion();
        this.optionsForQuestion = [];
        this.resetBooleanResponse();
        this.checkAndResetInput();
        this.resetCodingQuestion();
        this.goBackFromIDE();
        this.checkAndResetTextAnswer();
        this.vedioAnsId = '';
        this.audioAnsId = '';
        // Restore persisted compiled/test-case for the new question after advancing
        const restoredIdx = this.currentQuestionIndex;
        if (!this.compiledCodeMap) {
          this.compiledCodeMap = {};
        }
        if (restoredIdx != null && this.compiledCodeMap[restoredIdx] !== undefined) {
          this.compiledCode = this.compiledCodeMap[restoredIdx];
          this.visibleCorrectCases = this.visibleCorrectCasesMap[restoredIdx] || 0;
          this.visibleTestCaseCount = this.visibleTestCaseCountMap[restoredIdx] || 0;
          this.totalCorrectCases = this.totalCorrectCasesMap[restoredIdx] || 0;
        } else {
          this.compiledCode = this.compiledCode || this.compiledCode;
        }
        setTimeout(() => {
          const type = this.allQuestionsData?.questionType;
          if (
            ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)
          ) {
            this.getCodingLanguages();
            this.getCodingLanguageSelected();
          }
          if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
            clearInterval(this.retryInterval);
            this.stopAllJupyterContainers();
            // setTimeout(() => {
            //   this.toggleLanguageSelection(this.jupyterNotebookObject);
            // }, 1000);
          }
          if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
            clearInterval(this.retryInterval);
            // this.stopCodeServer();
            this.stopAllContainers();
          }
        }, this.timeoutDuration);
      } else {
        this.progressiveQuestionsList();
        this.recordedVideoAns = false;
        this.recordedAudioAns = false;
        if (
          this.sectionQuestionDto.selectedOptionsIds?.length > 0 &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        if (
          this.sectionQuestionDto.responseFileId &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        this.subSectionDto.sequence = this.allQuestionsDataForTopBar.sequence;

        this.recorderOne = true;
        this.isSectionSubmittedManually = true;
        this.submitTestForprogressiveAssessment();
      }
    } else {
      // if(this.currentQuestionIndex == 4) {
      //   this.verifySurroundingModal = true;
      // if(this.currentQuestionIndex == 4) {
      //   this.verifySurroundingModal = true;
      //   this.getMobileQRLink();
      //   sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
      // }
      if (
        currentQuestion.selectedAnswers?.length === 0 ||
        currentQuestion.selectedAnswers === undefined
      ) {
        currentQuestion.visited = true;
      } else if (!currentQuestion.attempted && !this.recordedAudioAns && !this.recordedVideoAns) {
        currentQuestion.attempted = true;
        currentQuestion.skipped = false;
        this.attemptedQuestionsCount++;
      }

      if (
        (currentQuestion.questionType === 'JUPYTER_NOTEBOOK' ||
          currentQuestion.questionType === 'IDE_TYPE') &&
        !currentQuestion.attempted
      ) {
        currentQuestion.attempted = true;
        currentQuestion.skipped = false;
        this.attemptedQuestionsCount++;
      }

      if (this.recordedVideoAns || this.recordedAudioAns) {
        currentQuestion.attempted = true;
        currentQuestion.skipped = false;
        this.attemptedQuestionsCount++;
      }

      if (this.currentQuestionIndex < totalQuestionsInSection - 1) {
        // console.log('Non-progressive section - not last question');

        this.nonProgressiveQuestionsList();
        this.recordedVideoAns = false;
        this.recordedAudioAns = false;
        // this.recorderOne = true;
        if (
          this.sectionQuestionDto.selectedOptionsIds?.length > 0 &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        if (
          this.sectionQuestionDto.responseFileId &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.sectionQuestionDto.timeTakenInSeconds = this.TimeSpentInSeconds;
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        this.subSectionDto.sequence = this.allQuestionsDataForTopBar.sequence;
        this.currentQuestionIndex++;
        // Ensure currentQuestionIndex stays within the visible range
        if (
          this.currentQuestionIndex >=
          this.displayedPageRange[this.numButtonsToShow - 1]
        ) {
          this.goToPage(this.currentQuestionIndex);
        } else {
          this.getSubcategory();
        }
        this.showLoaderForCurrentQuestion();
        this.optionsForQuestion = [];
        this.resetBooleanResponse();
        this.checkAndResetInput();
        this.resetCodingQuestion();
        this.goBackFromIDE();
        this.checkAndResetTextAnswer();
        // Restore persisted compiled/test-case for the new question after advancing
        const restoredIdx = this.currentQuestionIndex;
        if (!this.compiledCodeMap) {
          this.compiledCodeMap = {};
        }
        if (restoredIdx != null && this.compiledCodeMap[restoredIdx] !== undefined) {
          this.compiledCode = this.compiledCodeMap[restoredIdx];
          this.visibleCorrectCases = this.visibleCorrectCasesMap[restoredIdx] || 0;
          this.visibleTestCaseCount = this.visibleTestCaseCountMap[restoredIdx] || 0;
          this.totalCorrectCases = this.totalCorrectCasesMap[restoredIdx] || 0;
        } else {
          this.compiledCode = this.compiledCode || this.compiledCode;
        }

        setTimeout(() => {
          const type = this.allQuestionsData?.questionType;
          if (
            ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)
          ) {
            this.getCodingLanguages();
            this.getCodingLanguageSelected();
          }
          // createJupyterServer/createCodeServer are triggered by getSubcategory's
          // own setTimeout; calling them here caused duplicate container requests.
          // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
          //   this.createJupyterServer();
          // }
          // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
          //   this.createCodeServer();
          // }
        }, this.timeoutDuration);
      } else {
        // this.currentQuestionIndex++;
        this.nonProgressiveQuestionsList();
        this.recordedVideoAns = false;
        this.recordedAudioAns = false;
        if (
          this.sectionQuestionDto.selectedOptionsIds?.length > 0 &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }

        if (
          this.sectionQuestionDto.responseFileId &&
          this.sectionQuestionDto.mquestionId != null
        ) {
          this.subSectionDto.sectionQuestionList.push(this.sectionQuestionDto);
        }
        this.subSectionDto.sequence = this.allQuestionsDataForTopBar.sequence;
        this.optionsForQuestion = [];
        this.resetBooleanResponse();
        this.checkAndResetInput();
        this.resetCodingQuestion();
        this.goBackFromIDE();
        this.checkAndResetTextAnswer();
        this.recorderOne = true;
        this.isSectionSubmittedManually = true;
        this.submitTest();
      }
    }
    this.attemptedQuestionsList = this.subSectionDto.sectionQuestionList;
  }

  progressiveQuestionsList() {
    this.questionEndTime = new Date();
    this.questionTimeSpentInSeconds =
      (this.questionEndTime.getTime() - this.questionStartTime.getTime()) /
      1000;
    this.TimeSpentInSeconds = Math.floor(this.questionTimeSpentInSeconds);
    const matchingQuestionsIndexInProgressive =
      this.subCategoryResponseDto.sectionQuestionDtos.findIndex(
        (obj) => obj.mquestionId === this.allQuestionsData.id
      );

    let FibAnswerobj = {};
    if ((this.allQuestionsData?.questionType == 'FIB' || this.allQuestionsData?.questionType == 'CASE_STUDY' || this.allQuestionsData?.questionType === 'BIGQUERY_CODING') && this.fibAnswer) {
      this.fibAnswer?.forEach((value, index) => {
        FibAnswerobj[index] = value;
      });
    }
    let fibAnswerString = Object.values(FibAnswerobj).join(', ');

    let multipleFibAnsobj = {};
    this.multipleFibAns.forEach((value, index) => {
      multipleFibAnsobj[index] = value;
    });

    if (
      this.isCurrentSectionProgressive ||
      this.isProgressiveSection ||
      this.isNextSectionProgressive
    ) {
      const payload = this.buildProgressiveQuestionPayload(fibAnswerString, multipleFibAnsobj);
      if (matchingQuestionsIndexInProgressive !== -1) {
        this.subCategoryResponseDto.sectionQuestionDtos[matchingQuestionsIndexInProgressive] = payload;
      } else {
        this.subCategoryResponseDto.sectionQuestionDtos.push(payload);
      }
      // fibResponse = [];
      this.booleanResponse = null;
      this.textInput = '';
      fibAnswerString = '';
    }
  }

  private buildProgressiveQuestionPayload(fibAnswerString: string, multipleFibAnsobj: object): object {
    const type = this.allQuestionsData?.questionType;
    const isFibType = type === 'FIB' || type === 'CASE_STUDY' || type === 'BIGQUERY_CODING';
    return {
      mquestionId: this.allQuestionsData.id,
      mQuestionId: this.allQuestionsData.id,
      selectedOptionsIds: !this.optionsForQuestion || isFibType
        ? []
        : Array.isArray(this.optionsForQuestion)
        ? this.optionsForQuestion.flat(Infinity).filter(Boolean).map(String)
        : [String(this.optionsForQuestion)],
      responseFileId:
        type === 'VIDEO' || type === 'TECHNICAL_QUESTION'
          ? this.vedioAnsId
          : type === 'AUDIO'
          ? this.audioAnsId
          : '',
      sectionQuestionId: this.allQuestionsData.sectionQuestionId,
      sequence: this.allQuestionsData?.sequence,
      questionId: this.allQuestionsData.questionId,
      timeTakenInSeconds: this.TimeSpentInSeconds,
      singleWordAnswer: type === 'TEXT_TYPE' ? this.textInput : '',
      fibAnswer: isFibType ? fibAnswerString : '',
      multipleFibAns: multipleFibAnsobj,
      booleanTypeResponse: this.booleanResponse,
      sourceCode: this.code,
      languageName: this.selectedLanguage,
      languageType: this.getLanguageName(this.selectedLanguageId),
      languageId: this.selectedLanguageId,
      candidateTestCaseDtos: this.testCasesList,
      backendTestcases: this.backendTestCase,
      frontendTestcases: this.frontEndTestCase,
      newAudioQuestion:
        this.allQuestionsDataForTopBar?.isDifferentAudioQuestionForCandidate ||
        this.allQuestionsDataForTopBar?.isTechnicalQuestionNeeded
          ? this.allQuestionsData?.questionContentDto?.Text
          : '',
    };
  }

  matchingQuestionIndex: any;
  optionsForQuestionIList: boolean;
  nonProgressiveQuestionsList() {
    const currentQuestion = this.getQuestionObject(this.currentQuestionIndex);
    const type = currentQuestion?.questionType;
    const isMediaOrTech =
      type === 'AUDIO' ||
      type === 'VIDEO' ||
      type === 'TECHNICAL_QUESTION';
  
    if (isMediaOrTech) {
      
      if (!currentQuestion?.selectedAnswers || currentQuestion.selectedAnswers.length === 0) {
        return;
      }
    } else {
      // if (!currentQuestion?.attempted) {
      //   return;
      // }
      const isIdeOrJupyter =
        type === 'IDE_TYPE' || type === 'JUPYTER_NOTEBOOK';
      if (
        !currentQuestion?.attempted &&
        !(isIdeOrJupyter && currentQuestion?.opened)
      ) {
        return;
      }
    }
    const matchingQuestionIndex =
      this.subSectionDto.sectionQuestionList.findIndex(
        (obj) => obj.mquestionId === this.allQuestionsData.id
      );
    this.matchingQuestionIndex = matchingQuestionIndex;
    
    this.optionsForQuestion = currentQuestion.selectedAnswers?.[0];
    const isExistingWithOptions =
      matchingQuestionIndex !== -1 &&
      this.subSectionDto.sectionQuestionList[matchingQuestionIndex]?.selectedOptionsIds.length != 0;
    if (!isExistingWithOptions) {
      this.optionsForQuestionIList = true;
    }

    this.questionEndTime = new Date();
    this.questionTimeSpentInSeconds =
      (this.questionEndTime.getTime() - this.questionStartTime.getTime()) /
      1000;
    this.TimeSpentInSeconds = Math.ceil(this.questionTimeSpentInSeconds);
    if (matchingQuestionIndex !== -1) {
      const timeSpentOnPreviousQuestion =
        this.subSectionDto.sectionQuestionList[matchingQuestionIndex]
          .timeTakenInSeconds;
      this.TimeSpentInSeconds += Math.ceil(timeSpentOnPreviousQuestion);
    }

    let fibAnswerString: any;
    if (this.allQuestionsData?.questionType == 'FIB' || this.allQuestionsData?.questionType == 'CASE_STUDY' || this.allQuestionsData?.questionType == 'BIGQUERY_CODING') {
      let FibAnswerobj = {};
      this.fibAnswer?.forEach((value, index) => {
        FibAnswerobj[index] = value;
      });
      fibAnswerString = FibAnswerobj
        ? Object.values(FibAnswerobj).join(', ')
        : '';
    }

    let multipleFibAnsobj = {};
    this.multipleFibAns.forEach((value, index) => {
      multipleFibAnsobj[index] = value;
    });

    const payload = this.buildNonProgressiveQuestionPayload(fibAnswerString, multipleFibAnsobj);
    if (matchingQuestionIndex !== -1) {
      this.subSectionDto.sectionQuestionList[matchingQuestionIndex] = payload;
    } else {
      this.subSectionDto.sectionQuestionList.push(payload);
    }

    console.log(
      'subSectionDto.sectionQuestionList',
      this.subSectionDto.sectionQuestionList
    );

    // this.fibValue = '';
    this.optionsForQuestionIList = false;
    this.booleanResponse = null;
    this.textInput = '';
    fibAnswerString = '';
  }

  private buildNonProgressiveQuestionPayload(fibAnswerString: any, multipleFibAnsobj: object): object {
    const type = this.allQuestionsData?.questionType;
    const isFibType = type === 'FIB' || type === 'CASE_STUDY' || type === 'BIGQUERY_CODING';
    return {
      mquestionId: this.allQuestionsData.id,
      mQuestionId: this.allQuestionsData.id,
      selectedOptionsIds:
        !this.optionsForQuestion ||
        isFibType ||
        (typeof this.optionsForQuestion === 'object' &&
          !Array.isArray(this.optionsForQuestion) &&
          Object.keys(this.optionsForQuestion).length === 0)
          ? []
          : this.optionsForQuestionIList
          ? [String(this.optionsForQuestion)]
          : Array.isArray(this.optionsForQuestion)
          ? this.optionsForQuestion.flat(Infinity).filter(Boolean).map(String)
          : [String(this.optionsForQuestion)],
      responseFileId:
        type === 'VIDEO' || type === 'TECHNICAL_QUESTION'
          ? this.vedioAnsId
          : type === 'AUDIO'
          ? this.audioAnsId
          : '',
      sequence: this.allQuestionsData?.sequence,
      sectionQuestionId: this.allQuestionsData.sectionQuestionId,
      questionId: this.allQuestionsData.questionId,
      timeTakenInSeconds: this.TimeSpentInSeconds,
      singleWordAnswer: type === 'TEXT_TYPE' ? this.textInput : '',
      fibAnswer: isFibType ? fibAnswerString : '',
      multipleFibAns: multipleFibAnsobj,
      booleanTypeResponse: this.booleanResponse !== null ? this.booleanResponse : null,
      sourceCode: this.code,
      languageName: this.selectedLanguage,
      languageType: this.getLanguageName(this.selectedLanguageId),
      languageId: this.selectedLanguageId,
      candidateTestCaseDtos: this.testCasesList,
      backendTestcases: this.backendTestCase,
      frontendTestcases: this.frontEndTestCase,
      newAudioQuestion:
        this.allQuestionsDataForTopBar?.isDifferentAudioQuestionForCandidate ||
        this.allQuestionsDataForTopBar?.isTechnicalQuestionNeeded
          ? this.allQuestionsData?.questionContentDto?.Text
          : '',
    };
  }

  resetAllQuestionsState() {
    this.allQuestions = [];
  }

  resetCurrentPage() {
    this.currentPage = 0;
  }

  moveToNextOfflineSection() {
    if (!this.allSectionsData) {
      return;
    }

    this.resetAllQuestionsState();
    this.resetCurrentPage();
    this.startedExamination = false;

    if (this.isLiteAppVersion) {
      this.sectionBreakTime =
        this.allSectionsData[this.offlineSectionIndex]?.breakTimeInSeconds;
      console.log(this.sectionBreakTime, 'sectionBreakTime');

      if (this.sectionBreakTime > 0) {
        this.breakTimeScreen = true;
        this.ristrictExitingAssessment = false;
        this.startTimer(this.sectionBreakTime);
      }
      return;
    }
    this.sectionTimer = 0;
  }

  continueToNextOfflineSection() {
    if (
      !this.allSectionsData ||
      this.offlineSectionIndex >= this.allSectionsData.length - 1
    ) {
      return;
    }

    this.offlineSectionIndex++;
    this.breakTimeScreen = false;
    this.startedExamination = true;

    this.openConfirmationPopup = false;
    this.isRefreshpopup = false;
    this.ristrictExitingAssessment = false;
    this.breakTimeScreen = false;
    // this.sectionBreakTime = 0;
    this.startNextSection();
  }

  /**Method call on submit the test */
  submitLastSectionResponse: any;
  sectionBreakTime: number;
  nextSectionName: string;
  totalQuestionForNextSection: number;
  totalTimeForSection: number;
  isSubmitApiCalled: boolean;
  private liteSectionResponses: any[] = [];
  private allSectionsSubmitPayload: any = {
    userAssessmentDriveSetId: '',
    location: '',
    ipAddress: '',
    sectionDtos: [],
  };
  isSectionSubmittedManually: boolean = false;
  selectedQuestionForExplanation: any;
  showUnattemptedModal = false;
  // unattemptedCount = 0;
  submitUnattemptedNonProgressiveTest: boolean;
  submitTest() {
    this.saveCodingResponseOnSwitch();
    // Drop opened-but-unsaved IDE/Jupyter questions when:
    // 1. the candidate chose "Submit saved only" in the review popup, OR
    // 2. proctoring violation auto-submit (no review shown — only explicitly
    //    saved questions are sent).
    if (!this.includeOpenedQuestionsOnSubmit || this.autoSubmitAssessment) {
      this.dropOpenedUnsavedFromPayload();
    }
    this.includeOpenedQuestionsOnSubmit = true;
    this.showIdeSubmitSummary = false;
    this.ideSummaryForceSubmit = false;

    const totalQuestions = this.getTotalQuestionsInSection(
      this.allQuestionsDataForTopBar
    );
    const attempted = this.attemptedQuestionsCount;
    const unattempted = totalQuestions - attempted;

    const excludedTypes = [
      'IDE_TYPE',
      'JUPYTER_NOTEBOOK'
    ];
    if (
      unattempted > 0 &&
      !this.submitUnattemptedNonProgressiveTest &&
      !excludedTypes.includes(this.allQuestionsData?.questionType) &&
      !this.autoSubmitAssessment &&
      !this.autoSubmitExam &&
      !this.endSection
    ) {
      // this.unattemptedCount = unattempted;
      this.showUnattemptedModal = true;
      console.warn(`You have ${unattempted} unattempted question(s).`);
      return;
    }

    // if (this.isLiteAppVersion) {
    //   const currentSectionData = {
    //     sequence: this.allQuestionsDataForTopBar.sequence,
    //     sectionStatus: this.autoSubmitAssessment
    //       ? 'PROCTORING_DISCONNECTED'
    //       : this.autoSubmitExam
    //       ? 'SECTION_AUTO_SUBMIT'
    //       : this.endSection
    //       ? 'END_SECTION'
    //       : 'SUBMITTED',
    //     sectionQuestionList: [...this.subSectionDto.sectionQuestionList],
    //   };

    //   this.liteSectionResponses[this.offlineSectionIndex] = currentSectionData;
    //   console.log(this.liteSectionResponses, 'this.liteSectionResponses');

    //   if (!this.isLastSection) {
    //     this.moveToNextOfflineSection();
    //     return;
    //   } else {
    //     this.submitAllSectionsForLiteVersion();
    //     return;
    //   }
    // }

    this.loading = true;
    this.isSubmitApiCalled = true;
    this.isRefreshpopup = false;
    this.ristrictExitingAssessment = false;
    this.submitSection.userAssessmentDriveSetId = this.userAssessmentDriveSetId;
    this.subSectionDto.sequence = this.allQuestionsDataForTopBar.sequence;
    if (this.autoSubmitAssessment) {
      this.subSectionDto.sectionStatus = 'PROCTORING_DISCONNECTED';
    } else if (this.autoSubmitExam) {
      this.subSectionDto.sectionStatus = 'SECTION_AUTO_SUBMIT';
    } else if (this.endSection) {
      this.subSectionDto.sectionStatus = 'END_SECTION';
    } else {
      this.subSectionDto.sectionStatus = 'SUBMITTED';
    }
    if (this.isLastSection == true) {
      this.submitSection.location = this.proctoringDto.location;
      this.submitSection.ipAddress = this.proctoringDto.ipAddress;
      this.getFeedsCount();
    }
    this.submitSection.sectionDto = this.subSectionDto;

    if (
      (this.allQuestionsData?.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
      this.isRecording
    ) {
      this.stopRecordingVideo();
    } else if (
      this.allQuestionsData?.questionType == 'AUDIO' &&
      this.isRecording
    ) {
      this.stopRecordingAudio();
    } else {
      try {
        this.submitSection?.sectionDto?.sectionQuestionList.forEach((q) => {
          q.selectedOptionsIds = this.normalizeEmpty(q.selectedOptionsIds);
        });
      } catch (error) {
        console.error(error);
      }
      console.log(
        this.submitSection,
        'submitSection.sectionDto.sectionQuestionList'
      );

      if (this.retryInterval) {
        clearInterval(this.retryInterval);
      }
      if (this.allIDEQuestionsIds?.length > 0) {
        this.IDELoader = false;
        this.stopAllContainers();
      }
      if (this.allJupyterQuestionsIds?.length > 0) {
        this.jupyterLoader = false
        this.stopAllJupyterContainers();
      }

      try {
        let payloadToSave = {
          userAssessmentDriveSetId: this.userAssessmentDriveSetId,
          submitSectionPayload: JSON.stringify(this.submitSection),
        };
        this._examinationService
          .submitSectionsPayload(payloadToSave)
          .subscribe({
            next: (response) => {
              console.log(response);
            },
            error: (error) => {
              console.log(error);
            },
          });
      } catch (error) {
        console.log(error);
      }

      this._examinationService.submitSections(this.submitSection).subscribe(
        (response) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            Sentry.logger.info("Section Submitted Non-progressive", {
              driveId: String(this.driveData),
              isLastSection: !!this.isLastSection,
              sectionStatus: String(this.subSectionDto.sectionStatus),
            });
            this.sectionBreakTime = response?.data?.breakTimeInSeconds;
            this.nextSectionName = response?.data?.sectionName;
            this.totalTimeForSection = response?.data?.sectionTimeInMins;
            this.totalQuestionForNextSection =
              response?.data?.totalQuestionsCount;
            this.isNextSectionProgressive =
              response?.data?.isNextSectionProgressive;
            this.isNextSectionQuestionBank =
              response.data.isNextSectionQuestionBank;
            this.sectionSequence = response?.data?.nextSectionSequence;
            this.isCurrentSectionProgressive =
              response?.data?.isCurrentSectionProgressive;
            this.selectedQuestionForExplanation =
              response?.data?.selectedQuestionForExplanation;
            this.submitLastSectionResponse = response.data;
            let token = response.data.foreignDriveToken;
            sessionStorage.setItem('token', token);

            this.autoSubmitExam = false;
            this.startedExamination = false;
            this.loading = false;
            this.isSubmitApiCalled = false;
            this.endSection = false;
            this.resetAllQuestionsState();
            this.resetCurrentPage();
            this.openConfirmationPopup = false;
            if (this.selectedQuestionForExplanation) {
              this.loading = true;
              this.verifyUserResponseModal = true;
              this.startRecordingVideo();
              setTimeout(() => {
                this.loading = false;
              }, 1000);
            } else {
              if (!this.isLastSection && !this.autoSubmitAssessment) {         
                if(this.atleastOneQuestionReported){
                  this.newReportedQuestionsPopup='openReport';
                  sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
                }      
                else if (this.sectionBreakTime > 0) {
                    this.breakTimeScreen = true;
                    this.startTimer(this.sectionBreakTime);
                } else {
                    this.breakTimeScreen = false;
                    this.startNextSection();
                }
              }
            }

            if (!this.selectedQuestionForExplanation) {
              if(this.atleastOneQuestionReported){
                this.newReportedQuestionsPopup='openReport';
                sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
              }
              else{
                this.submitLastSection();
              }
            }
          }
        },
        (error) => {
          // sectionPayload used to be JSON.stringify(this.submitSection) in a
          // tag. Tag values are shipped verbatim by the SDK, so that 413'd at
          // ingest and this error never reached Sentry. Ship the shape only.
          //
          // Emitted twice on purpose: a losing submission is the worst thing
          // that can happen to a candidate, so it belongs in Issues where it
          // groups and can drive an alert, as well as in the Logs timeline.
          Sentry.logger.error("Submission Failed", {
            driveId: String(this.driveData),
            statusCode: String(error?.statusCode || 'unknown'),
            sectionPayloadBytes: JSON.stringify(this.submitSection ?? {}).length,
            questionCount:
              (this.submitSection as any)?.sectionQuestionList?.length ?? 0,
            errorMessage: String(error?.message ?? error),
          });
          Sentry.captureMessage("Submission Failed", {
            level: 'error',
            tags: {
              driveId: this.driveData,
              statusCode: error?.statusCode || 'unknown',
            },
            extra: {
              sectionPayloadBytes: JSON.stringify(this.submitSection ?? {}).length,
              questionCount:
                (this.submitSection as any)?.sectionQuestionList?.length ?? 0,
              errorMessage: error?.message ?? String(error),
            },
          });
          if (error.statusCode >= 500) {
            this.toastr.error('Something went wrong');
          }
          else {
            this.toastr.error(error?.error?.message);
          }
          this.endSection = false;
          this.loading = false;
        }
      );
    }
  }

  confirmSubmit() {
    this.showUnattemptedModal = false;
    this.submitUnattemptedNonProgressiveTest = true;
    this.submitTest();
  }

  async submitAllSectionsForLiteVersion() {
    const webFeedCounter = localStorage?.getItem('webFeedCounter');
    const screenShareCounter = localStorage?.getItem('screenShareCounter');
    const submitAllPayload = {
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      location: this.proctoringDto.location,
      ipAddress: this.proctoringDto.ipAddress,
      sectionDtos: [...this.liteSectionResponses],
      countOfWebFeedChunks: JSON.parse(webFeedCounter),
      countOfScreeShareChunks: JSON.parse(screenShareCounter),
    };

    this.loading = true;
    this.isSubmitApiCalled = true;

    this.allSectionsSubmitPayload = submitAllPayload;

    if (this.isLiteAppVersion) {
      sessionStorage.setItem(
        'pendingSubmitPayload',
        JSON.stringify(submitAllPayload)
      );

      const additionalEventsPayload = this.prepareAdditionalEvents();

      if (additionalEventsPayload) {
        sessionStorage.setItem(
          'pendingAdditionalEvents',
          JSON.stringify(additionalEventsPayload)
        );
      }

      // const serializableVideoList = await Promise.all(
      //   this.recordedVideosList.map(async (videoData) => {
      //     const blob = videoData.formData.get('file') as Blob;
      //     const base64 = await this.convertBlobToBase64(blob);
      //     return {
      //       base64Video: base64,
      //       mimeType: blob.type,
      //       fileName: 'file.webm',
      //       questionId: videoData.questionId,
      //       sectionQuestionId: videoData.sectionQuestionId,
      //     };
      //   })
      // );

      // sessionStorage.setItem(
      //   'pendingVideoQuestion',
      //   JSON.stringify(serializableVideoList)
      // );

      this.loading = false;
      this._commonService.isSyncModalVisible.next(true);
      this.submitLastSection();
      return;
    }
    this._examinationService.submitAllSections(submitAllPayload).subscribe(
      (response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this.submitLastSectionResponse = response.data;
          this.submitAllRecordedVideos();
          let token = response.data.foreignDriveToken;
          sessionStorage.setItem('token', token);
          this.submitAdditionalEvents();

          this.autoSubmitExam = false;
          this.startedExamination = false;
          this.loading = false;
          this.isSubmitApiCalled = false;
          this.endSection = false;

          if (this.selectedQuestionForExplanation) {
            this.loading = true;
            this.verifyUserResponseModal = true;
            this.startRecordingVideo();
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          }
          // this.uploadPendingVideos();
          this.submitLastSection();
        }
      },
      (error) => {
        this.endSection = false;
        this.loading = false;
      }
    );
  }

  additionalEvents: any[] = [];

  private prepareAdditionalEvents() {
    const payload = {
      reportedQuestions: [] as any[],
      focusedEvents: [] as any[],
      monitoringEvents: [] as any[],
    };

    if (this.liteSectionResponses && this._examinationEventService) {
      this.liteSectionResponses.forEach((section, index) => {
        const sectionId = (index + 1).toString();

        const reportedQuestions =
          this._examinationEventService.getReportedQuestions(sectionId);
        if (reportedQuestions && reportedQuestions.length > 0) {
          payload.reportedQuestions.push(
            ...reportedQuestions.map((question) => ({
              appUserId: this.loginUser.id,
              driveId: this.driveData,
              questionId: question.questionId,
              subCategoryId: this.subCategoriesId,
              wrongQuestionReason: question.reason,
              wrongQuestionSuggestion: question.suggestion,
            }))
          );
        }

        const focusEvents =
          this._examinationEventService.getFocusEvents(sectionId);
        if (focusEvents && focusEvents.length > 0) {
          payload.focusedEvents.push(
            ...focusEvents.map((event) => ({
              date: event.date,
              focusedIn: event.focusedIn,
              focusedOut: event.focusedOut,
              assessmentDriveSetId: this.assessmentDriveSetId,
            }))
          );
        }

        const monitoringEvents =
          this._examinationEventService.getMonitoringEvents(sectionId);
        if (monitoringEvents && monitoringEvents.length > 0) {
          payload.monitoringEvents.push(
            ...monitoringEvents.map((event) => ({
              appName: event.monitoringName,
              userAssessmentDriveSetId: this.userAssessmentDriveSetId,
              driveId: this.driveData,
              // date: event.timestamp
            }))
          );
        }
      });
    }

    return payload;
  }

  submitAdditionalEvents() {
    const payload = this.prepareAdditionalEvents();

    if (
      payload.reportedQuestions.length > 0 ||
      payload.focusedEvents.length > 0
    ) {
      if (!this.networkConnection && this.isLiteAppVersion) {
        sessionStorage.setItem(
          'pendingAdditionalEvents',
          JSON.stringify(payload)
        );
        return;
      }

      this._examinationService.submitAdditionalEvents(payload).subscribe(
        (response) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            console.log('Additional events submitted successfully');
            if (this.liteSectionResponses) {
              this.liteSectionResponses.forEach((section, index) => {
                const sectionId = (index + 1).toString();
                this._examinationEventService.clearFocusEvents(sectionId);
                this._examinationEventService.clearReportedQuestions(sectionId);
              });
            }
          }
        },
        (error) => {
          console.error('Failed to submit additional events:', error);
        }
      );
    }
  }

  subCategoryResponseDto: SubCategoryResponseDto = new SubCategoryResponseDto();
  // isLastQuestion: boolean;
  isCurrentSectionProgressive: boolean;
  lastSectionAndLastQuestion: boolean;
  disableButtonForSaveAndProceed: boolean;
  questionsIndex: boolean;
  startedExaminationStop: boolean;
  isSubCategoryLastQuestion: boolean;
  isProgressiveLastQuestion: boolean;
  submitTestForprogressiveAssessment() {
    this.loading = true;
    this.isSubmitApiCalled = true;
    this.isRefreshpopup = false;
    this.ristrictExitingAssessment = false;
    if (this.isLastQuestions || this.autoSubmitExam || this.endSection) {
      this.sectionTimer = 0;
      this.appTopBar.startTimerManually(
        this.sectionTimer,
        this.allQuestionsDataForTopBar
      );
      this.startedExaminationStop = true;
      // this.startedExamination = false;
    }
    if (this.subCategoryResponseDto.sectionQuestionDtos.length === 0) {
      this.progressiveResponseData.subCategories.push(
        this.subCategoryResponseDto
      );
    } else {
      this.progressiveResponseData.subCategories = [];
      this.progressiveResponseData.subCategories.push(
        this.subCategoryResponseDto
      );
    }
    this.subCategoryResponseDto.sequence =
      this.allQuestionsDataForTopBar.sequence;
    this.subCategoryResponseDto.id = this.subCategoriesId;
    if (this.autoSubmitAssessment) {
      this.progressiveResponseData.sectionStatus = 'PROCTORING_DISCONNECTED';
    } else if (this.isLastQuestions && !this.autoSubmitExam) {
      this.questionsIndex = true;
      this.progressiveResponseData.sectionStatus = 'SUBMITTED';
    } else if (this.autoSubmitExam) {
      this.questionsIndex = true;
      this.progressiveResponseData.sectionStatus = 'SECTION_AUTO_SUBMIT';
    } else if (this.endSection) {
      this.questionsIndex = true;
      this.progressiveResponseData.sectionStatus = 'END_SECTION';
    }

    if (this.isLastSection == true) {
      this.finalSectionDataForProgressive.location = this.proctoringDto.location;
      this.finalSectionDataForProgressive.ipAddress = this.proctoringDto.ipAddress;
    }

    if (
      (this.isLastSection &&
        (this.isLastQuestions || this.endSection || this.autoSubmitExam)) ||
      this.autoSubmitAssessment
    ) {
      this.lastSectionAndLastQuestion = true;
      this.getFeedsCount();
    }
    this.disableButtonForSaveAndProceed = true;

    if (
      (this.allQuestionsData?.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
      this.isRecording
    ) {
      this.stopRecordingVideo();
    } else if (
      this.allQuestionsData?.questionType == 'AUDIO' &&
      this.isRecording
    ) {
      this.stopRecordingAudio();
    } else {
          console.log('Requesting progressive questions with data:', this.progressiveResponseData);
      // Appening languageType  based on  languageId
      this.progressiveResponseData.subCategories.forEach(subCat => {
        subCat.sectionQuestionDtos.forEach(question => {
          question.languageType =this.getLanguageName(question.languageId);
          // Added this to get payload ofmprogressive for payload-dump api
          const alreadyExists =this.finalSectionDataForProgressive.sectionDto.sectionQuestionList.length>0? this.finalSectionDataForProgressive.sectionDto?.sectionQuestionList.some(
            q => q.sectionQuestionId === question.sectionQuestionId
          ):false;
      
          if (!alreadyExists) {
            const mappedQuestion = this.mapQuestionForProgressivePayload(question);
            this.finalSectionDataForProgressive.sectionDto.sectionQuestionList.push(mappedQuestion);
          }
        });
      });       
      console.log(this.finalSectionDataForProgressive,'++++++++++++++++++++++++++++++++');
         

      // Added  section payload dump api to store the progressive response as well
      if(this.isLastQuestions || this.endSection || this.autoSubmitExam ||  this.autoSubmitAssessment){
        this.finalSectionDataForProgressive.sectionDto.sectionStatus = this.progressiveResponseData.sectionStatus;
        // sectionPayload used to be the whole finalSectionDataForProgressive
        // object. Log attributes are stringified in full and batched 100 to an
        // envelope, so that was a 413 waiting to happen. Ship the shape.
        Sentry.logger.info("Section Submitted Progressive", {
          driveId: String(this.driveData),
          questionCount: Array.isArray(this.finalSectionDataForProgressive)
            ? this.finalSectionDataForProgressive.length
            : 0,
          payloadBytes: JSON.stringify(this.finalSectionDataForProgressive ?? {}).length,
        });
        try {
          let payloadToSave = {
            userAssessmentDriveSetId: this.userAssessmentDriveSetId,
            submitSectionPayload: JSON.stringify(this.finalSectionDataForProgressive),
          };
          this._examinationService
            .submitSectionsPayload(payloadToSave)
            .subscribe({
              next: (response) => {
                console.log(response);
                this.resetProgressiveDataPayload();
              },
              error: (error) => {
                console.log(error);
                this.resetProgressiveDataPayload();
              },
            });
        } catch (error) {
          console.log(error);
          this.resetProgressiveDataPayload();
        }
  
      }

      this._examinationService
        .getSectionProgressiveQuestions(this.progressiveResponseData)
        .pipe(takeUntil(this.destroy$))
        .subscribe(
          (response) => {
            if (response && response.statusCode === HttpStatusCode.Ok) {
              this.allQuestionsDataForTopBar = response.data.sectionDto;
              this.isLastQuestions = response.data.isLastQuestions;
              this.sectionBreakTime = response?.data?.breakTimeInSeconds;
              this.nextSectionName = response?.data?.sectionName;
              this.totalTimeForSection = response?.data?.sectionTimeInMins;
              this.totalQuestionForNextSection =
                response?.data?.totalQuestionsCount;
              this.isLastSection = response?.data?.isLastSection;
              this.isNextSectionProgressive =
                response?.data?.isNextSectionProgressive;
              this.isNextSectionQuestionBank =
                response.data.isNextSectionQuestionBank;
              this.sectionSequence = response?.data?.nextSectionSequence;
              this.isCurrentSectionProgressive =
                response?.data?.isCurrentSectionProgressive;
              this.selectedQuestionForExplanation =
                response?.data?.selectedQuestionForExplanation;
              this.submitLastSectionResponse = response.data;
              if (response?.data?.isNextSubCategory == true) {
                this.isSubCategoryLastQuestion = true;
              }
              this.openConfirmationPopup = false;
              this.progressiveResponseData.subCategories = [];
              this.autoSubmitExam = false;
              this.endSection = false;
              this.isSubmitApiCalled = false;
              this.currentQuestionIndex++;
              this.currentProgressiveIndex++;
              this.disableButtonForSaveAndProceed = false;
              this.optionsForQuestion = null;
              this.resetBooleanResponse();
              this.checkAndResetInput();
              this.resetCodingQuestion();
              this.goBackFromIDE();
              this.checkAndResetTextAnswer();
              this.vedioAnsId = '';
              this.audioAnsId = '';
              this.isProgressiveLastQuestion = false;

              // setTimeout(() => {
              //   const type = this.allQuestionsData?.questionType;
              //   if (
              //     ['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(
              //       type
              //     )
              //   ) {
              //     this.getCodingLanguages();
              //     this.getCodingLanguageSelected();
              //   }
              //   if (
              //     this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
              //   ) {
              //     this.jupyterLoader = false;
              //     this.stopJupyterServer();
              //     // setTimeout(() => {
              //     //   this.toggleLanguageSelection(this.jupyterNotebookObject);
              //     // }, 1000);
              //   }
              //   if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
              //     this.IDELoader = false;
              //     // this.stopCodeServer();
              //     this.stopAllContainers();
              //   }
              // }, this.timeoutDuration);
              if (this.selectedQuestionForExplanation) {
                this.loading = true;
                this.verifyUserResponseModal = true;
                this.startRecordingVideo();
                setTimeout(() => {
                  this.loading = false;
                }, 1000);
              } else {
                if (
                  !this.isLastSection &&
                  !this.autoSubmitAssessment &&
                  this.sectionBreakTime != null
                ) {
                  if(this.atleastOneQuestionReported){
                    this.newReportedQuestionsPopup='openReport';
                    sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
                  }
                  else if (this.sectionBreakTime > 0) {
                    this.breakTimeScreen = true;
                    this.startTimer(this.sectionBreakTime);
                  } else {
                    this.breakTimeScreen = false;
                    this.startNextSection();
                  }
                }
              }

              this.getSubcategory();
              if (!this.autoSubmitExam && response.data.sectionDto != null) {
                this.subCategoryResponseDto.sectionQuestionDtos = [];
                this.allQuestionsDataForTopBar.subCategories.forEach(
                  (subCategory) => {
                    subCategory.questionDtos.forEach((question) => {
                      this.allQuestions.push(new questionDto());
                    });
                  }
                );
                this.getSubcategory();
              }

              if (this.questionsIndex) {
                this.previousIndex = null;
                this.currentQuestionIndex = 0;
                this.currentProgressiveIndex = 0;
              }

              if (this.startedExaminationStop) {
                this.startedExamination = false;
              }

              if (this.lastSectionAndLastQuestion  &&  this.verifyUserResponseModal == false) {
                if (this.recordedChunks.length > 0) {
                // setTimeout(() => {
                  if (this.isDesktopApp) {
                    this.uploadVideo();
                  } else {
                    this.uploadScreenVideoOnWeb();
                  }
                // }, 300);
                }
                if (this.chunks.length > 0) {
                if (this.isDesktopApp) {
                  this.uploadVideoForWebCam(ChunkType.WEB_FEED);
                } else {
                  console.log('12 uploadVideoForWebCamOnWeb');

                  this.uploadVideoForWebCamOnWeb(ChunkType.WEB_FEED);
                }
                }

                this.getExtentionDisabled();
                this.breakTimeScreen = false;
                this.isSectionStarted = false;
                // if (this.connectedDriveId == this.driveId) {
                  this.stopScreenAndFeed();
                // }
                if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
                  this.IDELoader = false;
                  clearInterval(this.retryInterval);
                  // this.stopCodeServer();
                  this.stopAllContainers();
                }
                if (
                  this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
                ) {
                  clearInterval(this.retryInterval);
                  this.jupyterLoader = false;
                  this.stopAllJupyterContainers();
                }
                if(this.atleastOneQuestionReported ){
                  this.newReportedQuestionsPopup='openReport';
                  sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
                }
                else{
                  sessionStorage.removeItem('enableStep5');
                  this._router.navigate([
                    this._commonService.Navigations.SUBMIT_SUCCESS_PAGE,
                  ]);
                  this.exitFullScreen();
                }
              }
              this.loading = false;
              if (response.data.sectionDto == null) {
                this._commonService.getAssessmentSubmitDetails.next(
                  response.data
                );
              }
            }

            this.lastSectionAndLastQuestion = false;
            this.questionsIndex = false;
            this.startedExaminationStop = false;
          },
          (error) => {
            this.endSection = false;
            this.progressiveResponseData.sectionStatus = '';
            this.questionsIndex = false;
            this.startedExaminationStop = false;
            this.lastSectionAndLastQuestion = false;
            this.disableButtonForSaveAndProceed = false;
            this.isProgressiveLastQuestion = true;
            this.loading = false;
          }
        );
    }
  }

  mapQuestionForProgressivePayload(question: any) {
    return {
      mquestionId: question.mquestionId,
      mQuestionId: question.mQuestionId,
      selectedOptionsIds: question.selectedOptionsIds,
      responseFileId: question.responseFileId,
      sequence: question.sequence,
      sectionQuestionId: question.sectionQuestionId,
      questionId: question.questionId,
      timeTakenInSeconds: question.timeTakenInSeconds,
      singleWordAnswer: question.singleWordAnswer,
      fibAnswer: question.fibAnswer,
      multipleFibAns: question.multipleFibAns,
      booleanTypeResponse: question.booleanTypeResponse,
      sourceCode: question.sourceCode,
      candidateTestCaseDtos: question.candidateTestCaseDtos,
      newAudioQuestion: question.newAudioQuestion
    };
  }
  resetProgressiveDataPayload() {
    this.finalSectionDataForProgressive = {
      sectionDto: {
        sectionQuestionList: [],
        sectionStatus: '',
        sequence: null
      }
    };
  }

  displayMinutes: string;
  displaySeconds: string;
  timerInterval: any;
  reminingBreakTimer: any;

  startTimer(minutes: number): void {
    if (minutes > 0) {
      this.timerInterval = setInterval(() => {
        if (this.networkConnection || this.isLiteAppVersion) {
          const mins = Math.floor(minutes / 60);
          const secs = minutes % 60;

          // Ensure minutes and seconds don't go negative
          this.displayMinutes = Math.max(0, mins).toString();
          this.displaySeconds =
            secs < 10
              ? '0' + Math.max(0, secs).toString()
              : Math.max(0, secs).toString();

          if (minutes <= 0) {
            clearInterval(this.timerInterval);
            // if (this.isLiteAppVersion && this.breakTimeScreen) {
            //   this.breakTimeScreen = false;
            //   this.continueToNextOfflineSection();
            // } else 
            if (
              (this.startedExamination || this.breakTimeScreen) &&
              !this.isNextSectionStarted &&
              !this.manualStartCalled
            ) {
              this.startNextSection();
            }
          } else {
            minutes--;
          }
        } else {
          console.log('Network offline. Timer paused.');
        }
      }, 1000);
    } else if (minutes === 0) {
      this.displayMinutes = '';
      this.displaySeconds = '';
      clearInterval(this.timerInterval);

      // if (this.isLiteAppVersion && this.breakTimeScreen) {
      //   this.breakTimeScreen = false;
      //   this.continueToNextOfflineSection();
      // }
    }
  }

  goToDashboard() {
    this.submitTestModal = false;
    this._router
      .navigate([this._commonService.Navigations.PERMISSION_DETAILS])
      .then(() => {
        window.location.reload();
      });
  }

  manualStartCalled: boolean;
  breakInTime(event) {
    if (event === 'BreakInTime') {
      this.nextSection = true;
      this.loading=true;

      // If the section hasn't started yet
      if (!this.isNextSectionStarted) {
        this.manualStartCalled = true;
        this.startNextSection();
      }
    }
  }

  isNextSectionStarted: boolean = false;
  nextSection: boolean;
  startNextSection() {
    console.log('inside start next ');

    Sentry.logger.info("Next Section Started", {
      driveId: String(this.driveData),
      sectionSequence: String(this.sectionSequence),
    });

    this.isOfflineExamStarted = true;
    this.isNextSectionStarted = true;
    this.isProgressiveSection = false;
    this.submitUnattemptedNonProgressiveTest = false;
    this.progressiveResponseData.subCategories = [];
    // if(!this.isLiteAppVersion){
    this.subSectionDto.sectionQuestionList = [];
    this.subCategoryResponseDto.sectionQuestionDtos = [];
    // }
    this.fileInformationList = [];
    localStorage.removeItem('fileInformationList');
    this.resetAllQuestionsState();
    this.answers = [];
    this.fibAnswer = [];
    this.multipleFibAns = [];
    this.currentQuestionIndex = 0;
    this.currentProgressiveIndex = 0;
    this.isSectionSubmittedManually = false;
    this.compiledCode = null;
    this.IDECompiledTestCase = null;
    this.IDELoader = false;
    this.code = '';
    this.testCasesList = [];
    this.testCasesMap = {};
    this.compiledCodeMap = {};
    this.maximizeQuestionSection = false;
    this.bottomPanelExpanded = false;
    this.isShuffleSections = false;
    this.jupyterNotebookName = null
    this.IDEContainerUrl = null
    this.resetCurrentPage();
    setTimeout(() => {
      // if (this.isLiteAppVersion) {
      //   const currentSectionData =
      //     this.allSectionsData[this.offlineSectionIndex];
      //   console.log(
      //     'Loading section:',
      //     this.offlineSectionIndex,
      //     currentSectionData
      //   );
      //   if (this.appTopBar != null) {
      //     this.appTopBar.startTimerManually(
      //       this.sectionTimer,
      //       this.allQuestionsDataForTopBar
      //     );
      //   }

      //   this.isShuffleSections = currentSectionData?.isShuffleSections;
      //   if (this.isShuffleSections) {
      //     this.allQuestions = [...this.allQuestionsDataForTopBar.questionDtos];
      //   } else {
      //     this.allQuestions = [];
      //     this.allQuestionsDataForTopBar.subCategories.forEach(
      //       (subCategory) => {
      //         subCategory.questionDtos.forEach((question) => {
      //           this.allQuestions.push(question);
      //         });
      //       }
      //     );
      //   }
      //   this.getSubcategory();
      //   this.isSectionStarted = true;
      //   this.getOfflineUserAssessmentData();
      // } else {
        if (this.isNextSectionProgressive || (this.isLastSection && this.isCurrentSectionProgressive)) {
          this.subCategoriesData = [];
          this.getSubCategoriesDataForSections();
          this.getSectionProgressiveQuestions();
        } else if (this.isNextSectionQuestionBank) {
          this.getQuestionBankData();
        } else  if (!this.isNextSectionProgressive) {
          this.getUserAssessmentData();
        }
      // }
    }, 1000);

    if (this.getAllAdminPermissions.video) {
      setTimeout(() => {
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: true })
          .then((stream: MediaStream) => {
            if (this.userVideoElement && this.userVideoElement.nativeElement) {
              this.userVideoElement.nativeElement.srcObject = stream;
            }
          });
      }, 3000);
    }
    this.attemptedQuestionsCount = 0;
    setTimeout(() => {
      // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      //   this.stopAllContainers();
      // }
      clearInterval(this.retryInterval);
      const type = this.allQuestionsData?.questionType;
      if (['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)) {
        this.getCodingLanguages();
        this.getCodingLanguageSelected();
      }

      // if (type === 'JUPYTER_NOTEBOOK') {
      //   setTimeout(() => {
      //     this.createJupyterServer();
      //     this.toggleLanguageSelection(this.jupyterNotebookObject);
      //   }, 1000);
      // }

      // if (type === 'IDE_TYPE') {
      //   this.createCodeServer();
      //   this.toggleIDE();
      // }
    }, this.timeoutDuration);

    this.isNextSectionStarted = false;
    this.manualStartCalled = false;
    // this.sectionBreakTime = 0;
    // this.startTimer(this.sectionBreakTime);
    this.codeEditor = false;
    this.jupyterNotebookEnabled = false;
  }

  getQuestionObject(page: number) {
    return this.allQuestions[page];
  }

  optionsForQuestion: any;
  selectedAnswer(option?: any, questionIndex?: number, audioVideoId?: any) {
    this.vedioAnsId = audioVideoId;
    this.audioAnsId = audioVideoId;
    this.optionsForQuestion = option?.id;
    // console.log(option, 'option 1', 'question Index:', questionIndex);

    if (
      (option || audioVideoId) &&
      questionIndex !== undefined &&
      this.allQuestions &&
      this.allQuestions[questionIndex]
    ) {
      this.sectionQuestionDto = {};
      if (!this.sectionQuestionDto.selectedOptionsIds) {
        this.sectionQuestionDto.selectedOptionsIds = [];
      }

      const currentQ = this.allQuestions[questionIndex];
      if(currentQ?.attempted == true){
        if (currentQ?.selectedAnswers?.includes(option?.id)) {
          return;
        }
      }
      // Initialize selectedAnswers if it doesn't exist
      if (!this.allQuestions[questionIndex].selectedAnswers) {
        this.allQuestions[questionIndex].selectedAnswers = [];
      } else {
        this.allQuestions[questionIndex].selectedAnswers = [];
      }


      if (currentQ.attempted === true) {
        currentQ.attempted = false;
        if(this.attemptedQuestionsCount > 0){
          this.attemptedQuestionsCount--
        }
        currentQ.skipped = false;

        this.subSectionDto.sectionQuestionList =
          this.subSectionDto.sectionQuestionList.filter(
            (q: any) => q.questionId !== currentQ.questionId
          );
      }

      // console.log(option, 'option 2');

      if (option) {
        this.allQuestions[questionIndex].selectedAnswers.push(option?.id);
      } else if (this.vedioAnsId || this.audioAnsId) {
        // currentQ.attempted = true;
        // currentQ.skipped = false;
        // currentQ.visited = true;
        this.allQuestions[questionIndex].selectedAnswers.push(
          this.vedioAnsId || this.audioAnsId
        );
      }
    } else {
      console.error('Invalid questionIndex or allQuestions not available:', {
        questionIndex,
        allQuestionsLength: this.allQuestions?.length,
        hasQuestion: this.allQuestions?.[questionIndex] ? 'yes' : 'no',
      });
    }
  }

  recordOptionAudio() {
    this.allQuestions[this.currentPage].selectedAnswers.push('audio recorded');
  }

  remainingDescriptionText: number = 250;
  answerEntered(value: string) {
    let wordCount = value ? value.split(/\s+/) : [];
    this.remainingDescriptionText = 250 - wordCount.length;
    this.getQuestionObject(this.currentPage).selectedAnswers[0] = value;
  }

 endAssessment(isEndSection: boolean = true) {
    this.endSection = isEndSection;
    console.log(this.allIDEQuestionsIds, 'allIDEQuestionsIds');

    if (this.isLastSection == true) {
      this.modalConfirmation.heading =
        'Are you sure you want to end the examination?';
    } else {
      this.modalConfirmation.heading =
        'Are you sure you want to end the Section?';
    }
    this.modalConfirmation.description =
      'Once Submitted, you will no longer be allowed to change <br/> exam answers.  Make sure you have <br/> attempted & saved all questions';

    const isIdeJupyterSection =
      this.allIDEQuestionsIds?.length > 0 ||
      this.allJupyterQuestionsIds?.length > 0;
    if (!this.isCurrentSectionProgressive && isIdeJupyterSection) {
      this.computeIdeJupyterSummary();
      if (
        this.ideJupyterSummary.opened > 0 ||
        this.ideJupyterSummary.notAttempted > 0
      ) {
        this.includeOpenedQuestionsOnSubmit = true; // default selection
        this.ideSummaryForceSubmit = false; // manual end → Cancel allowed
        this.showIdeSubmitSummary = true;
        this.scrollToTop();
      } else {
        // all attempted → submit straight away, no popup
        this.submitTestForProgressiveOrNonProgressive(
          this._commonService.Enums.Submit_Section
        );
      }
      return;
    }

    this.ristrictExitingAssessment = !this.ristrictExitingAssessment;
    this.scrollToTop();
  }
  /**end */
  async promptPermission(type: string) {
    let constraints: { audio?: boolean; video?: boolean };
    switch (type) {
      case 'audio':
        constraints = { audio: true };
        break;
      case 'webCam':
        constraints = { video: true };
        break;
      default:
        break;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia(constraints);
      stream.getTracks().forEach((track) => track.stop());

      // User granted access to the microphone.
      // You can use the stream object to do something with the audio stream if needed.
    } catch (error: any) {
      // console.log(error);
      let text: string;
      // User denied access to the microphone or an error occurred.
      // console.error(error.name);.

      // Check if the user has previously blocked microphone access
      if (error.name === 'NotAllowedError') {
        text =
          type +
          ' access is blocked. Please enable it manually in your browser settings.';
        this.toastr.error(text, 'Info');
      } else if (error.name == 'NotFoundError') {
        text = type + ' is not connected to the device.';
        this.toastr.error(text, 'Info');
      }
    }
  }
  currentPageAndQuestionChanged(currentPageAndQuestionChanged: {
    currentPage: number;
    question: questionDto;
  }) {
    this.currentPage = currentPageAndQuestionChanged.currentPage;
    this.allQuestions[currentPageAndQuestionChanged.currentPage] =
      currentPageAndQuestionChanged.question;
  }

  userAssessmentDriveSetIdForVideo: any;
  getAdminPermissions() {
    let driveId = sessionStorage.getItem('driveId');
    if (driveId) {
      this._examinationService
        .getAdminPermissions(driveId)
        .subscribe(async (response: any) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            sessionStorage.setItem(
              'assessmentDriveSetId',
              response.data.assessmentDriveSetId
            );
            console.log(response.data.userAssessmentDriveSetId, 'userAssessmentDriveSetId');
            // Stored BEFORE the awaited bot call below: resetScannerStatusForBot()
            // rethrows, and this callback is async, so a failed bot-init API used
            // to abort the callback and leave the id unwritten for the whole exam.
            this.userAssessmentDriveSetIdForVideo =
              response?.data?.userAssessmentDriveSetId;
            if (this.userAssessmentDriveSetIdForVideo) {
              sessionStorage.setItem(
                'userAssessmentDriveSetId',
                this.userAssessmentDriveSetIdForVideo
              );
            }
            this.getAllAdminPermissions = response.data
            .proctoringSettingDto as AdminPermissionDto;
            if(response.data?.isInterviewBotDrive){
              const result = await this.resetScannerStatusForBot(response.data.userAssessmentDriveSetId);
              console.log(result,'result from resetScannerStatusForBot');
            }
              sessionStorage.setItem(
                'ParentDriveProctoringSetting',
                JSON.stringify(this.getAllAdminPermissions)
              );
            // if(this.connectedDriveId == this.driveId){
            //   this.getAllAdminPermissions.aadharPhotoCapture =false
            //  }

            // this.getAllAdminPermissions.screenShare =false

            let candidateDriveData = response?.data;
            this.getAllAdminPermissions = response.data
              .proctoringSettingDto as AdminPermissionDto;
            this.getAllAdminPermissions.overrideProctoringSetting =
              response.data.overrideProctoringSetting;
            // Dedicated handoff for the interview-bot wrapper so it can gate
            // app/external-device detection independently of ParentDriveProctoringSetting
            sessionStorage.setItem(
              'InterviewBotProctoringSetting',
              JSON.stringify(this.getAllAdminPermissions)
            );
            this.isInterviewBotDrive = !!response?.data?.isInterviewBotDrive;

            if (this.isInterviewBotDrive) {
              this._examinationService
                .createCandidateInterviewSession({
                  driveId: driveId,
                  userAssessmentDriveSetId: this.userAssessmentDriveSetIdForVideo,
                })
                .subscribe({
                  next: (sessionRes: any) => {
                    const userInterviewSessionId = sessionRes?.data?.id;
                    if (userInterviewSessionId) {
                      sessionStorage.setItem(
                        'userInterviewSessionId',
                        userInterviewSessionId
                      );
                    }
                  },
                  error: (err) => {
                    console.error(
                      'Error creating candidate interview session:',
                      err
                    );
                  },
                });
            }

            if (this.connectedDriveId == this.driveId) {
              const storedCapturedImage =
                await this.videoUploaderService?.getItem('pendingImages');

              if (storedCapturedImage) {
                const { file, timestamp } =
                  storedCapturedImage as {
                    file: any;
                    timestamp: string;
                  };
                this._examinationService
                  .saveCaptureImage(file, this.userAssessmentDriveSetIdForVideo)
                  .subscribe(
                    (res) => {
                      if (
                        res &&
                        (res.statusCode === HttpStatusCode.Ok ||
                          res.status === HttpStatusCode.Ok)
                      ) {
                        this.videoUploaderService.deleteItem('pendingImages');
                        // if(this.connectedDriveId){
                        //   this.enbleStep2({webcamImage:undefined, image: file})
                        // }
                      }
                    },
                    (error) => {
                      console.error('Error submitting captured image:', error);
                    }
                  );
              }
            }
            this.proctoringDto.adminPermissions = new AdminPermissionDto();
            this.proctoringDto.adminPermissions = this.getAllAdminPermissions;
            if (this.proctoringDto.adminPermissions.disableScreenshot) {
              document.addEventListener('contextmenu', (event) =>
                event.preventDefault()
              );
              document.addEventListener('keyup', (e) => {
                if (e.key == 'PrintScreen') {
                  navigator.clipboard.writeText('');
                  this.toastr.info('', 'Screenshots disabled!');
                }
              });
            }

            // if (
            //   !candidateDriveData?.isReAttemptDrive &&
            //   !candidateDriveData?.isInterviewBotDrive
            // ) {
            //   if (candidateDriveData?.isExperienceDrive) {
            //     this.saveTechnicalQuestion(
            //       candidateDriveData?.userAssessmentDriveSetId
            //     );
            //   } else {
            //     this.saveFFFQuestion(
            //       candidateDriveData?.noOfFFFQuestionNeeded,
            //       candidateDriveData?.candidateResumeURL
            //     );
            //   }
            // }

            // Run pre-assessment checks immediately after getting proctoring settings
            await this.runInitialPreChecks();

            this.mediaAccessService.startContinuousPermissionCheck();
            this.mediaPermissionSubscription =
              this.mediaAccessService.mediaPermissions$.subscribe((obj) => {
                this.mediaAccessService.activeTab = this.activeTab;
                this.checkAllAccess();
                if (this.activeTab >= 1) {
                } else {
                  this.checkForExistenceOfExtension();
                }
              });
          }
        },
        (error) => {
          // Was captureException with a string, which produces a synthetic
          // exception with no usable stack. This is a gate failure in the exam
          // funnel, so it belongs in the Logs timeline.
          Sentry.logger.error("Config Load Failed", {
            driveId: String(driveId),
            statusCode: String(error?.statusCode ?? error?.status ?? 'unknown'),
            errorMessage: String(error?.message ?? error),
          });
          console.error('Failed to load admin permissions:', error);
        });
    }
  }

  async resetScannerStatusForBot(userAssessmentDriveSetId: any) {
  try {
    console.log('Resetting mobile scanner status...');
    this.loading = true; // Show loading indicator while resetting status
    const response = await firstValueFrom(
      this._examinationService.resetMobileScannerStatusForBot(userAssessmentDriveSetId)
    );
    if (response && response.statusCode === 200) {
      this.loading = false; 
      console.log('Status reset successfully:', response.data);
      return response.data;
    }
    
  } catch (error) {
    // Handle API errors or timeouts here
    this.loading = false; 
    console.error('Failed to reset scanner status:', error);
    throw error; 
  }
}

  async checkForExistenceOfExtension() {
    this.extensionEnabled =
      await this.mediaAccessService.checkExtensionPresence();
  }

  mediaRecorder: MediaRecorder | null = null;
  mediaRecorderForWebCam: MediaRecorder | null = null;
  recordedChunks: Blob[] = [];
  sequence: number = 0;
  sequenceForWebcam: number = 0;
  recordName: string = 'abc';
  startedExamination: boolean = false;

  async startRecording() {
    try {
      if (!this.breakTimeScreen) {
        this.startedExamination = true;
      }
      const constraints: MediaStreamConstraints = {
        // @ts-ignore: Add cursor option as it is not directly supported
        video: { cursor: 'motion' },
        audio: { echoCancellation: true },
      };

      if (!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia)) {
        window.alert('Screen Record not supported!');
        return;
      }
      // this.screenShareData = await navigator.mediaDevices.getDisplayMedia(constraints);
      // Get access to the user's webcam and display the video in the UI
      setTimeout(() => {
        if (this.getAllAdminPermissions.video) {
          navigator.mediaDevices
            .getUserMedia({ video: true, audio: true })
            .then((stream: MediaStream) => {
              this.userVideoElement.nativeElement.srcObject = stream;
              this.setupMedia();
            })
            .catch((error) => {
              console.error('Error accessing webcam: ', error);
              // this.toastr.error(error, 'Info');
              // clearInterval(this.CHUNK_UPLOAD_INTERVAL);
            });
        }
      }, 1000);
      if (this.screenShareData) {
        // Check if the user wants to record audio with the screen
        // if (window.confirm('Record audio with the screen?')) {
        const audioContext = new AudioContext();
        const voiceStream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true },
          video: false,
        });
        const userAudio = audioContext.createMediaStreamSource(voiceStream);
        const audioDestination = audioContext.createMediaStreamDestination();
        userAudio.connect(audioDestination);

        if (this.screenShareData.getAudioTracks().length > 0) {
          const displayAudio = audioContext.createMediaStreamSource(
            this.screenShareData
          );
          displayAudio.connect(audioDestination);
        }

        const tracks = [
          ...this.screenShareData.getVideoTracks(),
          ...audioDestination.stream.getTracks(),
        ];

        //stream.getTracks().forEach(track => track.stop()); // Stop the original stream
        this.screenShareData = new MediaStream(tracks);
        // }
        this.mediaRecorder = new MediaRecorder(this.screenShareData);

        this.mediaRecorder.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.recordedChunks.push(event.data);
            // console.log('Chunk received:', event.data.size);
            if (this.shouldSendChunks()) {
              setTimeout(async () => {
                if (this.isDesktopApp) {
                  await this.uploadVideo();
                } else {
                  await this.uploadScreenVideoOnWeb();
                }
              }, 500);
            }
          }
        };
        this.mediaRecorder.start(this.mediaRecorderStarterTime);
        // this.mediaRecorder.onstop = () => {
        //   this.stopRecording();
        //   this.recordedChunks = [];
        // };
      }
    } catch (err: any) {}
  }

  shouldSendChunks() {
    const totalSize = this.recordedChunks.reduce(
      (acc, chunk) => acc + chunk.size,
      0
    );
    return totalSize >= this.maxSize;
  }

  stopRecording() {
    if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
      this.mediaRecorder.stop();
      this.screenShareData?.getTracks().forEach((obj) => obj.stop());
    }
  }

  private readonly maxSize: number = 5 * 1024 * 1024; // 5 MB in bytes
  uploadedScreenFilesSet = new Set<string>();

  // async uploadVideo() {
  //   if (this.isApiRequestPending) {
  //     this.recordedChunks = [];
  //     return;
  //   }

  //   if (!this.recordedChunks.length) {
  //     console.warn('No screen share chunks to upload.');
  //     return;
  //   }

  //   const chunksToUpload = [...this.recordedChunks];
  //   this.recordedChunks = [];

  //   const recordedBlob = new Blob(chunksToUpload, { type: 'video/webm' });

  //   if (recordedBlob.size === 0) {
  //     console.error('Recorded screen blob is empty! Skipping upload.');
  //     return;
  //   }

  //   const buffer = await recordedBlob.arrayBuffer();
  //   const byteArray = new Uint8Array(buffer);

  //   if (window.electron) {
  //     window.electron.ipcRenderer.send('save-screen-video', byteArray);
  //   }

  //   const screenVideoFiles = await window.electron.ipcRenderer.invoke(
  //     'get-screen-saved-videos'
  //   );

  //   console.log(screenVideoFiles, 'screenVideoFiles');

  //   if (!screenVideoFiles.length) {
  //     console.log('No saved screen share videos found.');
  //     return;
  //   }

  //   if (this.mediaAccessService.isNetworkConnectionEnabled()) {
  //      for (const filePath of screenVideoFiles) {
  //           if (this.uploadedScreenFilesSet.has(filePath)) {
  //             continue;
  //           }

  //     const isEmpty = this.isFormDataEmpty(filePath);

  //     if (
  //       (!isEmpty && this.startedExamination) ||
  //       (!isEmpty && this.breakTimeScreen)
  //     ) {
  //       this.isApiRequestPending = true;
  //       this.recordedChunks = [];

  //       this._examinationService
  //         .saveChunkVideos(filePath, this.sequence, ChunkType.SCREEN_SHARE)
  //         .subscribe(
  //           (res) => {
  //             if (res && res.statusCode == HttpStatusCode.Ok) {
  //               // if (this.startedExamination) {
  //               this.recordedChunks = [];
  //               this.lastApiResponseSuccess = true;
  //               this.makeApiCall = true;
  //               this.sequence++;
  //               this.stopAndRestartMediaRecorder();
  //             } else {
  //               this.lastApiResponseSuccess = false;
  //               this.makeApiCall = false;
  //               this.checkPendingApiStatus();
  //             }
  //           },
  //           (error) => {
  //             this.lastApiResponseSuccess = false;
  //             this.isApiRequestPending = false;
  //             this.makeApiCall = true;
  //             this.checkPendingApiStatus();
  //             if (!this.isRecordedChunkMissed) {
  //               console.error('API error:', error);
  //               this.isRecordedChunkMissed = true;
  //               this.sendSlowInternetSpeed(
  //                 this.isRecordedChunkMissed,
  //                 this.driveData
  //               );
  //             }
  //           },
  //           () => {
  //             this.isApiRequestPending = false;
  //             this.scheduleNextApiCall();
  //           }
  //         );
  //     }
  //   }

  //   } else {
  //     this.recordedChunks = [];
  //   }
  // }

  /////////////Uplaod Screen Share Video Method/////////////////
  // uploadScreenVideoOnWeb() {
  //   // if (this.isLiteAppVersion) {
  //   //   return;
  //   // }

  //   if (this.isApiRequestPending) {
  //     this.recordedChunks = [];
  //     return;
  //   }
  //   const recordedBlob = new Blob(this.recordedChunks, { type: 'video/webm' });
  //   var file = new File([recordedBlob], 'file', { type: recordedBlob.type });
  //   let fileSize = file.size;
  //   let contentType = file.type;
  //   // console.log(file, "file screen");

  //   // Create a download link for the recorded file.
  //   // const url = window.URL.createObjectURL(recordedBlob);
  //   // const a = document.createElement('a');
  //   // a.style.display = 'none';
  //   // a.href = url;
  //   // a.download = 'screenShare-video.webm';
  //   // document.body.appendChild(a);
  //   // a.click();
  //   // window.URL.revokeObjectURL(url);
  //   // document.body.removeChild(a);
  //   //////////////////////////////////

  //   if (this.mediaAccessService.isNetworkConnectionEnabled()) {
  //     const formData: FormData = new FormData();
  //     formData.append('file', file);
  //     const isEmpty = this.isFormDataEmpty(formData);
  //     if (
  //       (!isEmpty && this.startedExamination) ||
  //       (!isEmpty && this.breakTimeScreen)
  //     ) {
  //       this.isApiRequestPending = true;
  //       this.recordedChunks = [];

  //       this._examinationService
  //         .saveChunkVideos(
  //           file,
  //           this.sequence,
  //           ChunkType.SCREEN_SHARE,
  //           fileSize,
  //           contentType
  //         )
  //         .subscribe(
  //           (res) => {
  //             if (res && res.status == HttpStatusCode.Ok) {
  //               console.log('screen share video uploaded successfully');

  //               // if (this.startedExamination) {
  //               this.recordedChunks = [];
  //               this.lastApiResponseSuccess = true;
  //               this.makeApiCall = true;
  //               this.sequence++;
  //               this.stopAndRestartMediaRecorder1();
  //             } else {
  //               this.lastApiResponseSuccess = false;
  //               this.makeApiCall = false;
  //               this.checkPendingApiStatus();
  //             }
  //           },
  //           (error) => {
  //             this.lastApiResponseSuccess = false;
  //             this.isApiRequestPending = false;
  //             this.makeApiCall = true;
  //             this.checkPendingApiStatus();
  //             if (!this.isRecordedChunkMissed) {
  //               console.error('API error:', error);
  //               this.isRecordedChunkMissed = true;
  //               this.sendSlowInternetSpeed(
  //                 this.isRecordedChunkMissed,
  //                 this.driveData
  //               );
  //             }
  //           },
  //           () => {
  //             this.isApiRequestPending = false;
  //             this.scheduleNextApiCall();
  //           }
  //         );
  //     }
  //   } else {
  //     this.recordedChunks = [];
  //   }
  // }

  async uploadScreenVideoOnWeb() {
    if (this.isApiRequestPending) {
      this.recordedChunks = [];
      return;
    }

    const recordedBlob = new Blob(this.recordedChunks, { type: 'video/webm' });
    const file = new File([recordedBlob], 'file', { type: recordedBlob.type });
    const fileSize = file.size;
    const contentType = file.type;
    const sequence = this.sequence;

    // this.downloadFile(recordedBlob, `recorded-video-${sequence}.webm`);
    // Save chunk to IndexedDB
    await this.videoUploaderService.saveScreenChunk(sequence, recordedBlob);

    // const uploadChunk = async (retryCount = 0) => {
    if (!this.mediaAccessService.isNetworkConnectionEnabled()) {
      this.recordedChunks = [];
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    const isEmpty = this.isFormDataEmpty(formData);

    if (
      (!isEmpty && this.startedExamination) ||
      (!isEmpty && this.breakTimeScreen)
    ) {
      this.isApiRequestPending = true;

      this._examinationService
        .saveChunkVideos(
          file,
          sequence,
          ChunkType.SCREEN_SHARE,
          fileSize,
          contentType
        )
        .subscribe(
          async (res) => {
            if (
              res &&
              (res.status === HttpStatusCode.Ok ||
                res.status === HttpStatusCode.Ok)
            ) {
              console.log('screen share video uploaded successfully');
              this.recordedChunks = [];
              this.lastApiResponseSuccess = true;
              this.makeApiCall = true;
              this.sequence++;
              await this.videoUploaderService.deleteScreenChunk(sequence);
              this.stopAndRestartMediaRecorderForScreenShare();
            } else {
              this.lastApiResponseSuccess = false;
              this.makeApiCall = false;
              this.checkPendingApiStatus();
            }
          },
          async (error) => {
            this.lastApiResponseSuccess = true;
            this.isApiRequestPending = false;
            this.makeApiCall = true;
            this.sequence++;
            this.recordedChunks = [];
            this.stopAndRestartMediaRecorderForScreenShare();

            // this.checkPendingApiStatus();

            // if (retryCount < 2) {
            //   console.warn(
            //     `Retrying screen chunk ${sequence}, attempt ${retryCount + 1}`
            //   );
            //   await uploadChunk(retryCount + 1);
            // } else {
            //   console.error(
            //     `Failed to upload screen chunk ${sequence} after 3 attempts`
            //   );
            //   this.sequence++;
            // }

            if (!this.isRecordedChunkMissed) {
              this.isRecordedChunkMissed = true;
              this.sendSlowInternetSpeed(
                this.isRecordedChunkMissed,
                this.driveData
              );
            }
          },
          () => {
            this.isApiRequestPending = false;
            this.scheduleNextApiCall();
          }
        );
      // }
    }

    // await uploadChunk();
  }

  //////////////////////////////////////////////////////////////

  // uploadScreenVideoOnWebs(chunkType: ChunkType, mergedBlob: Blob, sequence: number) {
  //   if (this.isApiRequestPending) {
  //     console.warn("Previous upload still pending. Skipping...");
  //     return;
  //   }

  //   if (!mergedBlob || mergedBlob.size === 0) {
  //     console.error("Screen share blob is empty! Skipping upload.");
  //     return;
  //   }

  //   const fileSize = mergedBlob.size;
  //   const contentType = mergedBlob.type;

  //   if (this.mediaAccessService.isNetworkConnectionEnabled()) {
  //     this.isApiRequestPending = true;

  //     const MAX_CHUNK_SIZE = 5 * 1024 * 1024;
  //     let start = 0;
  //     let partNumber = 0;

  //     const uploadNextSlice = () => {
  //       if (start >= mergedBlob.size) {
  //         console.log("Finished uploading all slices of screen share chunk");
  //         this.isApiRequestPending = false;
  //         this.lastApiResponseSuccess = true;
  //         this.makeApiCall = true;
  //         this.sequence++;
  //         this.stopAndRestartMediaRecorder();
  //         return;
  //       }

  //       const end = Math.min(start + MAX_CHUNK_SIZE, mergedBlob.size);
  //       const slice = mergedBlob.slice(start, end, contentType);
  //       const filePart = new File(
  //         [slice],
  //         `screenShare-${sequence}-part-${partNumber}.webm`,
  //         { type: contentType }
  //       );

  //       this._examinationService
  //         .saveChunkVideos(
  //           filePart,
  //           sequence,
  //           chunkType,
  //           filePart.size,
  //           contentType,
  //         )
  //         .subscribe(
  //           (res) => {
  //             if (res && res.statusCode == HttpStatusCode.Ok) {
  //               console.log(`Uploaded screen share part ${partNumber}`);
  //               partNumber++;
  //               start = end;
  //               uploadNextSlice();
  //             } else {
  //               console.error(`Failed uploading part ${partNumber}`);
  //               this.lastApiResponseSuccess = false;
  //               this.makeApiCall = false;
  //               this.isApiRequestPending = false;
  //               this.checkPendingApiStatus();
  //             }
  //           },
  //           (error) => {
  //             console.error("API error while uploading screen share:", error);
  //             this.lastApiResponseSuccess = false;
  //             this.isApiRequestPending = false;
  //             this.makeApiCall = true;
  //             this.checkPendingApiStatus();

  //             if (!this.isRecordedChunkMissed) {
  //               this.isRecordedChunkMissed = true;
  //               this.sendSlowInternetSpeed(this.isRecordedChunkMissed, this.driveData);
  //             }
  //           }
  //         );
  //     };

  //     uploadNextSlice();
  //   } else {
  //     console.warn("Network unavailable, dropping chunks.");
  //   }
  // }

  async uploadVideo() {
    if (this.isApiRequestPending) {
      // console.log('API request in progress, skipping screen upload.');
      return;
    }

    if (!this.recordedChunks.length) {
      console.warn('No screen share chunks to upload.');
      return;
    }

    const chunksToUpload = [...this.recordedChunks];
    this.recordedChunks = [];

    if (
      !chunksToUpload.length ||
      chunksToUpload.every((chunk) => chunk.size === 0)
    ) {
      console.error(
        'Recorded chunks are empty! Skipping screen chunks upload.'
      );
      return;
    }

    const recordedBlob = new Blob(chunksToUpload);

    if (recordedBlob.size === 0) {
      console.error('Recorded screen blob is empty! Skipping upload.');
      return;
    }

    try {
      const buffer = await recordedBlob.arrayBuffer();
      const byteArray = new Uint8Array(buffer);

      if (window.electron) {
        window.electron.ipcRenderer.send('save-screen-video', byteArray);
      }

      try {
        const screenVideoFiles = await window.electron.ipcRenderer.invoke(
          'get-screen-saved-videos'
        );

        if (!screenVideoFiles.length) {
          console.log('No saved screen share videos found.');
          return;
        }

        if(this.deployedClient == AppClient.PROD_MAIN){
          if (this.mediaAccessService.isNetworkConnectionEnabled()) {
            const indexToUpload = screenVideoFiles.length - 1;
            console.log(indexToUpload,"indexToUpload");

            if (indexToUpload >= 0) {
              console.log(indexToUpload,"indexToUpload inside");

              const filePath = screenVideoFiles[indexToUpload]?.path;
              console.log(filePath,"filePath");
              // for (const file of screenVideoFiles) {
              // console.log(file.size,"file.size");
              // console.log(file.path,"file.path");

              // const filePath = file.path;
              // console.log(`Skipping already uploaded file: ${filePath}`);
              if (!this.uploadedScreenFilesSet.has(filePath)) {
                //   continue;
                // }
                console.log('8 processQueuedScreenVideoUpload');

                const videoBlob = await this.readFileAsBlob(filePath);
                console.log(videoBlob.size,"videoBlob");

                await this.uploadScreenVideoToServer(
                  videoBlob,
                  ChunkType.SCREEN_SHARE,
                  filePath
                );
                this.uploadedScreenFilesSet.add(filePath);
              }}
          }
        }else { // for all other env, but decide which one to choose and make one
          if (
            this.mediaAccessService.isNetworkConnectionEnabled() &&
            !this.isLiteAppVersion
          ) {
            for (const file of screenVideoFiles) {
              const filePath = file.path;
              // console.log(`Skipping already uploaded file: ${filePath}`);
              if (this.uploadedScreenFilesSet.has(filePath)) {
                continue;
              }
              const videoBlob = await this.readFileAsBlob(filePath);
              await this.uploadScreenVideoToServer(
                videoBlob,
                ChunkType.SCREEN_SHARE,
                filePath
              );
              this.uploadedScreenFilesSet.add(filePath);
            }
          }
        }
      } catch (error) {
        console.error('Error fetching saved screen videos:', error);
      }
      console.log('upload done now restarting');

      this.stopAndRestartMediaRecorderForScreenShare();
    } catch (error) {
      console.error('Error processing screen video:', error);
    }
  }

  // async uploadScreenVideoToServer(videoBlob: Blob, chunkType: ChunkType, filePath:any) {
  //   const newFormData = new FormData();
  //   const fileData = new File([videoBlob], 'file', { type: 'video/webm' });
  //   newFormData.append('file', fileData);
  //   console.log('file:', fileData);

  //   if (this.shouldUploadVideo(newFormData)) {
  //     try {
  //       this.isApiRequestPending = true;
  //       const response = await this._examinationService
  //         .saveChunkVideos(newFormData, this.sequence, chunkType)
  //         .toPromise();

  //       this.handleScreenUploadResponse(response, chunkType, filePath);
  //     } catch (error) {
  //       this.handleScreenUploadError(error, chunkType);
  //     } finally {
  //       this.isApiRequestPending = false;
  //     }
  //   }
  // }

  async uploadScreenVideoToServer(
    videoBlob: Blob,
    chunkType: ChunkType,
    filePath: any
  ) {
    const newFormData = new FormData();
    const fileData = new File([videoBlob], 'file', { type: 'video/webm' });
    newFormData.append('file', fileData);
    // console.log('file:', fileData);

    if (this.shouldUploadVideo(newFormData)) {
      // If a question API request is in progress, queue this screen video upload
      if (this.apiPriorityService.isHighPriorityActive()) {
        this.apiPriorityService.queueVideoUpload(
          videoBlob,
          chunkType,
          filePath,
          true
        ); // Adding 'true' to indicate it's a screen share
      } else {
        // Otherwise, upload directly
        await this.processQueuedScreenVideoUpload(
          videoBlob,
          chunkType,
          filePath
        );
      }
    }
  }

  // New method to handle screen video upload processing
  async processQueuedScreenVideoUpload(
    videoBlob: Blob,
    chunkType: ChunkType,
    filePath: any
  ) {
    const newFormData = new FormData();
    const fileData = new File([videoBlob], 'file', { type: 'video/webm' });
    newFormData.append('file', fileData);
    let fileSize = videoBlob.size;
    let contentType = fileData.type;

    try {
      this.isApiRequestPending = true;
      const response = await this._examinationService
        .saveChunkVideos(
          fileData,
          this.sequence,
          chunkType,
          fileSize,
          contentType
        )
        .toPromise();

      this.handleScreenUploadResponse(response, chunkType, filePath);
    } catch (error) {
      this.handleScreenUploadError(error, chunkType);
    } finally {
      this.isApiRequestPending = false;
    }
  }

  // Handle successful screen share upload response
  handleScreenUploadResponse(
    response: any,
    chunkType: ChunkType,
    filePath: any
  ) {
    if (
      response &&
      (response.statusCode == HttpStatusCode.Ok || response.status == 200)
    ) {
      this.lastApiResponseSuccess = true;
      this.makeApiCall = true;
      this.sequence++;

      setTimeout(() => {
        window.electron.ipcRenderer.invoke('delete-video-chunk', filePath);
      }, 5000);

      this.stopAndRestartMediaRecorderForScreenShare();
    } else {
      this.lastApiResponseSuccess = false;
      this.makeApiCall = false;
      this.checkPendingApiStatus();
    }
  }

  // Handle screen share upload errors
  handleScreenUploadError(error: any, chunkType: ChunkType) {
    this.lastApiResponseSuccess = false;
    this.makeApiCall = true;
    this.checkPendingApiStatus();
    if (!this.isRecordedChunkMissed) {
      console.error('API error:', error);
      this.isRecordedChunkMissed = true;
      this.sendSlowInternetSpeed(this.isRecordedChunkMissed, this.driveData);
    }
  }

  webcamBuffer: Blob[] = [];
  screenBuffer: Blob[] = [];

  webcamSequence = 0;
  screenSequence = 0;

  // async stopAndRestartMediaRecorder1() {
  //   // ----- Webcam -----
  //   if (this.mediaRecorderForWebCam?.state === 'recording') {
  //     this.mediaRecorderForWebCam.stop();

  //     this.mediaRecorderForWebCam.onstop = async () => {
  //       if (this.chunks.length > 0) {
  //         // add new chunks to buffer
  //         this.webcamBuffer.push(new Blob(this.chunks, { type: 'video/webm' }));
  //         this.chunks = [];

  //         // check accumulated size
  //         const totalSize = this.webcamBuffer.reduce((s, b) => s + b.size, 0);

  //         if (totalSize >= 5 * 1024 * 1024) {
  //           const merged = new Blob(this.webcamBuffer, { type: 'video/webm' });
  //           this.webcamBuffer = []; // reset buffer
  //           this.webcamSequence++;

  //           if (this.isDesktopApp) {
  //             await this.uploadVideoForWebCam(ChunkType.WEB_FEED);
  //           } else {
  //             console.log('uploadVideoForWebCamOnWebdjkfhsdfgasdfgsjf');

  //             await this.uploadVideoForWebCamOnWeb(ChunkType.WEB_FEED);
  //           }
  //         }
  //       }

  //       // restart
  //       if (this.mediaRecorderForWebCam.state === 'inactive') {
  //         this.mediaRecorderForWebCam.start(6000);
  //       }
  //     };
  //   }

  //   // ----- Screen -----
  //   if (this.mediaRecorder?.state === 'recording') {
  //     this.mediaRecorder.stop();

  //     this.mediaRecorder.onstop = async () => {
  //       if (this.recordedChunks.length > 0) {
  //         this.screenBuffer.push(
  //           new Blob(this.recordedChunks, { type: 'video/webm' })
  //         );
  //         this.recordedChunks = [];

  //         const totalSize = this.screenBuffer.reduce((s, b) => s + b.size, 0);

  //         if (totalSize >= 5 * 1024 * 1024) {
  //           const merged = new Blob(this.screenBuffer, { type: 'video/webm' });
  //           this.screenBuffer = []; // reset buffer
  //           this.screenSequence++;

  //           if (this.isDesktopApp) {
  //             await this.uploadVideo();
  //           } else {
  //             await this.uploadScreenVideoOnWeb();
  //           }
  //         }
  //       }

  //       if (this.mediaRecorder.state === 'inactive') {
  //         this.mediaRecorder.start(1000);
  //       }
  //     };
  //   }
  // }

  async stopAndRestartMediaRecorderForWebFeed() {
    // ----- Webcam -----
    if (this.mediaRecorderForWebCam?.state === 'recording') {
      this.mediaRecorderForWebCam.stop();

      this.mediaRecorderForWebCam.onstop = async () => {
        if (this.chunks.length > 0) {
          // add new chunks to buffer
          this.webcamBuffer.push(new Blob(this.chunks, { type: 'video/webm' }));
          this.chunks = [];

          // check accumulated size
          const totalSize = this.webcamBuffer.reduce((s, b) => s + b.size, 0);

          if (totalSize >= 5 * 1024 * 1024) {
            const merged = new Blob(this.webcamBuffer, { type: 'video/webm' });
            this.webcamBuffer = []; // reset buffer
            this.webcamSequence++;

            if (this.isDesktopApp) {
              await this.uploadVideoForWebCam(ChunkType.WEB_FEED);
            } else {
              console.log('uploadVideoForWebCamOnWebdjkfhsdfgasdfgsjf');

              await this.uploadVideoForWebCamOnWeb(ChunkType.WEB_FEED);
            }
          }
        }

        // restart
        if (this.mediaRecorderForWebCam.state === 'inactive') {
          this.mediaRecorderForWebCam.start(6000);
        }
      };
    }

    // ----- Screen -----
    // if (this.mediaRecorder?.state === 'recording') {
    //   this.mediaRecorder.stop();

    //   this.mediaRecorder.onstop = async () => {
    //     if (this.recordedChunks.length > 0) {
    //       this.screenBuffer.push(
    //         new Blob(this.recordedChunks, { type: 'video/webm' })
    //       );
    //       // this.recordedChunks = [];

    //       const totalSize = this.screenBuffer.reduce((s, b) => s + b.size, 0);

    //       if (totalSize >= 5 * 1024 * 1024) {
    //         const merged = new Blob(this.screenBuffer, { type: 'video/webm' });
    //         this.screenBuffer = []; // reset buffer
    //         this.screenSequence++;

    //         if (this.isDesktopApp) {
    //           await this.uploadVideo();
    //         } else {
    //           await this.uploadScreenVideoOnWeb();
    //         }
    //       }
    //     }

    //     if (this.mediaRecorder.state === 'inactive') {
    //       this.mediaRecorder.start(1000);
    //     }
    //   };
    // }
  }

  stopAndRestartMediaRecorderForScreenShare() {
    if (this.mediaRecorder?.state === 'recording') {
      this.mediaRecorder.stop();

      this.mediaRecorder.onstop = async () => {
        this.recordedChunks = [];
        this.screenBuffer = [];
        this.screenSequence++;
        if (this.mediaRecorder.state === 'inactive') {
          this.mediaRecorder.start(2000);
        }
      };
    }
  }

  // async stopAndRestartMediaRecorder() {
  //   // if (!this.mediaRecorderForWebCam || !this.mediaRecorder) {
  //   //   console.warn('MediaRecorder(s) not initialized');
  //   //   return;
  //   // }

  //   if (this.mediaRecorderForWebCam?.state === 'recording') {
  //     // this.mediaRecorderForWebCam.requestData();

  //     this.mediaRecorderForWebCam.stop();

  //     this.mediaRecorderForWebCam.onstop = async () => {
  //       if (this.chunks.length > 0 && this.shouldSendChunksForWebCam()) {
  //         if (this.isDesktopApp) {
  //           await this.uploadVideoForWebCam(ChunkType.WEB_FEED);
  //         } else {
  //           await this.uploadVideoForWebCamOnWeb(ChunkType.WEB_FEED);
  //         }
  //       }

  //       // setTimeout(() => {
  //       // console.log("starting webcam");
  //       if (this.mediaRecorderForWebCam.state === 'inactive') {
  //         this.mediaRecorderForWebCam.start(6000);
  //       }
  //       // }, 2000);
  //     };
  //   }

  //   if (this.mediaRecorder?.state === 'recording') {
  //     // this.mediaRecorder.requestData();
  //     this.mediaRecorder.onstop = async () => {
  //       if (this.recordedChunks.length > 0 && this.shouldSendChunks()) {
  //         if (this.isDesktopApp) {
  //           await this.uploadVideo();
  //         } else {
  //           await this.uploadScreenVideoOnWeb();
  //         }
  //       }

  //       // setTimeout(() => {
  //       if (this.mediaRecorder.state === 'inactive') {
  //         this.mediaRecorder.start(1000);
  //       }
  //       // }, 2000);
  //     };
  //     this.mediaRecorder.stop();
  //   }
  // }

  getIpAndLocation() {
    this._examinationService.getLocationAndIpAddress().subscribe((response) => {
      if (response) {
        this.proctoringDto.ipAddress = response.IPv4;
        this.proctoringDto.location =
          response.city && response.state
            ? `${response.city}, ${response.state}, ${response.country_name}`
            : 'Location details not available';
      }
    });
  }

  autoSubmitAssessment: boolean;
  timer: any;
  timeOver: boolean = false;
  durationMinutes: any;
  startTimerForFifteenSeconds() {
    this.mediaPermissionSubscription.unsubscribe();
    let seconds: number = 15;
    let textSec: any = '0';
    let statSec: number = 15;
    const prefix = seconds < 10 ? '0' : '';
    this.timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 14;

      if (statSec < 10) {
        textSec = '0' + statSec;
      } else textSec = statSec;

      this.durationMinutes = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;
      if (seconds == 0) {
        Sentry.logger.warn("Exam Auto-Submit-Due-to-15sec-timer - Timeout", {
          driveId: String(this.driveData),
        });
        this.autoSubmitAssessment = true;
        this.autoSubmitExam = true;
        clearInterval(this.timer);
        this.timeOver = false;
        this.startedExamination = false;
        if (this.allQuestionsData.questionType == 'AUDIO' && this.isRecording) {
          this.stopRecordingAudio();
          return;
        }

        if (
          (this.allQuestionsData.questionType == 'VIDEO' ||
          this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION' ) && this.isRecording 
        ) {
          this.stopRecordingVideo();
          return;
        }

        // this.autoSubmitAssessment = true;
        // this.autoSubmitExam = true;
        // clearInterval(this.timer);
        // this.timeOver = false;
        // this.startedExamination = false;
          setTimeout(() => {
            this.autoSubmitForVideoQuestions();
          }, 1000);
        this.openPopUp = false;
      }
    }, 1000);
  }
  submitTestOnCancel() {
    this.openConfirmationPopup = false;
    this.openPopUp = true;
    this.startTimerForFifteenSeconds();
  }

  openPopUpForVideoQuestion: boolean;
  timerForVideoQuestion: any;
  displayMinutesForVideoQuestion: string;
  displaySecondsForVideoQuestion: string;
  isUploading:boolean=false;
  startTimerForVideoQuestion(minutes) {
    if (minutes > 0) {
      this.timerForVideoQuestion = setInterval(() => {
        const mins = Math.floor(minutes / 60);
        const secs = minutes % 60;
        this.displayMinutesForVideoQuestion = mins.toString();
        this.displaySecondsForVideoQuestion =
          secs < 10 ? '0' + secs.toString() : secs.toString();

        if (minutes <= 0) {
          this.openPopUpForVideoQuestion = false;
          clearInterval(this.timerForVideoQuestion);

          if (this.autoSubmitExam) {
            this.autoSubmitForVideoQuestions();
          }
        } else {
          minutes--;
        }
      }, 1000);
    } else {
      this.displayMinutesForVideoQuestion = '';
      this.displaySecondsForVideoQuestion = '';
      clearInterval(this.timerForVideoQuestion);
    }
  }
  startTimerForAudioQuestion(minutes) {
    if (minutes > 0) {
      this.timerForVideoQuestion = setInterval(() => {
        const mins = Math.floor(minutes / 60);
        const secs = minutes % 60;
        this.displayMinutesForVideoQuestion = mins.toString();
        this.displaySecondsForVideoQuestion =
          secs < 10 ? '0' + secs.toString() : secs.toString();

        if (minutes <= 0) {
          this.openPopUpForVideoQuestion = false;
          clearInterval(this.timerForVideoQuestion);

          if (this.autoSubmitExam && !this.isUploading) {
            this.autoSubmitForVideoQuestions();
          }
        } else {
          minutes--;
        }
      }, 1000);
    } else {
      this.displayMinutesForVideoQuestion = '';
      this.displaySecondsForVideoQuestion = '';
      clearInterval(this.timerForVideoQuestion);
    }
  }

  continueExamination(messageType: string) {
    switch (messageType) {
      case this._commonService.Enums.DISABLE_FULL_SCREEN:
        setTimeout(() => {
          this.openFullscreen();
          this.autoSubmitAssessment = false;

          // if (window.electron) {
          //   window.electron.ipcRenderer.send('toggle-kiosk', true);
          // }

          if (this.sectionBreakTime > 0) {
            this.breakTimeScreen = true;
          }
        }, 100);
        break;
      case this._commonService.Enums.DISABLE_EXTENSION:
        this.toastr.error(
          this._commonService.Enums.DISABLE_EXTENSION_TEXT,
          'Error'
        );
        return;
        break;
      default:
        break;
    }
    this.openConfirmationPopup = false;
  }

  async askForPermission() {
    try {
      const constraints: MediaStreamConstraints = {
        // @ts-ignore: Add cursor option as it is not directly supported
        video: {cursor: 'motion',
          frameRate: { ideal: 5, max: 5 },
          width: { ideal: 1080, max: 1080 },
        },
        audio: { echoCancellation: true },
      };

      // console.log(constraints, 'constraints');

      if (!(navigator.mediaDevices && navigator.mediaDevices.getDisplayMedia)) {
        window.alert('Screen Record not supported!');
        return;
      }
      let stream = await navigator.mediaDevices.getDisplayMedia(constraints);

      let displaySurface = stream
        .getVideoTracks()[0]
        .getSettings().displaySurface;

      // console.log(displaySurface, 'displaySurface');

      if (displaySurface !== 'monitor') {
        this.toastr.error('Selection of entire screen mandatory!', 'Info');
        stream.getTracks().forEach((obj) => obj.stop());
        return;
      }

      let mediaRecorderForPersmission = new MediaRecorder(stream);

      this.screenShareData = stream;
      this.screenRecordingEnabled = stream && stream != null ? true : false;

      mediaRecorderForPersmission.onstop = (event) => {
        this.screenRecordingEnabled = false;
      };

      mediaRecorderForPersmission.start(this.mediaRecorderStarterTime);
    } catch (err) {
      console.error('Error accessing screen:', err);
    }
  }

  enablePopupAndDisplayModalText(
    heading: string,
    alerMessageType: string,
    enableButtons?: boolean
  ) {
    this.openConfirmationPopup = true;
    this.modalConfirmation.heading = heading;
    this.modalConfirmation.alertMessageType = alerMessageType;
    this.modalConfirmation.enableButtons = enableButtons
      ? enableButtons
      : false;
  }

  handleCancelDisabledEventsOnModalPopup(messageType: string) {
    switch (messageType) {
      case this._commonService.Enums.DISABLE_FULL_SCREEN:
        this.modalConfirmation.heading =
          this._commonService.Enums.CANCEL_FULL_SCREEN_TEXT;
        break;
      case this._commonService.Enums.DISABLE_VIDEO:
        this.modalConfirmation.heading =
          this._commonService.Enums.CANCEL_VIDEO_TEXT;
        break;
      case this._commonService.Enums.DISABLE_AUDIO:
        this.modalConfirmation.heading =
          this._commonService.Enums.CANCEL_AUDIO_TEXT;
        break;
      case this._commonService.Enums.DISABLE_EXTENSION:
        this.modalConfirmation.heading =
          this._commonService.Enums.CANCEL_EXTENSION_TEXT;
        break;
      default:
        break;
    }
    this.openConfirmationPopup = false;
    this.openPopUp = true;
    this.startTimerForFifteenSeconds();
  }
  openFullscreen(): Promise<void> {
    return new Promise<void>((resolve) => {
      if (this.elem.requestFullscreen) {
        this.elem.requestFullscreen();
      } else if (this.elem.mozRequestFullScreen) {
        /* Firefox */
        this.elem.mozRequestFullScreen();
      } else if (this.elem.webkitRequestFullscreen) {
        /* Chrome, Safari and Opera */
        this.elem.webkitRequestFullscreen();
      } else if (this.elem.msRequestFullscreen) {
        /* IE/Edge */
        this.elem.msRequestFullscreen();
      }
      this.openConfirmationPopup = false;
      this.fullScreenModeEnabled = true;
      resolve();
    });
  }

  exitFullScreen() {
    if (this.document.exitFullscreen) {
      this.document.exitFullscreen();
    } else if (this.document.mozCancelFullScreen) {
      this.document.mozCancelFullScreen();
    } else if (this.document.webkitExitFullscreen) {
      this.document.webkitExitFullscreen();
    } else if (this.document.msExitFullscreen) {
      this.document.msExitFullscreen();
    }
    this.fullScreenModeEnabled = false;
  }
  @HostListener('document:fullscreenchange', ['$event'])
  @HostListener('document:webkitfullscreenchange', ['$event'])
  @HostListener('document:mozfullscreenchange', ['$event'])
  @HostListener('document:MSFullscreenChange', ['$event'])
  onFullScreenChange(event: Event) {
    this.fullScreenModeEnabled = document.fullscreenElement ? true : false;
  }

  openPopupForSubSection: boolean;
  openSubSectionsPopup() {
    this.openPopupForSubSection = !this.openPopupForSubSection;
  }

  closeDropdown() {
    this.openPopupForSubSection = false;
  }

  openTermsAndConditionModal(value: any) {
    this._commonService.open(value);
  }

  navToAssessment(event) {
    if (event == 'next') {
      this.enableStepTwo = false;
      this.enableStepThree = true;
    }
  }

  navToAssessmentRules(event) {
    if (event == 'next') {
      this.enableStepTwo = false;
      this.enableStepThree = false;
      this.enableStepFour = true;
    }
  }

  autoSubmitExam: boolean;
  timeUpForExam(event: any) {
    if (event == 'timeUpForExam') {
      this.autoSubmitExam = true;
      Sentry.logger.warn("Exam Auto-Submit - Timeout", {
        driveId: String(this.driveData),
      });

      if (
        this.allQuestionsData.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
      ) {
        if (
          this.autoSubmitExam &&
          (this.allQuestionsData.questionType == 'VIDEO' ||
            this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
          this.isRecording
        ) {
          this.stopRecordingVideo();
          return;
        } else if (
          this.autoSubmitExam &&
          this.vedioAnsId &&
          !this.openPopUpForVideoQuestion
        ) {
          this.autoSubmitForVideoQuestions();
        } else if (
          this.autoSubmitExam &&
          !this.openPopUpForVideoQuestion &&
          !this.isSubmitApiCalled
        ) {
          this.autoSubmitForVideoQuestions();
        }
      }

      if (this.allQuestionsData.questionType == 'AUDIO') {
        if (
          this.autoSubmitExam &&
          this.allQuestionsData.questionType == 'AUDIO' &&
          this.isRecording
        ) {
          this.stopRecordingAudio();          
          return;
        } else if (
          this.autoSubmitExam &&
          this.audioAnsId &&
          !this.openPopUpForVideoQuestion
        ) {
          this.autoSubmitForVideoQuestions();
        } else if (
          this.autoSubmitExam &&
          !this.openPopUpForVideoQuestion &&
          !this.isSubmitApiCalled
        ) {
          this.autoSubmitForVideoQuestions();
        }
      }

      if (
        this.allQuestionsData.questionType != 'VIDEO' &&
        this.allQuestionsData.questionType != 'AUDIO' &&
        this.allQuestionsData?.questionType != 'TECHNICAL_QUESTION'
      ) {
        // if (this.isLiteAppVersion) {
        //   const currentSectionData = {
        //     sequence: this.allQuestionsDataForTopBar.sequence,
        //     sectionStatus: 'SECTION_AUTO_SUBMIT',
        //     sectionQuestionList: [...this.subSectionDto.sectionQuestionList],
        //   };
        //   this.liteSectionResponses[this.offlineSectionIndex] =
        //     currentSectionData;

        //   if (!this.isLastSection) {
        //     this.moveToNextOfflineSection();
        //   } else {
        //     this.submitAllSectionsForLiteVersion();
        //   }
        // } else {
          if (this.isCurrentSectionProgressive) {
            this.destroy$.next();
            this.destroy$.complete();
            this.subCategoryResponseDto.sequence =
              this.allQuestionsDataForTopBar.sequence;
            this.progressiveQuestionsList();
            this.submitTestForprogressiveAssessment();
          } else if (!this.isSectionSubmittedManually) {
            this.subSectionDto.sequence =
              this.allQuestionsDataForTopBar.sequence;
            this.nonProgressiveQuestionsList();
            // Same review condition as endAssessment(): opened (orange) OR
            // not-attempted (grey) in an IDE/Jupyter section → review popup.
            // All saved → direct submit.
            const isIdeJupyterTimeUpSection =
              this.allIDEQuestionsIds?.length > 0 ||
              this.allJupyterQuestionsIds?.length > 0;
            if (isIdeJupyterTimeUpSection) {
              this.computeIdeJupyterSummary();
            }
            if (
              isIdeJupyterTimeUpSection &&
              (this.ideJupyterSummary.opened > 0 ||
                this.ideJupyterSummary.notAttempted > 0)
            ) {
              this.includeOpenedQuestionsOnSubmit = true; // default selection
              this.ideSummaryForceSubmit = true; // time-up → must submit, no Cancel
              this.showIdeSubmitSummary = true;
              this.scrollToTop();
            } else {
              this.submitTest();
            }
          }
        // }
      }

      // Handle network connection issues
      console.log('outside time time up');

      if (!this.networkConnection) {
        let submitAssessment = setInterval(() => {
          // if (this.isLiteAppVersion) {
          //   // For lite version, store data locally until network is available
          //   if (this.networkConnection) {
          //     if (this.isLastSection) {
          //       this.submitAllSectionsForLiteVersion();
          //     }
          //     clearInterval(submitAssessment);
          //   }
          // } else {
            // Original logic for non-lite version
            if (this.isCurrentSectionProgressive) {
              this.progressiveQuestionsList();
              this.submitTestForprogressiveAssessment();
            } else {
              this.nonProgressiveQuestionsList();
              this.submitTest();
            }
            if (this.networkConnection) {
              clearInterval(submitAssessment);
            }
          // }
        }, 4000);
      }
    }
  }

  endSection: boolean;
  submitTestForProgressiveOrNonProgressive(value: any) {
    if (
      (this.isCurrentSectionProgressive &&
        (this.allQuestionsData?.questionType == 'VIDEO' ||
          this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
        this.isRecording) ||
      (!this.isCurrentSectionProgressive &&
        (this.allQuestionsData?.questionType == 'VIDEO' ||
          this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
        this.isRecording)
    ) {
      if (!this.recordedVideoAns) {
        this.toastr.error('Please record the video to proceed', 'Error');
        return;
      }
    }

    if (
      (this.isCurrentSectionProgressive &&
        this.allQuestionsData?.questionType == 'AUDIO' &&
        this.isRecording) ||
      (!this.isCurrentSectionProgressive &&
        this.allQuestionsData?.questionType == 'AUDIO' &&
        this.isRecording)
    ) {
      if (!this.recordedAudioAns) {
        this.toastr.error('Please record the audio to proceed', 'Error');
        return;
      }
    }

    if (value == this._commonService.Enums.Reload_Assessment) {
      this.autoSubmitAssessment = true;
      this.startedExamination = false;
    }

    // this.endSection = true;
    this.isSectionSubmittedManually = true;
    this.resetCodingQuestion();
    this.goBackFromIDE();
    if (this.isCurrentSectionProgressive) {
      this.progressiveQuestionsList();
      this.submitTestForprogressiveAssessment();
    } else {
      this.nonProgressiveQuestionsList();
      this.submitTest();
    }
  }

  // code for the header
  displayedPageRange: number[] = [];
  /**
   * The function `getPageRangePopup` returns an array of page numbers to be displayed in a popup, based
   * on the current subsection index and current page number.
   * @returns The function `getPageRangePopup()` returns an array of numbers representing the displayed
   * page range.
   */
  getPageRangePopup(): any[] {
    const displayedPageRange: number[] = [];
    if (this.isCurrentSectionProgressive) {
      const totalQuestionsInProgressiveSection = this.totalProgressiveQuestions;
      for (let i = 0; i < totalQuestionsInProgressiveSection; i++) {
        displayedPageRange.push(i);
      }
    } else {
      if (this.currentSubSectionIndex === 0) {
        const totalQuestionsInFirstSection = this.getTotalQuestionsInSection(
          this.allQuestionsDataForTopBar
        );
        for (let i = 0; i < totalQuestionsInFirstSection; i++) {
          displayedPageRange.push(i);
        }
      } else {
        let start = 0;
        let end = this.currentPage;
        start = Math.max(0, start);
        end = Math.min(
          this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar) - 1,
          end
        );
        for (let i = start; i <= end; i++) {
          displayedPageRange.push(i);
        }
      }
    }

    this.displayedPageRange = displayedPageRange;
    return displayedPageRange;
  }

  totalProgressiveQuestions: any;
  getPageRange(): any[] {
    const displayedPageRange: number[] = [];
    let totalQuestionsInSection: number;

    if (this.isCurrentSectionProgressive) {
      totalQuestionsInSection = this.subCategoriesData
        ? this.subCategoriesData.reduce(
            (total, category) => total + Number(category.value),
            0
          )
        : 0;
      this.totalProgressiveQuestions = totalQuestionsInSection;
    } else {
      totalQuestionsInSection = this.getTotalQuestionsInSection(
        this.allQuestionsDataForTopBar
      );
    }

    let start = Math.max(
      0,
      this.currentPage - Math.floor(this.numButtonsToShow / 2)
    );
    let end = start + this.numButtonsToShow - 1;

    if (end >= totalQuestionsInSection) {
      start -= end - (totalQuestionsInSection - 1);
      end = totalQuestionsInSection - 1;
    }

    start = Math.max(0, start);

    for (let i = start; i <= end; i++) {
      displayedPageRange.push(i);
    }

    this.displayedPageRange = displayedPageRange;
    return displayedPageRange;
  }

  // Wrapper used by the question-palette buttons. Persists any in-progress
  // CODING_TYPE / SQL_CODING response against the question being left, then
  // navigates. goToPage itself no longer saves (see comment inside it).
  navigateToPage(page: number): void {
    this.saveCodingResponseOnSwitch();
    this.goToPage(page);
  }

  goToPage(pageNumber: number, data?: string): void {
    console.log(pageNumber, 'page');
    this.clearPendingLoaderTimers();

    if (
      this.allQuestionsData?.questionType === 'IDE_TYPE' ||
      this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
    ) {
      this.loading = true;
    }
    if (
      (this.allQuestionsData?.questionType == 'VIDEO' ||
        this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION') &&
      this.isRecording
    ) {
      this.toastr.info(
        'Please record and Submit the video to proceed',
        'Error'
      );
      this.loading = false;
      return;
    }

    if (this.allQuestionsData?.questionType == 'AUDIO' && this.isRecording) {
      this.toastr.info(
        'Please record and Submit the audio to proceed',
        'Error'
      );
      this.loading = false;
      return;
    }

    // if (
    //   this.allQuestionsData?.questionType == 'VIDEO' ||
    //   this.allQuestionsData?.questionType == 'AUDIO' ||
    //   this.allQuestionsData?.questionType == 'TECHNICAL_QUESTION'
    // ) {
    //   this.compareAndLogObject(pageNumber);
    // }
    this.scrollToTop();
    if (
      pageNumber >= 0 &&
      pageNumber <
        this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar)
    ) {
      this.currentQuestionIndex = pageNumber;
      this.currentPage = pageNumber;
      this.getSubcategory();
      this.showLoaderForCurrentQuestion();
      if (!this.isCurrentSectionProgressive && !this.commonQuestionTime) {
        // this.nonProgressiveQuestionsList();
        this.optionsForQuestion = [];
        this.resetBooleanResponse();
        this.checkAndResetInput();
        this.checkAndResetTextAnswer();
      }
      setTimeout(() => {
        const type = this.allQuestionsData?.questionType;
        if (['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(type)) {
          this.getCodingLanguages();
          this.getCodingLanguageSelected();
        }
        // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
        //   // this.stopJupyterServer();
        //   // setTimeout(() => {
        //   //   this.toggleLanguageSelection(this.jupyterNotebookObject);
        //   // }, 1000);
        //   this.createJupyterServer();
        // }
        // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
        //   // if (data != 'attemptLater') {
        //   //   this.stopCodeServer();
        //   // } else {
        //   this.createCodeServerOnSwitch();
        //   // }
        // }
        // this.loading = false;
      }, this.timeoutDuration);
        this.resetCodingQuestion();
        this.goBackFromIDE();
        // Restore persisted compiled/test-case
        const idx = pageNumber;
        if (!this.compiledCodeMap) {
          this.compiledCodeMap = {};
        }

        if (idx != null && this.compiledCodeMap[idx] !== undefined) {
          this.compiledCode = this.compiledCodeMap[idx];
          this.visibleCorrectCases = this.visibleCorrectCasesMap[idx] || 0;
          this.visibleTestCaseCount = this.visibleTestCaseCountMap[idx] || 0;
          this.totalCorrectCases = this.totalCorrectCasesMap[idx] || 0;
        } else {
          this.compiledCode = null;
          this.visibleCorrectCases = 0;
          this.visibleTestCaseCount = 0;
          this.totalCorrectCases = 0;
        }
    }
    if (this.allQuestionsData?.questionType !== 'JUPYTER_NOTEBOOK' || this.allQuestionsData?.questionType !== 'IDE_TYPE') {
      this.loading = false;
    }
  }

  getNextRangeForProgressive(currentIndex: number) {
    if (currentIndex >= 0 && currentIndex <= this.totalProgressiveQuestions) {
      this.currentPage = currentIndex;
    }
  }

  openPopupForTotalQustions: boolean;
  openPopupForTotalQustion() {
    this.openPopupForTotalQustions = !this.openPopupForTotalQustions;
  }

  closeDropdownForTotalQuestions() {
    this.openPopupForTotalQustions = false;
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.checkScreenRatio(event.target.innerWidth);
  }
  checkScreenRatio(width) {
    if (width >= 280 && width <= 576) {
      this.numButtonsToShow = 5;
      // this.height=400;
    }
    if (width >= 577 && width <= 767) {
      this.numButtonsToShow = 8;
      // this.height=400;
    }
    if (width >= 768) {
      this.numButtonsToShow = 10;
      // this.height=400;
    }
  }

  chunks: Blob[] = [];
  // async setupMedia() {
  //   try {
  //     const constraints = {
  //       video: {
  //         aspectRatio: { ideal: 4 / 3, max: 4 / 3 },
  //         frameRate: { ideal: 5, max: 5 },
  //       },
  //       audio: true,
  //     };

  //     this.webFeedData = await navigator.mediaDevices.getUserMedia(constraints);

  //     const audioContext = new AudioContext();
  //     const voiceStream = await navigator.mediaDevices.getUserMedia({
  //       audio: { echoCancellation: true },
  //       video: false,
  //     });

  //     const userAudio = audioContext.createMediaStreamSource(voiceStream);
  //     const audioDestination = audioContext.createMediaStreamDestination();
  //     userAudio.connect(audioDestination);

  //     if (this.webFeedData.getAudioTracks().length > 0) {
  //       const displayAudio = audioContext.createMediaStreamSource(this.webFeedData);
  //       displayAudio.connect(audioDestination);
  //     }

  //     const videoTrack = this.webFeedData.getVideoTracks()[0];
  //     const { width, height } = videoTrack.getSettings();

  //     const resizedVideoStream = await this.resizeVideoStream(this.webFeedData);
  //     const newVideo = this.newStream;
  //     const newVideoTrack = newVideo.getVideoTracks()[0];
  //     const { width: newWidth, height: newHeight } = newVideoTrack.getSettings();

  //     const tracks = [
  //       ...resizedVideoStream.getVideoTracks(),
  //       ...audioDestination.stream.getTracks(),
  //     ];

  //     this.webFeedData = new MediaStream(tracks);

  //     // Use videoBitsPerSecond to control file size and ensure keyframes
  //     this.mediaRecorderForWebCam = new MediaRecorder(this.webFeedData, {
  //       mimeType: 'video/webm;codecs=vp8,opus', // Ensure compatible codec
  //       videoBitsPerSecond: 500000, // Adjust bitrate to control size (~500kbps)
  //     });

  //     // Shorter time slice for more frequent keyframes (2 seconds instead of 6)
  //     this.mediaRecorderForWebCam.start(2000);

  //     this.mediaRecorderForWebCam.ondataavailable = (event) => {
  //       if (event.data.size > 0) {
  //         console.log(`Chunk size: ${event.data.size} bytes`);
  //         this.chunks.push(event.data);

  //         if (this.shouldSendChunksForWebCam()) {
  //           if (this.isDesktopApp) {
  //             this.uploadVideoForWebCam('WEB_FEED');
  //           } else {
  //             console.log('14 uploadVideoForWebCamOnWeb');
  //             this.uploadVideoForWebCamOnWeb('WEB_FEED');
  //           }
  //         }
  //       }
  //     };

  //   } catch (error) {
  //     console.error('Error accessing camera:', error);
  //     // Handle errors...
  //   }
  // }
  async setupMedia() {
    try {
      const constraints = {
        video: {
          aspectRatio: { ideal: 4 / 3, max: 4 / 3 },
          frameRate: { ideal: 5, max: 5 },
        },
        audio: true,
      };
      this.webFeedData = await navigator.mediaDevices.getUserMedia(constraints);
      // this.webFeedData = await navigator.mediaDevices.getUserMedia({
      //   video: true,
      //   audio: true,
      // });
      const audioContext = new AudioContext();
      const voiceStream = await navigator.mediaDevices.getUserMedia({
        audio: { echoCancellation: true },
        video: false,
      });
      const userAudio = audioContext.createMediaStreamSource(voiceStream);
      const audioDestination = audioContext.createMediaStreamDestination();
      userAudio.connect(audioDestination);

      if (this.webFeedData.getAudioTracks().length > 0) {
        const displayAudio = audioContext.createMediaStreamSource(
          this.webFeedData
        );
        displayAudio.connect(audioDestination);
      }

      // Retrieve current aspect ratio and resolution
      const videoTrack = this.webFeedData.getVideoTracks()[0];
      const { width, height } = videoTrack.getSettings();
      const currentAspectRatio = width / height;

      const resizedVideoStream = await this.resizeVideoStream(this.webFeedData);
      // console.log(resizedVideoStream,'resized');

      const newVideo = this.newStream;
      // Retrieve the new aspect ratio and resolution after resizing
      const newVideoTrack = newVideo.getVideoTracks()[0];
      const { width: newWidth, height: newHeight } =
        newVideoTrack.getSettings();
      const newAspectRatio = newWidth / newHeight;
      const tracks = [
        ...resizedVideoStream.getVideoTracks(),
        ...audioDestination.stream.getTracks(),
      ];

      this.webFeedData = new MediaStream(tracks);
      this.mediaRecorderForWebCam = new MediaRecorder(this.webFeedData);

      this.mediaRecorderForWebCam.start(6000);
      // console.log("main starting webcam");

      this.mediaRecorderForWebCam.ondataavailable = (event) => {
        // console.log(event,"event");

        if (event.data.size > 0) {
          this.chunks.push(event.data);
          if (this.shouldSendChunksForWebCam()) {
            if (this.isDesktopApp) {
              this.uploadVideoForWebCam('WEB_FEED');
            } else {
              console.log('14 uploadVideoForWebCamOnWeb');

              this.uploadVideoForWebCamOnWeb('WEB_FEED');
            }
          }
        }
      };

      // this.mediaRecorderForWebCam.onstop = () => {
      //   const videoBuffer = new Blob(this.chunks, {
      //     type: 'video/webm',
      //   });
      //   let downloadUrl = window.URL.createObjectURL(videoBuffer);
      //   this.stopRecordingForWebCam();
      //   this.chunks = [];
      // };
    } catch (error: any) {
      console.error('Error accessing camera:', error);

      if (error.name === 'NotAllowedError') {
        // Permissions denied, offer the user the option to retry.
        // if (confirm('Permission to access camera and microphone was denied. Retry?')) {
        /*re enable of browser alert for permission not working*/
        //await this.startOverMediaAgain(); // Retry requesting permissions
        //}
      }
    }
  }

  newStream: any;
  async resizeVideoStream(videoStream) {
    const videoTrack = videoStream.getVideoTracks()[0];
    const { width, height } = videoTrack.getSettings();
    const standardAspectRatio = 16 / 9;
    let newWidth: any, newHeight: any;
    if (width / height > standardAspectRatio) {
      newWidth = height * standardAspectRatio;
      newHeight = height;
    } else {
      newWidth = width;
      newHeight = width / standardAspectRatio;
    }

    const canvas = Object.assign(document.createElement('canvas'), {
      width: newWidth,
      height: newHeight,
    });

    // Create a new MediaStream with the canvas as the source
    this.newStream = canvas.captureStream();

    const newStream = canvas.captureStream();
    newStream.addTrack(videoTrack);

    const clonedVideoTrack = videoTrack.clone();
    clonedVideoTrack.applyConstraints();

    const newStreamWithMimeType = new MediaStream([
      newStream.getVideoTracks()[1],
    ]);
    // const newStreamWithMimeType = new MediaStream([clonedVideoTrack]);
    return newStreamWithMimeType;
  }

  shouldSendChunksForWebCam() {
    const totalSize = this.chunks.reduce((acc, chunk) => acc + chunk.size, 0);
    // console.log(totalSize,'totalSize');

    return totalSize >= this.maxSize;
  }

  startRecordingForWebCam() {
    this.chunks = [];
    this.mediaRecorderForWebCam.start(this.mediaRecorderStarterTime);
  }

  stopRecordingForWebCam() {
    if (
      this.mediaRecorderForWebCam &&
      this.mediaRecorderForWebCam.state !== 'inactive'
    ) {
      this.mediaRecorderForWebCam.stop();
      this.webFeedData.getTracks().forEach((obj) => obj.stop());
    }
  }

  //   uploadVideoForWebCam(chunkType: ChunkType | any) {
  //     if (this.isApiRequestPending) {
  //       // this.chunks = [];
  //       return;
  //     }

  //     console.log("Chunks before saving:", this.chunks);

  //     // const recordedBlob = new Blob(this.chunks, { type: "video/webm" });
  //     // console.log("Recorded Blob size:", recordedBlob);
  //     const reader = new FileReader();
  //     // reader.onload = () => {
  //     //   const buffer = reader.result;

  //     //   if (window.electron) {
  //     //     window.electron.ipcRenderer.send("save-video", buffer);
  //     //   }
  //     // };
  //     // reader.readAsArrayBuffer(recordedBlob);

  //     const recordedBlob = new Blob(this.chunks, { type: "video/webm" });
  // console.log("Recorded Blob size:", recordedBlob);

  // recordedBlob.arrayBuffer().then((buffer) => {
  //   const byteArray = new Uint8Array(buffer);
  // console.log(byteArray,'byteArray');

  //   if (window.electron) {
  //     window.electron.ipcRenderer.send("save-video", byteArray);
  //   }
  // });

  //     if (this.mediaAccessService.isNetworkConnectionEnabled()) {

  //       this.electronService.onVideoChunk((chunk) => {
  //         console.log("Received video chunk from Electron:", chunk);
  //         this.webFeedChunk = chunk;
  //       });

  //       this.electronService.onVideoChunkEnd(() => {
  //         console.log("Upload complete!");
  //       });

  //       this.electronService.onVideoChunkError((error) => {
  //         console.error("Error reading video:", error);
  //       });

  //       const formData = new FormData();
  //       const fileData = new File([this.webFeedChunk], "file", { type: "video/webm" });
  //       console.log("file:", fileData);
  //       formData.append("file", fileData);

  //       const isEmpty = this.isFormDataEmpty(formData);
  //       console.log(formData, "formData11");

  //       if (
  //         (!isEmpty && this.startedExamination) ||
  //         (!isEmpty && this.breakTimeScreen)
  //       ) {
  //         this.isApiRequestPending = true;
  //         // this.chunks = [];

  //         this._examinationService
  //           .saveChunkVideos(formData, this.sequenceForWebcam, chunkType)
  //           .subscribe(
  //             (res) => {
  //               if (res && res.statusCode == HttpStatusCode.Ok) {
  //                 this.chunks = [];
  //                 this.lastApiResponseSuccess = true;
  //                 this.makeApiCall = true;
  //                 this.sequenceForWebcam++;
  //                 this.stopAndRestartMediaRecorder();
  //               } else {
  //                 this.lastApiResponseSuccess = false;
  //                 this.makeApiCall = false;
  //                 this.checkPendingApiStatus(chunkType);
  //               }
  //             },
  //             (error) => {
  //               this.isApiRequestPending = false;
  //               this.makeApiCall = true;
  //               this.lastApiResponseSuccess = false;
  //               this.checkPendingApiStatus(chunkType);
  //               if (!this.isRecordedChunkMissed) {
  //                 console.error("API error:", error);
  //                 this.isRecordedChunkMissed = true;
  //                 this.sendSlowInternetSpeed(
  //                   this.isRecordedChunkMissed,
  //                   this.driveData
  //                 );
  //               }
  //             },
  //             () => {
  //               this.isApiRequestPending = false;
  //               this.scheduleNextApiCall(chunkType);
  //             }
  //           );
  //       }
  //     } else {
  //       this.chunks = [];
  //     }
  //   }
  //////////////////////////////

  // uploadVideoForWebCamOnWeb(chunkType: ChunkType | any) {
  //   if (this.isLiteAppVersion) {
  //     return;
  //   }

  //   if (this.isApiRequestPending) {
  //     this.chunks = [];
  //     return;
  //   }
  //   const recordedBlob = new Blob(this.chunks, { type: 'video/webm' });
  //   const file = new File([recordedBlob], 'file', { type: recordedBlob.type });
  //   const videoUrl = URL.createObjectURL(recordedBlob);

  //   // Create a download link for the recorded file.
  //   const url = window.URL.createObjectURL(recordedBlob);
  //   // const a = document.createElement('a');
  //   // a.style.display = 'none';
  //   // a.href = url;
  //   // a.download = 'webFeed-video.webm';
  //   // document.body.appendChild(a);
  //   // a.click();
  //   // window.URL.revokeObjectURL(url);
  //   // document.body.removeChild(a);
  //   //////////////////////////////////

  //   if (this.mediaAccessService.isNetworkConnectionEnabled()) {
  //     const formData = new FormData();
  //     formData.append('file', file);
  //     let fileSize = file.size;
  //     let contentType = file.type;
  //     const isEmpty = this.isFormDataEmpty(formData);
  //     if (
  //       (!isEmpty && this.startedExamination) ||
  //       (!isEmpty && this.breakTimeScreen)
  //     ) {
  //       this.isApiRequestPending = true;
  //       this.chunks = [];
  //       this._examinationService
  //         .saveChunkVideos(
  //           file,
  //           this.sequenceForWebcam,
  //           chunkType,
  //           fileSize,
  //           contentType
  //         )
  //         .subscribe(
  //           (res) => {
  //             if (res && res.status == HttpStatusCode.Ok) {
  //               this.chunks = [];
  //               this.lastApiResponseSuccess = true;
  //               this.makeApiCall = true;
  //               // if (this.mediaRecorderForWebCam?.state === 'recording') {
  //               // this.mediaRecorderForWebCam!.stop();
  //               // }
  //               this.sequenceForWebcam++;
  //               // this.stopAndRestartMediaRecorder();
  //               // setTimeout(() => {
  //               //   this.mediaRecorderForWebCam!.start(
  //               //     this.mediaRecorderStarterTime
  //               //   ); // Start a new recording
  //               // }, 500);

  //               // if (this.mediaRecorderForWebCam.state === 'inactive') {
  //               //   this.mediaRecorderForWebCam.start(6000);
  //               // }
  //               if (this.mediaRecorderForWebCam?.state === 'recording') {
  //                 this.mediaRecorderForWebCam.stop();

  //                 this.mediaRecorderForWebCam.onstop = async () => {
  //                   if (this.chunks.length > 0) {
  //                     this.chunks = [];
  //                   }

  //                   // restart
  //                   if (this.mediaRecorderForWebCam.state === 'inactive') {
  //                     console.log('inside inactive');
  //                     console.log(this.mediaRecorderForWebCam.state);
  //                     this.mediaRecorderForWebCam.start(6000);
  //                   }
  //                 };
  //               }
  //             } else {
  //               this.lastApiResponseSuccess = false;
  //               this.makeApiCall = false;
  //               this.checkPendingApiStatus(chunkType);
  //             }
  //           },
  //           (error) => {
  //             this.isApiRequestPending = false;
  //             this.makeApiCall = true;
  //             this.lastApiResponseSuccess = false;
  //             this.checkPendingApiStatus(chunkType);
  //             if (!this.isRecordedChunkMissed) {
  //               console.error('API error:', error);
  //               this.isRecordedChunkMissed = true;
  //               this.sendSlowInternetSpeed(
  //                 this.isRecordedChunkMissed,
  //                 this.driveData
  //               );
  //             }
  //           },
  //           () => {
  //             this.isApiRequestPending = false;
  //             this.scheduleNextApiCall(chunkType);
  //           }
  //         );
  //     }
  //   } else {
  //     this.chunks = [];
  //   }
  // }

  async uploadVideoForWebCamOnWeb(chunkType: ChunkType | any) {
    if (this.isLiteAppVersion || this.isApiRequestPending) {
      this.chunks = [];
      return;
    }

    const recordedBlob = new Blob(this.chunks, { type: 'video/webm' });
    const file = new File([recordedBlob], 'file', { type: recordedBlob.type });
    const sequence = this.sequenceForWebcam;

    // Save chunk to IndexedDB
    await this.videoUploaderService.saveWebcamChunk(sequence, recordedBlob);
    // const uploadChunk = async (retryCount = 0) => {
    if (!this.mediaAccessService.isNetworkConnectionEnabled()) {
      this.chunks = [];
      return;
    }

    const formData = new FormData();
    formData.append('file', file);
    const fileSize = file.size;
    const contentType = file.type;

    if (
      (!this.isFormDataEmpty(formData) && this.startedExamination) ||
      (!this.isFormDataEmpty(formData) && this.breakTimeScreen)
    ) {
      this.isApiRequestPending = true;
      this._examinationService
        .saveChunkVideos(file, sequence, chunkType, fileSize, contentType)
        .subscribe(
          async (res) => {
            if (
              res &&
              (res.status === HttpStatusCode.Ok ||
                res.statusCode === HttpStatusCode.Ok)
            ) {
              console.log('successfully uploaded chunk', res);

              this.lastApiResponseSuccess = true;
              this.makeApiCall = true;
              this.sequenceForWebcam++;
              await this.videoUploaderService.deleteWebcamChunk(sequence);
              this.chunks = [];
              this.stopAndRestartMediaRecorderForWebFeed();
            } else {
              console.log('Failed to upload chunk', sequence);
              this.lastApiResponseSuccess = false;
              this.makeApiCall = false;
              this.checkPendingApiStatus(chunkType);
            }
          },
          async (error) => {
            this.lastApiResponseSuccess = true;
            this.isApiRequestPending = false;
            this.makeApiCall = true;
            this.chunks = [];
            this.sequenceForWebcam++;
            this.stopAndRestartMediaRecorderForWebFeed();
            // this.checkPendingApiStatus(chunkType);

            // if (retryCount < 2) {
            //   console.warn(
            //     `Retrying chunk ${sequence}, attempt ${retryCount + 1}`
            //   );
            //   await uploadChunk(retryCount + 1);
            // } else {
            //   console.error(
            //     `Failed to upload chunk ${sequence} after 3 attempts`
            //   );
            //   this.sequenceForWebcam++;
            // }

            if (!this.isRecordedChunkMissed) {
              this.isRecordedChunkMissed = true;
              this.sendSlowInternetSpeed(
                this.isRecordedChunkMissed,
                this.driveData
              );
            }
          },
          () => {
            this.isApiRequestPending = false;
            this.scheduleNextApiCall(chunkType);
          }
        );
    }
    // };

    // await uploadChunk();
  }

  async readFileAsBlob(filePath: string): Promise<Blob> {
    return new Promise((resolve, reject) => {
      window.electron.ipcRenderer
        .invoke('read-video-file', filePath)
        .then((buffer: ArrayBuffer) => {
          if (!buffer || buffer.byteLength === 0) {
            return reject(new Error('Failed to read video file: Empty buffer'));
          }
          const blob = new Blob([buffer], { type: 'video/webm' });
          resolve(blob);
        })
        .catch((error) => {
          console.error('Error reading video file:', error);
          reject(error);
        });
    });
  }

  // downloadFile(blob: Blob, filename: string) {
  //   const url = window.URL.createObjectURL(blob);
  //   const a = document.createElement('a');
  //   a.style.display = 'none';
  //   a.href = url;
  //   a.download = filename;
  //   document.body.appendChild(a);
  //   a.click();
  //   window.URL.revokeObjectURL(url);
  //   document.body.removeChild(a);
  // }

  uploadedFilesSet = new Set<string>();
  isFirstChunkUploading: boolean = true;
  async uploadVideoForWebCam(chunkType: ChunkType | any) {
    if (this.isApiRequestPending) {
      return;
    }

    if (!this.chunks.length) {
      console.warn('No video chunks to upload.');
      return;
    }

    const chunksToUpload = [...this.chunks];
    this.chunks = [];

    if (
      !chunksToUpload.length ||
      chunksToUpload.every((chunk) => chunk.size === 0)
    ) {
      console.error(
        'Recorded chunks are empty! Skipping web feed chunks upload.'
      );
      return;
    }

    const recordedBlob = new Blob(chunksToUpload);

    if (recordedBlob.size === 0) {
      console.error('Recorded blob is empty! Skipping upload.');
      return;
    }

    try {
      const buffer = await recordedBlob.arrayBuffer();
      const byteArray = new Uint8Array(buffer);

      if (window.electron) {
        // console.log('Sending video chunk to Electron:', byteArray.length);
        window.electron.ipcRenderer.send('save-video', byteArray);
      }

      this.stopAndRestartMediaRecorderForWebFeed();

      try {
        const videoFiles = await window.electron.ipcRenderer.invoke(
          'get-saved-videos'
        );

        if (!videoFiles.length) {
          console.log('No saved videos found.');
          return;
        }

        if (
          this.mediaAccessService.isNetworkConnectionEnabled() &&
          !this.isLiteAppVersion
        ) {
          if (this.isFirstChunkUploading) {
            console.log(
              'Skipping upload for the first chunk to verify saving.'
            );
          } else {
            const indexToUpload = videoFiles.length - 2;
            if (indexToUpload >= 0) {
              const filePath = videoFiles[indexToUpload];

              if (!this.uploadedFilesSet.has(filePath)) {
                const videoBlob = await this.readFileAsBlob(filePath);

                await this.uploadVideoToServer(
                  videoBlob,
                  ChunkType.WEB_FEED,
                  filePath
                );

                this.uploadedFilesSet.add(filePath);
              }
            } else {
              console.log('Not enough saved chunks to upload.');
            }
          }
        }
      } catch (error) {
        console.error('Error fetching saved videos:', error);
      }

      this.isFirstChunkUploading = false;
      // this.stopAndRestartMediaRecorderForWebFeed();
    } catch (error) {
      console.error('Error processing video:', error);
    }
  }

  async uploadVideoToServer(
    videoBlob: Blob,
    chunkType: ChunkType,
    filePath: any
  ) {
    const newFormData = new FormData();
    const fileData = new File([videoBlob], 'file', { type: 'video/webm' });
    newFormData.append('file', fileData);

    // console.log(filePath, 'filePath');

    if (this.shouldUploadVideo(newFormData)) {
      if (this.apiPriorityService.isHighPriorityActive()) {
        this.apiPriorityService.queueVideoUpload(
          videoBlob,
          chunkType,
          filePath
        );
      } else {
        await this.processQueuedVideoUpload(videoBlob, chunkType, filePath);
      }
    }
  }

  async processQueuedVideoUpload(
    videoBlob: Blob,
    chunkType: ChunkType,
    filePath: any
  ) {
    const newFormData = new FormData();
    const fileData = new File([videoBlob], 'file', { type: 'video/webm' });
    let fileSize = videoBlob.size;
    let contentType = fileData.type;
    newFormData.append('file', fileData);
    // let i = 0;

    //    // Create a download link for testing
    //    this.downloadFile(videoBlob, `recorded-video-${i}.webm`);
    // i++;
    try {
      this.isApiRequestPending = true;
      const response = await this._examinationService
        .saveChunkVideos(
          fileData,
          this.sequenceForWebcam,
          chunkType,
          fileSize,
          contentType
        )
        .toPromise();

      this.handleUploadResponse(response, chunkType, filePath);
    } catch (error) {
      this.handleUploadError(error, chunkType);
    } finally {
      this.isApiRequestPending = false;
    }
  }

  // Helper method to determine if upload should proceed
  shouldUploadVideo(formData: FormData): boolean {
    const isEmpty = this.isFormDataEmpty(formData);
    return (
      (!isEmpty && this.startedExamination) ||
      (!isEmpty && this.breakTimeScreen)
    );
  }

  // Handle successful upload response
  handleUploadResponse(response: any, chunkType: ChunkType, filePath: any) {
    if (
      response &&
      (response.statusCode === HttpStatusCode.Ok ||
        response.status === HttpStatusCode.Ok)
    ) {
      this.lastApiResponseSuccess = true;
      this.makeApiCall = true;
      this.sequenceForWebcam++;

      setTimeout(() => {
        window.electron.ipcRenderer.invoke('delete-video-chunk', filePath);
      }, 5000);

      this.stopAndRestartMediaRecorderForWebFeed();
    } else {
      this.lastApiResponseSuccess = false;
      this.makeApiCall = false;
      this.checkPendingApiStatus(chunkType);
    }
  }

  // Handle upload errors
  handleUploadError(error: any, chunkType: ChunkType) {
    this.makeApiCall = true;
    this.lastApiResponseSuccess = false;
    this.checkPendingApiStatus(chunkType);

    if (!this.isRecordedChunkMissed) {
      console.error('API upload error:', error);
      this.isRecordedChunkMissed = true;
      this.sendSlowInternetSpeed(this.isRecordedChunkMissed, this.driveData);
    }
  }

  checkPendingApiStatus(chunkType?: ChunkType | any) {
    if (this.isApiRequestPending) {
      setTimeout(() => {
        this.checkPendingApiStatus(chunkType);
      }, 10000);
    } else {
      this.scheduleNextApiCall(chunkType);
    }
  }

  scheduleNextApiCall(chunkType?: ChunkType | any) {
    if (this.makeApiCall) {
      setTimeout(() => {
        if (chunkType == 'WEB_FEED') {
          if (this.shouldSendChunksForWebCam()) {
            if (this.isDesktopApp) {
              this.uploadVideoForWebCam('WEB_FEED');
            } else {
              console.log('10 uploadVideoForWebCamOnWeb');

              this.uploadVideoForWebCamOnWeb('WEB_FEED');
            }
          }
        } else {
          setTimeout(() => {
            if (this.shouldSendChunks()) {
              if (this.isDesktopApp) {
                this.uploadVideo();
              } else {
                this.uploadScreenVideoOnWeb();
              }
            }
          }, 300);
        }
      }, 10000);
    } else {
      this.scheduleNextApiCall(chunkType);
    }
  }

  getExtentionDisabled() {
    setTimeout(() => {
      let disableExtension = document.getElementById(
        'extension-installed-indicator'
      );
      if (disableExtension) {
        disableExtension.click();
      }
    }, 1000);
  }

  isRefreshpopup: any;
  handleF5Pressed(isF5Pressed: boolean): void {
    this.isRefreshpopup = isF5Pressed;
    console.log('F5 key pressed:', this.isRefreshpopup);
  }

  getAlphabeticalQuestionCount(index: number): string {
    return String.fromCharCode(65 + index);
  }

  // ???????????/////////////////////////////////////////
  getMergeChunksFilesExamination() {
    this._examinationService
      .getMergeChunksFilesExamination()
      .subscribe((res) => {
        if (res.statusCode === HttpStatusCode.Ok) {
        }
      });
  }

  openDetailsPopup: boolean;
  @ViewChild('videoPlayer') videoElement: ElementRef | undefined;
  currentChunkIndex = 0;
  openUploadDetails: any;
  combinedVideoUrl: string;
  combinedMobileFeedUrl: string;
  byteArrays: FileDocumentDto[] = [];
  getVideoPathOfExamination() {
    this._examinationService.getVideoPathOfExamination().subscribe((res) => {
      this.combinedVideoUrl = res.data['SCREEN_SHARE'];
      this.combinedMobileFeedUrl = res.data['MOBILE_FEED'];
    });
  }

  mediaRecorderVideo: MediaRecorder;
  recordedChunksFile: Blob[] = [];
  isRecording = false;
  videoStopTimeout: any;
  recorderOne = true;
  recordingTime = 0;
  audioRecordingTime = 0;
  recordingInterval: any;
  audioRecordingInterval: any;
  recordedVideo: boolean = false;

  startRecordingVideo() {
    this.emptyRecordedFilePreviewUrl();
    this.recordedVideoAns = false;
    this.recordedAudioTime = null;
    this.recorderOne = false;
    this.vedioAnsId = '';
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: true })
      .then((stream) => {
        const videoPlayer = document.getElementById(
          'videoPlayer'
        ) as HTMLVideoElement;
        this.recordedChunksFile = [];
        videoPlayer.srcObject = stream;

        setTimeout(() => {
          navigator.mediaDevices
            .getUserMedia({ video: true, audio: false })
            .then((showstream) => {
              this.displayVideoElement.nativeElement.srcObject = showstream;
            })
            .catch((error) => {
              console.error('Error accessing camera:', error);
              // Handle error, e.g., show an alert to the user
            });

          // this.displayVideoElement.nativeElement.srcObject = stream;
        }, 1000);
        this.mediaRecorderVideo = new MediaRecorder(stream);

        this.mediaRecorderVideo.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.recordedChunksFile.push(event.data);
          } else {
            console.warn('Empty chunk received, might be network delay');
          }
        };

        if (this.verifyUserResponseModal) {
          this.mediaRecorderVideo.onstop = () => {
            setTimeout(() => {
              this.handleExplainRecordingStop();
            }, 500);
          };

          this.videoStopTimeout = setTimeout(() => {
            this.stopRecordingVideo();
          }, this.maxExplainRecordingTime * 1000); // explain/verify-response max time
        } else {
          this.mediaRecorderVideo.onstop = () => {
            setTimeout(() => {
              this.handleRecordingStop();
            }, 500);
          };

          this.videoStopTimeout = setTimeout(() => {
            this.stopRecordingVideo();
          }, this.maxVideoRecordingTime * 1000); // video answer max time
        }

        this.recordingInterval = setInterval(() => {
          this.recordingTime++;
        }, 1000);

        this.mediaRecorderVideo.start();
        this.isRecording = true;
      })
      .catch((error) => {
        console.error('Error accessing camera:', error);
      });
  }

  recordedAudioTime: any;
  formatTime(seconds: number): string {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    const formattedMinutes = minutes < 10 ? `0${minutes}` : `${minutes}`;
    const formattedSeconds =
      remainingSeconds < 10 ? `0${remainingSeconds}` : `${remainingSeconds}`;
    return `${formattedMinutes}:${formattedSeconds}`;
  }

  recordedVideoAns: boolean = false;
  stopRecordingVideo() {
    if (
      this.mediaRecorderVideo &&
      this.mediaRecorderVideo.state !== 'inactive'
    ) {
      this.recordedVideoAns = true;
      this.mediaRecorderVideo.stop();
      this.isRecording = false;
      this.recordingTime = 0;
      clearTimeout(this.videoStopTimeout);
      clearInterval(this.recordingInterval);
      this.mediaRecorderVideo = null;
    }
  }

  fileInformationList: { filePreviewUrl: string; currentQuestionIndex: any }[] =
    [];
  videoUrlForVideoQuestion: any;
  recordedVideosList: {
    formData: FormData;
    questionId: string;
    sectionQuestionId: string;
  }[] = [];
  async handleRecordingStop() {
    // this.loading = true;
    this.openPopUpForVideoQuestion = true;
    this.startTimerForVideoQuestion(60);
    const videoBlob = new Blob(this.recordedChunksFile, { type: 'video/webm' });
    const videoUrl = URL.createObjectURL(videoBlob);
    var file = new File([videoBlob], 'file', { type: videoBlob.type });
    const formData: FormData = new FormData();
    formData.append('file', file);
    // this.downloadFile(file,'videooo');

    const videoPlayer = document.getElementById(
      'videoPlayer'
    ) as HTMLVideoElement;

    if (!this.autoSubmitExam) {
      videoPlayer.src = videoUrl;
    }
    // this.videoUrlForVideoQuestion = URL.createObjectURL(videoBlob);

    const existingIndex = this.fileInformationList.findIndex(
      (obj) => obj.currentQuestionIndex === this.currentQuestionIndex
    );

    if (existingIndex !== -1) {
      this.fileInformationList[existingIndex] = {
        filePreviewUrl: videoUrl,
        currentQuestionIndex: this.currentQuestionIndex,
      };
    } else {
      this.fileInformationList.push({
        filePreviewUrl: videoUrl,
        currentQuestionIndex: this.currentQuestionIndex,
      });
    }

    localStorage.setItem(
      'fileInformationList',
      JSON.stringify(this.fileInformationList)
    );

    const questionId = this.userAssessmentDriveSetIdForVideo;
    const sectionQuestionId = this.allQuestionsData.sectionQuestionId;
    console.log(this.isLiteAppVersion, 'this.isLiteAppVersion');
    this.recordedVideosList.push({
      formData,
      questionId,
      sectionQuestionId,
    });

    const serializableVideoList = await Promise.all(
      this.recordedVideosList.map(async (videoData) => {
        const blob = videoData.formData.get('file') as Blob;
        const base64 = await this.convertBlobToBase64(blob);
        return {
          base64Video: base64,
          mimeType: blob.type,
          fileName: 'file.webm',
          questionId: videoData.questionId,
          sectionQuestionId: videoData.sectionQuestionId,
        };
      })
    );

    // sessionStorage.setItem(
    //   'pendingVideoQuestion',
    //   JSON.stringify(serializableVideoList)
    // );
    this.videoUploaderService?.setItem(
      'pendingVideoQuestion',
      serializableVideoList
    );
    if (this.isLiteAppVersion) {
      this.selectedAnswer(null, this.currentQuestionIndex, null);
      this.getOptionSelectedOrNot(null, this.currentQuestionIndex, null);
      this.openPopUpForVideoQuestion = false;
      clearInterval(this.timerForVideoQuestion);

      if (this.autoSubmitExam) {
        this.autoSubmitForVideoQuestions();
      }
    } else {
      this._examinationService
        .videoSaveAssessment(
          file,
          this.userAssessmentDriveSetIdForVideo,
          this.allQuestionsData.sectionQuestionId
        )
        .subscribe(
          (res) => {
            // Handle success
            this.vedioAnsId = res?.data?.fileId;
            this.selectedAnswer(
              null,
              this.currentQuestionIndex,
              this.vedioAnsId
            );
            this.getOptionSelectedOrNot(
              null,
              this.currentQuestionIndex,
              this.vedioAnsId
            );

            if (
              res &&
              (res.statusCode === HttpStatusCode.Ok ||
                res.status === HttpStatusCode.Ok)
            ) {
              const storedVideoQuestion = this.videoUploaderService?.getItem(
                'pendingVideoQuestion'
              );
              if (storedVideoQuestion) {
                this.videoUploaderService?.deleteItem('pendingVideoQuestion');
              }
              this.openPopUpForVideoQuestion = false;
              clearInterval(this.timerForVideoQuestion);
              if (this.autoSubmitExam) {
                this.openPopUp = false;
                this.autoSubmitForVideoQuestions();
              }
            }
            // setTimeout(() => {
            //   const videoUrl = URL.createObjectURL(videoBlob);
            //     const videoPlayer = document.getElementById(
            //       'videoPlayer'
            //     ) as HTMLVideoElement;
            //     videoPlayer.src = videoUrl;
            // }, 2000);
          },
          (error) => {
            this.openPopUpForVideoQuestion = false;
            clearInterval(this.timerForVideoQuestion);
            if (this.autoSubmitExam) {
              this.autoSubmitForVideoQuestions();
            }
            console.error('API error:', error);
          }
        );
    }
  }

  submitAllRecordedVideos() {
    this.recordedVideosList.forEach((videoData) => {
      this._examinationService
        .videoSaveAssessment(
          videoData.formData,
          videoData.questionId,
          videoData.sectionQuestionId
        )
        .subscribe(
          (res) => {
            console.log('Video submitted:', res);
          },
          (error) => {
            console.error('Video submission failed:', error);
          }
        );
    });
  }

  autoSubmitForVideoQuestions() {
    // if (this.isLiteAppVersion) {
    //   const currentSectionData = {
    //     sequence: this.allQuestionsDataForTopBar.sequence,
    //     sectionStatus: 'SECTION_AUTO_SUBMIT',
    //     sectionQuestionList: [...this.subSectionDto.sectionQuestionList],
    //   };
    //   this.liteSectionResponses[this.offlineSectionIndex] = currentSectionData;
    //   this.submitAllSectionsForLiteVersion();
    // } else {
      if (this.isCurrentSectionProgressive) {
        this.progressiveQuestionsList();
        this.submitTestForprogressiveAssessment();
      } else {
        this.nonProgressiveQuestionsList();
        this.submitTest();
      }
    // }
  }

  isFormDataEmpty(formData) {
    // Using entries() method to get an iterator over key/value pairs
    const formDataIterator = formData.entries();
    // Check if there are any entries
    const firstEntry = formDataIterator.next();
    // If the first entry exists, the FormData is not empty
    return firstEntry.done;
  }

  recordedFilePreviewUrl: any;
  compareAndLogObject(currentQuestionId: any) {
    const matchingObject = this.fileInformationList.find(
      (obj) => obj.currentQuestionIndex === currentQuestionId
    );

    if (matchingObject) {
      this.recordedFilePreviewUrl = matchingObject.filePreviewUrl;
    } else {
      console.log(
        'No matching object found for the current question ID:',
        currentQuestionId
      );
      this.recordedFilePreviewUrl = '';
    }
  }

  emptyRecordedFilePreviewUrl() {
    const currentQuestionIndex = this.currentQuestionIndex;
    this.recordedFilePreviewUrl = '';
    // Find the index of the current question in fileInformationList
    const index = this.fileInformationList.findIndex(
      (obj) => obj.currentQuestionIndex === currentQuestionIndex
    );
    // Empty recordedFilePreviewUrl if the index is found
    if (index !== -1) {
      this.fileInformationList[index].filePreviewUrl = '';
      this.recordedVideo = false;
    }
  }

  keyPressTimestamp: number;
  windowWarningCount: number = 0;
  altKeyPressed: boolean = false;
  ctrlKeyPressed: boolean = false;
  @HostListener('document:keydown', ['$event'])
  handleKeyDown(event: KeyboardEvent) {
    const mod = event.ctrlKey || event.metaKey;
    const key = event.key.toLowerCase();
    if (event.key === 'Alt') {
      this.altKeyPressed = true;
    }
    if (event.key === 'Control') {
      this.ctrlKeyPressed = true;
    }
    const conditions =
    (this.startedExamination || this.breakTimeScreen) &&
    (this.networkConnection || this.isLiteAppVersion);

  if (conditions && event.key === 'Tab' && (event.altKey || event.ctrlKey)) {
    this.getWindowRestrictModal();
  }
  else if (mod && key === 's') {
    this.toastr.info('', 'Saving or downloading this page is not allowed.');
    event.cancelBubble = true;
    event.preventDefault();
    event.stopImmediatePropagation();
    return;
  }

  else if (mod && key === 'p') {
    this.toastr.info(
      '',
      'This section is not allowed to print or export to PDF'
    );
    event.cancelBubble = true;
    event.preventDefault();
    event.stopImmediatePropagation();
  }
  }

  @HostListener('document:keyup', ['$event'])
  handleKeyUp(event: KeyboardEvent) {
    const conditions =
    (this.startedExamination || this.breakTimeScreen) &&
    (this.networkConnection || this.isLiteAppVersion);
    if (conditions && event.key === 'Tab' && (event.altKey || event.ctrlKey)) {
      this.getWindowRestrictModal();
    }
    // if (event.key === 'Alt') {
    //   this.altKeyPressed = false;
    // }
    // if (event.key === 'Control') {
    //   this.ctrlKeyPressed = false;
    // }
    // if (
    //   this.altKeyPressed &&
    //   event.key === 'Tab' &&
    //   (this.startedExamination || this.breakTimeScreen) &&
    //   (this.networkConnection || this.isLiteAppVersion)
    // ) {
    //   this.getWindowRestrictModal();
    // }

    // if (
    //   this.ctrlKeyPressed &&
    //   event.key === 'Tab' &&
    //   (this.startedExamination || this.breakTimeScreen) &&
    //   (this.networkConnection || this.isLiteAppVersion)
    // ) {
    //   this.getWindowRestrictModal();
    // }
  }

  calculateTimeDifference() {
    if (this.focusOutTime && this.focusInTime) {
      let timeDifference = Math.abs(
        this.focusInTime.getTime() - this.focusOutTime.getTime()
      );
      this.timeDifference = timeDifference / 1000;
    }
  }

  changeWindowWarning: boolean;
  getWindowRestrictModal() {
    if (this.windowWarningCount === 0) {
      this.windowWarningCount++;
      // this.mobileConnectionModal = false;
      this.changeWindowWarning = true;
    } else if (this.windowWarningCount === 1) {
      this.windowWarningCount++;
      this.changeWindowWarning = false;
      this.modalConfirmation.heading =
        'You cannot change the windows while taking the Examination.';
      // this.mobileConnectionModal = false;
      this.autoSubmitAssessment = true;
      this.breakTimeScreen = false;
      this.openPopUp = true;
      this.openConfirmationPopup = false;
      this.scanQRCodeModal = false;
      this.startTimerForFifteenSeconds();
    }
  }

  async startRecordingAndAskForPermission() {
    // if (this.mediaRecorder) {
    //   this.mediaRecorder.stop();
    //   this.recordedChunks = [];
    // }
    this.openConfirmationPopup = false;
    await this.askForPermission();
    this.startRecording();
  }

  stopScreenShareManually: boolean;
  stopScreenAndSubmit() {
    this.stopScreenShareManually = true;
    this.stopScreenShare = false;
    this.modalConfirmation.heading =
      this._commonService.Enums.DISABLE_SCREEN_SHARE_TEXT_NOT_POSSIBLE;
    this.autoSubmitAssessment = true;
    this.breakTimeScreen = false;
    // this.mobileConnectionModal = false;
    this.openPopUp = true;
    this.openConfirmationPopup = false;
    this.startTimerForFifteenSeconds();

    if (this.stopScreenShareManually) {
      this.stopScreenAndFeed();
    }
  }

  stopScreenAndFeed() {
    this.screenShareData = null;
    this.stopStatusCheck = true;
    this.stopRecording();
    this.recordedChunks = [];
  }

  enlargedImageUrl: string;
  isEnlargeImage: boolean;
  openImageModal(imageUrl: string) {
    this.isEnlargeImage = true;
    this.enlargedImageUrl = imageUrl;
  }

  closeEnlargedImage() {
    this.isEnlargeImage = false;
  }

  languageModal: boolean = false;
  selectCodeLanguage: boolean;
  codeEditor: boolean;

  openLanguageModal() {
    this.languageModal = !this.languageModal;
  }

  closeLanguageDropdown() {
    this.languageModal = false;
  }

  selectedLanguage: string;
  selectedLanguageId: string;
  jupyterNotebookEnabled: boolean;
  // Map a coding language id to the correct CodeMirror mode so highlighting
  // and indentation match the selected language (C/C++/C# /Java use clike).
  getCodeMirrorMode(languageId: string): string {
    switch (String(languageId)) {
      case '110': // C
        return 'text/x-csrc';
      case '105': // C++
        return 'text/x-c++src';
      case '51': // C#
        return 'text/x-csharp';
      case '62': // Java
        return 'text/x-java';
      case '92': // Python 3
      case '70': // Python 2
        return 'python';
      case '82': // SQL
        return 'sql';
      default:
        return this.editorMode || 'javascript';
    }
  }

  // Update the editor mode (and trigger CodeMirror to re-apply it) for a language.
  updateEditorMode(languageId: string): void {
    const mode = this.getCodeMirrorMode(languageId);
    this.editorMode = mode;
    this.editorOptions = { ...this.editorOptions, mode };
  }

  toggleLanguageSelection(selectedLanguage: any) {
    // Save current language's code before switching (per-language code persistence)
    if (this.selectedLanguageId && this.code != null && this.code !== '') {
      const questionObj = this.allQuestions[this.currentQuestionIndex];
      if (!questionObj.languageCodeMap) questionObj.languageCodeMap = {};
      questionObj.languageCodeMap[this.selectedLanguageId] = this.code;
    }
    this.codingLanguages.forEach((language) => (language.selected = false));
    selectedLanguage.selected = true;
    this.selectCodeLanguage = false;
    this.selectedLanguage = selectedLanguage.name;
    this.selectedLanguageId = selectedLanguage.id;
    this.updateEditorMode(selectedLanguage.id);
    this.allQuestions[this.currentQuestionIndex].selectedLanguage =
      selectedLanguage;
    if (selectedLanguage.id === '01') {
      this.codeEditor = false;
      this.jupyterNotebookEnabled = true;
    } else {
      this.jupyterNotebookEnabled = false;
      this.codeEditor = true;
    }
    this.languageModal = false;
    if((this.allQuestionsData?.questionType === 'SQL_CODING' || this.allQuestionsData?.questionType === 'CODING_TYPE')) {
              this.inputBoilerCode();
    }
    // TODO: REMOVE LATER - Custom refresh logic for drive_id 102980 and 244403 and 239424 and 239424 in toggleLanguageSelection
    // Refresh language options for other questions after selection (for drive_id 102980, 244403)
    // Delay to ensure boilerplate code generation completes first
    if (['102980', '244403', '239424','715158'].includes(this.driveData) && this.allQuestionsData?.questionType === 'CODING_TYPE') {
      setTimeout(() => {
        this.applyLogicToCodingLanguages();
      }, 2000);
    }
    // TODO: REMOVE LATER - End of custom refresh logic
  }

  toggleSelectedLanguage(selectedLanguage: any) {
    // Save current language's code before switching (per-language code persistence)
    if (this.selectedLanguageId && this.code != null && this.code !== '') {
      const questionObj = this.allQuestions[this.currentQuestionIndex];
      if (!questionObj.languageCodeMap) questionObj.languageCodeMap = {};
      questionObj.languageCodeMap[this.selectedLanguageId] = this.code;
    }
    this.jupyterLoader = true;
    this.loading = true;
    this.IDELoader = true;
    this.codingLanguages.forEach((language) => (language.selected = false));
    selectedLanguage.selected = true;
    this.selectedLanguage = selectedLanguage.name;
    this.selectedLanguageId = selectedLanguage.id;
    this.updateEditorMode(selectedLanguage.id);
    this.code = '';
    this.languageModal = false;
    this.allQuestions[this.currentQuestionIndex].selectedLanguage =
      selectedLanguage;
    // if((this.allQuestionsData?.questionType === 'SQL_CODING' || this.allQuestionsData?.questionType === 'CODING_TYPE')) {
    //   if (!this.restoreSavedCodeForLanguage(selectedLanguage.id)) {
    //     this.inputBoilerCode();
    //   } else {
    //     this.loading = false;
    //     this.jupyterLoader = false;
    //     this.IDELoader = false;
    //   }
    // }
    if((this.allQuestionsData?.questionType === 'SQL_CODING' || this.allQuestionsData?.questionType === 'CODING_TYPE')) {
      this.inputBoilerCode();
    }
    if (selectedLanguage.id === '01') {
      this.loading = true;
      this.codeEditor = false;
      this.jupyterNotebookEnabled = true;
      setTimeout(() => {
        this.loading = false;
      }, 3000);
    } else {
      this.jupyterNotebookEnabled = false;
      this.codeEditor = true;
    }
    // TODO: REMOVE LATER - Custom refresh logic for drive_id 102980 and 244403 and 239424 and 239424 in toggleSelectedLanguage
    // Refresh language options for other questions after selection (for drive_id 102980, 244403)
    // Delay to ensure boilerplate code generation completes first
    if (['102980', '244403', '239424','715158'].includes(this.driveData) && this.allQuestionsData?.questionType === 'CODING_TYPE') {
      setTimeout(() => {
        this.applyLogicToCodingLanguages();
      }, 2000);
    }
    // TODO: REMOVE LATER - End of custom refresh logic
  }

  private resetCodingAttemptOnLanguageChange() {
    const currentQuestion = this.allQuestions?.[this.currentQuestionIndex];
    if (!currentQuestion) {
      return;
    }

    const type = currentQuestion.questionType;
    if (type !== 'CODING_TYPE' && type !== 'SQL_CODING') {
      return;
    }
    if (currentQuestion.attempted) {
      currentQuestion.attempted = false;
      if (this.attemptedQuestionsCount > 0) {
        this.attemptedQuestionsCount--;
      }
    }
  }

  private markCurrentQuestionAttempted() {
    const q: any = this.allQuestions?.[this.currentQuestionIndex];
    if (!q) return;
    if (!q.attempted) {
      q.attempted = true;
      q.skipped = false;
      this.attemptedQuestionsCount++;
    }
    this.nonProgressiveQuestionsList();
  }

  private markCurrentQuestionOpened() {
    const q: any = this.allQuestions?.[this.currentQuestionIndex];
    if (!q) return;
    q.opened = true;
    this.nonProgressiveQuestionsList();
  }

  saveIdeJupyterCurrentQuestion(): void {
    const type = this.allQuestionsData?.questionType;
    if (type !== 'IDE_TYPE' && type !== 'JUPYTER_NOTEBOOK') return;
    this.markCurrentQuestionAttempted();
    this.toastr.success(
      'Your work is saved. Use “Submit Section” when you are ready to submit.',
      'Saved'
    );
  }

  includeOpenedQuestionsOnSubmit = true;
  showIdeSubmitSummary = false;
  ideSummaryForceSubmit = false;
  ideJupyterSummary = { saved: 0, opened: 0, notAttempted: 0 };

  hasOpenedUnsavedIdeJupyter(): boolean {
    return (this.allQuestions || []).some(
      (q: any) =>
        (q?.questionType === 'IDE_TYPE' ||
          q?.questionType === 'JUPYTER_NOTEBOOK') &&
        q?.opened &&
        !q?.attempted
    );
  }

  private computeIdeJupyterSummary(): void {
    const all = this.allQuestions || [];
    const total =
      this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar) ||
      all.length;
    const saved = all.filter((q: any) => q?.attempted).length;
    const opened = all.filter(
      (q: any) =>
        (q?.questionType === 'IDE_TYPE' ||
          q?.questionType === 'JUPYTER_NOTEBOOK') &&
        q?.opened &&
        !q?.attempted
    ).length;
    this.ideJupyterSummary = {
      saved,
      opened,
      notAttempted: Math.max(0, total - saved - opened),
    };
  }

  confirmIdeSubmit(includeOpened: boolean): void {
    this.includeOpenedQuestionsOnSubmit = includeOpened;
    this.showIdeSubmitSummary = false;
    if (this.ideSummaryForceSubmit) {
      this.autoSubmitExam = true;
    }
    this.submitTestForProgressiveOrNonProgressive(
      this._commonService.Enums.Submit_Section
    );
  }

  private dropOpenedUnsavedFromPayload(): void {
    const openedUnsavedIds = new Set(
      (this.allQuestions || [])
        .filter(
          (q: any) =>
            (q?.questionType === 'IDE_TYPE' ||
              q?.questionType === 'JUPYTER_NOTEBOOK') &&
            q?.opened &&
            !q?.attempted
        )
        .map((q: any) => q?.questionId)
    );
    if (!openedUnsavedIds.size) return;
    this.subSectionDto.sectionQuestionList = (
      this.subSectionDto.sectionQuestionList || []
    ).filter((entry: any) => !openedUnsavedIds.has(entry?.questionId));
  }
  // ---------------------------------------------------------------------------

  // private restoreSavedCodeForLanguage(languageId: any): boolean {
  //   const currentQuestion = this.allQuestions?.[this.currentQuestionIndex];
  //   if (!currentQuestion) {
  //     return false;
  //   }
  //   const savedCode = this.answers[this.currentQuestionIndex];
  //   if (currentQuestion.lastTypedLanguageId !== languageId || !savedCode) {
  //     return false;
  //   }
  //   this.code = savedCode;
  //   currentQuestion.selectedAnswers = savedCode;
  //   return true;
  // }

  minimizeQuestionSection: boolean = true;
  expandCodeEditor() {
    this.minimizeQuestionSection = !this.minimizeQuestionSection;
  }

  compiledCode: any;
  textInput: any;
  reportQuestionPopup: boolean;
  newReportedQuestionsPopup:string='';
  booleanOptions: any = ['True', 'False'];
  // multipleBlanks = [1, 2, 3]
  multipleBlanks: any[] = [1];
  fibAnswer: string[] = [];
  multipleFibAns: string[] = [];
  answers: { [key: number]: string[] } = {};
  focusedInput: number | null = null;
  displayChecked: boolean;
  booleanResponse: boolean | null = null;
  fibValue: string;
  wrongQuestionSuggestion: string = '';
  wrongQuestionReason: string = '';
  QuestionReportDto: QuestionReportDto = new QuestionReportDto();
  questionReportMap = new Map<String,any>();
  atleastOneQuestionReported:boolean=false;

  // questionResponses: string[] = [];

  setFocus(index: number) {
    this.focusedInput = index;
  }

  removeFocus() {
    this.focusedInput = null;
  }

  updateFibAnswer(value: string, questionIndex: number, inputIndex: number) {
    // console.log(value, questionIndex, inputIndex, 'fib value');

    if (!this.answers[questionIndex]) {
      this.answers[questionIndex] = new Array(this.multipleBlanks.length).fill(
        ''
      );
    }
    this.answers[questionIndex][inputIndex] = value;
    if (this.multipleBlanks.length > 1) {
      this.multipleFibAns[inputIndex] = value;
    } else {
      this.fibAnswer[inputIndex] = value;
      if(this.allQuestions[questionIndex].attempted && this.attemptedQuestionsCount > 0){
        this.attemptedQuestionsCount--;  
      }
      this.allQuestions[questionIndex].selectedAnswers = [value];
      this.allQuestions[questionIndex].attempted = false;
      this.allQuestions[questionIndex].skipped = false;
    }
  }

  checkAndResetInput() {
    if (this.multipleBlanks?.length > 1) {
      if (!this.answers[this.currentQuestionIndex]) {
        this.multipleFibAns = new Array(this.multipleBlanks.length).fill('');
      } else {
        this.multipleFibAns = this.answers[this.currentQuestionIndex];
      }
    } else {
      if (!this.answers[this.currentQuestionIndex]) {
        this.fibAnswer = new Array(this.multipleBlanks.length).fill('');
      } else {
        this.fibAnswer = this.answers[this.currentQuestionIndex];
      }
      console.log(this.fibAnswer,'fibAnswer');
      
    }
  }

  getAnswerForField(inputIndex: number): string {
    return this.answers[this.currentQuestionIndex]
      ? this.answers[this.currentQuestionIndex][inputIndex] || ''
      : '';
  }

  getBooleanValue(event: any, questionIndex: number) {
    const value = event.target.value;

    if (value === null || value === undefined || value === '') {
      this.allQuestions[questionIndex].selectedAnswers = [];
      this.booleanResponse = null;
    } else {
      this.allQuestions[questionIndex].selectedAnswers = [value];
      this.booleanResponse = value;
    }

    this.displayChecked = true;
  }

  resetBooleanResponse() {
    this.displayChecked = false;
  }

  getOptionSelected(option: string, questionIndex: number): boolean {
    let optionExists: boolean = false;
    if (option) {
      optionExists =
        this.allQuestions[questionIndex]?.selectedAnswers.includes(option);
    }
    return optionExists;
  }

  textResponse(event: any, questionIndex: number) {
    let plainText: any;

    if (typeof event === 'string') {
      plainText = event;
    } else if (
      event &&
      typeof event === 'object' &&
      'target' in event &&
      'value' in event.target
    ) {
      plainText = event.target.value;
    } else if (
      event &&
      typeof event === 'object' &&
      'type' in event &&
      'content' in event
    ) {
      const htmlContent = toHTML(event);
      plainText = this.stripHtmlTags(htmlContent);
    } else {
      console.log('Invalid event data:', event);
      return;
    }

    this.textInput = plainText;

    if (questionIndex >= 0 && questionIndex < this.allQuestions.length) {
      if (!Array.isArray(this.allQuestions[questionIndex].selectedAnswers)) {
        this.allQuestions[questionIndex].selectedAnswers = [];
      }
      this.answers[questionIndex] = plainText;
      this.allQuestions[questionIndex].selectedAnswers = [plainText];
    } else {
      console.log('Invalid question index:', questionIndex);
    }
  }

  stripHtmlTags(html: string): string {
    const div = document.createElement('div');
    div.innerHTML = html;
    return div.innerText || div.textContent || '';
  }

  checkAndResetTextAnswer() {
    if (this.allQuestionsData?.questionType === 'TEXT_TYPE') {
      const currentAnswer = this.answers[this.currentQuestionIndex];
      if (!currentAnswer) {
        this.textInput = '';
      } else {
        this.textInput = currentAnswer;
      }
    }
  }

  resetReportQuestion() {
    this.reportQuestionPopup = false;
    this.wrongQuestionReason = '';
    this.wrongQuestionSuggestion = '';
    sessionStorage.removeItem('isExaminationTimerStopped');
  }
  resetAllReportQuestion() {
    this.newReportedQuestionsPopup = '';
    this.atleastOneQuestionReported=false;
    this.questionReportMap.clear();
    sessionStorage.removeItem('isExaminationTimerStopped');
  }
  resetReportedQuestion(){
    this.newReportedQuestionsPopup = '';
    this.atleastOneQuestionReported=false;
    this.questionReportMap.clear();
    sessionStorage.removeItem('isExaminationTimerStopped');
      if (!this.isLastSection && !this.autoSubmitAssessment) {              
        if (this.sectionBreakTime > 0) {
            this.breakTimeScreen = true;
            this.startTimer(this.sectionBreakTime);
          }else {
            this.breakTimeScreen = false;
            this.startNextSection();
        }
      }
    else if(this.isLastSection === true ||
      this.autoSubmitAssessment === true){
        this.submitLastSection();
      }
      else if(this.lastSectionAndLastQuestion){
          sessionStorage.removeItem('enableStep5');
          this._router.navigate([
            this._commonService.Navigations.SUBMIT_SUCCESS_PAGE,
          ]);
          this.exitFullScreen();        
      }
  }
  openCancelReportPopUp(){
    this.newReportedQuestionsPopup='cancelReport'
  }
  backToReportPopUp(){
    this.newReportedQuestionsPopup='openReport';
  }

  submitWrongQuestion() {
    if (this.wrongQuestionReason == '') {
      this.toastr.error('Please enter your response');
      return;
    }
    this.QuestionReportDto.appUserId = this.loginUser.id;
    this.QuestionReportDto.driveId = this.driveData;
    this.QuestionReportDto.questionId = this.allQuestionsData.questionId;
    this.QuestionReportDto.subCategoryId = this.subCategoriesId;
    this.QuestionReportDto.wrongQuestionReason = this.wrongQuestionReason;
    this.QuestionReportDto.wrongQuestionSuggestion =
      this.wrongQuestionSuggestion;

    if (this.isLiteAppVersion) {
      this._examinationEventService.addReportedQuestion(
        this.allQuestionsDataForTopBar.sequence.toString(),
        {
          questionId: this.allQuestionsData.questionId,
          reason: this.wrongQuestionReason,
          suggestion: this.wrongQuestionSuggestion,
        }
      );
      this.toastr.success('Question reported successfully');
      this.resetReportQuestion();
    } else {
      this._examinationService
        .reportWrongQuestion(this.QuestionReportDto)
        .subscribe((response) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            this.toastr.success(response.message);
            this.resetReportQuestion();
          }
        });
    }
  }
  submitAllReportedQuestion(){
    const reports = Array.from(this.questionReportMap.values()).map(report => {
      const { allQuestionData, ...rest } = report; 
      return {
        ...rest,
        wrongQuestionReason: rest.wrongQuestionReason?.trim(),
        wrongQuestionSuggestion:rest.wrongQuestionSuggestion?.trim()
      };
    });


    const invalidReport = reports.find(
      r => !r.wrongQuestionReason || r.wrongQuestionReason.trim() === ''
    );
    if (invalidReport) {
      this.toastr.error('Please enter reason for all reported questions');
      return;
    }

    if (this.isLiteAppVersion) {
      reports.forEach(report => {
        this._examinationEventService.addReportedQuestion(
          report.allQuestionData.sequence.toString(),
          {  
            questionId: report.questionId,
            reason: report.wrongQuestionReason,
            suggestion: report.wrongQuestionSuggestion
          }
        );
      });
      this.toastr.success('Questions reported successfully');
      this.resetReportQuestion();
    }
    else {
      this._examinationService
      .reportAllWrongQuestions(reports).pipe(finalize(()=>{
        this.resetAllReportQuestion();
          if (!this.isLastSection && !this.autoSubmitAssessment) {
          if (this.sectionBreakTime > 0) {
            this.breakTimeScreen = true;
            this.startTimer(this.sectionBreakTime);
          }
          else{
            this.breakTimeScreen = false;
            this.startNextSection();
          }
        }
        else if(this.isLastSection === true ||
          this.autoSubmitAssessment === true){
            this.submitLastSection(); 
          }
          else if(this.lastSectionAndLastQuestion){
            sessionStorage.removeItem('enableStep5');
            this._router.navigate([
              this._commonService.Navigations.SUBMIT_SUCCESS_PAGE,
            ]);
            this.exitFullScreen();        
        }
      }))
      .subscribe({
        next: (response) => {
          if (response.statusCode === HttpStatusCode.Ok) {
            this.toastr.success(response.message);
          }
        },
        error: (err) => {
          console.error('Report API failed', err);
        }
      });
    }
  }

  scrollToTop() {
    this.renderer.setProperty(document.body, 'scrollTop', 0);
    this.renderer.setProperty(document.documentElement, 'scrollTop', 0);
    const container = document.getElementById('question-container');
    if (!container) {
      console.warn('Element with ID "question-container" not found.');
      return;
    }

    const myElement = document.getElementById('current-question');
    if (myElement) {
      const topPos = myElement.offsetTop;
      container.scrollTop = topPos - 50;
    } else {
      console.warn('Element with ID "current-question" not found.');
      container.scrollTop = 0;
    }
  }

  isFetchingCodingLanguages: boolean = false;
  codingLanguagesFetched = false;
  allCodingLanguages: any;
  getCodingLanguages() {
    if (this.isLiteAppVersion && this.codingLanguagesLoaded) {
      if (this.allCodingLanguages) {
        this.codingLanguages = this.allCodingLanguages;
        this.applyLogicToCodingLanguages();
      }
      return;
    }

    if (!this.allQuestionsData?.questionType) {
      this.allQuestionsData.questionType = this.originalQuestionType;
    }

    if (
      (!this.codingLanguagesFetched ||
        (this.isLiteAppVersion && !this.isCodingLaguageForLiteVersion)) &&
      !this.isFetchingCodingLanguages
    ) {
      this.isFetchingCodingLanguages = true;
      this._examinationService.getCodingLanguages().subscribe(
        (response) => {
          this.isFetchingCodingLanguages = false;
          if (response && response.statusCode === HttpStatusCode.Ok) {
            this.allCodingLanguages = response.data;
            this.codingLanguages = this.allCodingLanguages;
            this.codingLanguagesFetched = true;
            if (this.isLiteAppVersion) {
              this.codingLanguagesLoaded = true;
              this.isCodingLaguageForLiteVersion = true;
            }
            this.applyLogicToCodingLanguages();
          }
        },
        (error) => {
          this.isFetchingCodingLanguages = false;
        }
      );
    } else {
      this.codingLanguages = this.allCodingLanguages;
      this.applyLogicToCodingLanguages();
    }
  }

  // getCodingLanguages() {
  //   if (!this.allQuestionsData.questionType) {
  //     this.allQuestionsData.questionType = this.originalQuestionType;
  //   }

  //   if (!this.codingLanguagesFetched) {
  //     if (this.isLiteAppVersion) {
  //       this.allCodingLanguages = [
  //         { id: 1, name: 'Java' },
  //         { id: 2, name: 'Python' },
  //         { id: 3, name: 'C++' },
  //         { id: 4, name: 'JavaScript' },
  //       ];
  //       this.codingLanguages = this.allCodingLanguages;
  //       this.codingLanguagesFetched = true;
  //       this.applyLogicToCodingLanguages();
  //     } else {
  //       this._examinationService.getCodingLanguages().subscribe((response) => {
  //         if (response && response.statusCode === HttpStatusCode.Ok) {
  //           this.allCodingLanguages = response.data;
  //           this.codingLanguages = this.allCodingLanguages;
  //           this.codingLanguagesFetched = true;
  //           this.applyLogicToCodingLanguages();
  //         }
  //       });
  //     }
  //   } else {
  //     this.codingLanguages = this.allCodingLanguages;
  //     this.applyLogicToCodingLanguages();
  //   }
  // }

  applyLogicToCodingLanguages() {
    const exists = this.codingLanguages?.some((item: any) => item.id === '01');

    if (!exists) {
      this.codingLanguages?.push({ id: '01', name: 'Jupyter Notebook' });
    }

    if (!this.allQuestionsData.questionType) {
      this.allQuestionsData.questionType = this.originalQuestionType;
    }
    if (
      this.allQuestionsData?.questionType === 'CODING_TYPE' ||
      this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK'
    ) {
      // TODO: REMOVE LATER - Python-only drive restriction
      // For drive_id 298694, 788952 and 682968, CODING_TYPE questions
      // may only be attempted in Python 2 or Python 3.
      if (
        ['298694', '788952', '682968'].includes(String(this.driveData)) &&
        this.allQuestionsData?.questionType === 'CODING_TYPE'
      ) {
        this.codingLanguages = this.codingLanguages?.filter(
          (item: any) =>
            item.id === '70' ||   // Python2
            item.id === '92'      // Python3
        );
        // TODO: REMOVE LATER - End of Python-only drive code
      } else if (
        // TODO: REMOVE LATER - Custom code for drive_id 102980 and 244403 and 239424 language restriction
        // For drive_id 102980 and 244403 and 239424, show only C, C++, Java, and Python3
        ['102980', '244403', '239424','715158'].includes(this.driveData)
      ) {
        this.codingLanguages = this.codingLanguages?.filter(
          (item: any) =>
            item.id === '110' ||  // C
            item.id === '105' ||  // C++
            item.id === '62' ||   // Java
            item.id === '92'      // Python3
        );
      } else {
        // TODO: REMOVE LATER - End of custom drive_id 102980 and 244403 and 239424 code
        // Default language filtering for other drives
        this.codingLanguages = this.codingLanguages?.filter(
          (item: any) =>
            item.id === '70' ||
            item.id === '92' ||
            item.id === '62' ||
            item.id === '01' ||
            item.id === '110' ||
            item.id === '105' ||
            item.id === '51'
        );
      }

      // Clean up language names for C family languages
      this.codingLanguages = this.codingLanguages?.map((item: any) => {
        if (['110', '105', '51'].includes(item.id)) {
          return {
            ...item,
            name: item?.name.split(' ')[0]
          };
        }
        return item;
      });

      this.editorMode = 'python';
    } else {
      this.editorMode = 'javascript';
    }

    this.editorOptions = {
      ...this.editorOptions,
      mode: this.editorMode,
    };

    if (this.allQuestionsData?.questionType === 'SQL_CODING') {
      this.codingLanguages = this.codingLanguages?.filter((item: any) =>
        item.name.includes('SQL')
      );
    }

    // TODO: REMOVE LATER - Custom filtering logic for drive_id 102980 and 244403 and 239424
    // Filter out languages already selected by other coding questions in current section (for drive_id 102980, 244403)
    const selectedLanguageIds = this.getSelectedLanguageIdsForCurrentSection();
    const currentQuestionLanguageId = this.allQuestions[this.currentQuestionIndex]?.selectedLanguage?.id;

    if (selectedLanguageIds.length > 0) {
      this.codingLanguages = this.codingLanguages?.filter((item: any) => {
        // Always keep the currently selected language for current question (needed for boilerplate code)
        if (String(item.id) === String(currentQuestionLanguageId)) {
          return true;
        }
        // Filter out languages used in other questions
        const shouldFilter = selectedLanguageIds.includes(String(item.id));
        return !shouldFilter;
      });
    }
    // TODO: REMOVE LATER - End of custom filtering logic for drive_id 102980 and 244403 and 239424

    this.codingLanguages?.forEach((item: any) => {
      item.selected = false;
      const versionMatch = item.name.match(/\((?:[^0-9]*)(\d+)\./);
      if (versionMatch && versionMatch[1]) {
        item.name = `${item.name.split(' ')[0]} ${versionMatch[1]}`;
      }
    });
  }

  // TODO: REMOVE LATER - Custom method for drive_id 102980 and 244403 and 239424 language filtering
  // Helper method to get language IDs from coding questions with actual code written
  getSelectedLanguageIdsForCurrentSection(): string[] {
    const selectedLanguageIds: string[] = [];

    // Only apply filtering for drive_id 102980 and 244403 and 239424
    if (!['102980', '244403', '239424','715158'].includes(this.driveData)) {
      return selectedLanguageIds;
    }

    // Get languages from coding questions that have actual code written (attempted)
    if (this.allQuestions && this.allQuestions.length > 0) {
      this.allQuestions.forEach((question, index) => {
        // Skip current question to allow changing its language
        // Only filter if the question has actual code content AND a selected language
        if (index !== this.currentQuestionIndex &&
            question.questionType === 'CODING_TYPE' &&
            this.answers[index] &&
            String(this.answers[index]).trim() !== '' &&
            question.selectedLanguage &&
            question.selectedLanguage.id) {

          selectedLanguageIds.push(String(question.selectedLanguage.id)); // Ensure string conversion
        }
      });
    }

    return selectedLanguageIds;
  }
  // TODO: REMOVE LATER - End of custom method for drive_id 102980 and 244403 and 239424

  getCodingLanguageSelected() {
    if (!this.allQuestionsData.questionType) {
      this.allQuestionsData.questionType = this.originalQuestionType;
    }
    if (this.allQuestionsData?.questionType === 'SQL_CODING') {
      this.loading = true;
      this.codeEditor = true;
      setTimeout(() => {
        const selectedLanguage = this.codingLanguages?.find((res) =>
          res.name.includes('SQL')
        );

        if (selectedLanguage) {
          selectedLanguage.selected = true;
          this.selectedLanguage = selectedLanguage.name;
          this.selectedLanguageId = selectedLanguage.id;
          this.updateEditorMode(selectedLanguage.id);
        }
        this.loading = false;
      }, 1500);
    } else if (this.allQuestionsData?.questionType === 'CODING_TYPE') {
      if (!this.codeEditor) {
        this.selectCodeLanguage = true;
      }
    } else if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      if (!this.jupyterNotebookEnabled) {
        this.jupyterNotebookEnabled = true;
      }
    }
    this.minimizeQuestionSection = true;
  }

  testCaseProcessing: boolean;
  isExecutingCode: boolean;
  getLanguageName(id) {
    switch (String(id)) {
        case '110':
            return 'c';
        case '105':
            return 'cplus';
        case '51':
            return 'csharp';
        case '92':
            return 'Python3';
        case '70':
            return 'Python2';
        case '62':
            return 'Java13';    
        case '82':
            return 'SQL'; 
        default:
            return 'Unknown Language';
    }
}
  async getCodingQuestionOutput(questionId?: string) {
    if (this.code == '' || this.testCaseProcessing) {
      return;
    }
    // this.minimizeQuestionSection = false;
    this.codingQuestionDto.sourceCode = this.encryptValue(this.code);
    this.codingQuestionDto.languageId = this.selectedLanguageId;
    this.codingQuestionDto.languageType = this.getLanguageName(this.selectedLanguageId);
    this.codingQuestionDto.mquestionId = this.allQuestionsData.id;
    this.codingQuestionDto.mQuestionId = this.allQuestionsData.id;
    
    if (this.isInputValue) {
      this.codingQuestionDto.stdIn = this.encryptValue(this.enteredInputValue);
    }
    //  else{
      //   let defaultNumber = '';
      //   this.codingQuestionDto.stdIn = this.encryptValue(defaultNumber);
      // }
      
      if (this.allQuestionsData?.questionType === 'CODING_TYPE') {
    this.codingQuestionDto.questionId = this.allQuestionsData.questionId;
      this.compileCodingQuestion();
    } else if (this.allQuestionsData?.questionType === 'SQL_CODING') {
      this.isLiteAppVersion
        ? this.executeQueryForQuestion(questionId)
        : this.getSqlQuestionOutput();
    }
  }

  // Store test cases per question index so navigating away/back preserves them
   testCasesMap: { [questionIndex: number]: any[] } = {};
    // Store compiled output and visible counts per question so values persist when navigating
    compiledCodeMap: { [questionIndex: number]: any } = {};
    visibleCorrectCasesMap: { [questionIndex: number]: number } = {};
    visibleTestCaseCountMap: { [questionIndex: number]: number } = {};
    totalCorrectCasesMap: { [questionIndex: number]: number } = {};

  // Expose current question's test cases as a property to keep existing usages unchanged
  get testCasesList(): any[] {
    if (this.currentQuestionIndex == null) return [];
    if (!this.testCasesMap[this.currentQuestionIndex]) {
      this.testCasesMap[this.currentQuestionIndex] = [];
    }
    return this.testCasesMap[this.currentQuestionIndex];
  }

  set testCasesList(value: any[]) {
    if (this.currentQuestionIndex == null) return;
    this.testCasesMap[this.currentQuestionIndex] = value || [];
  }

  selectedTestCaseIndex: number = 0;
  get selectedTestCase() {
    return this.testCasesList && this.testCasesList.length > 0
      ? this.testCasesList[this.selectedTestCaseIndex]
      : null;
  }

  selectTestCase(index: number) {
    this.bottomPanelExpanded = true;
    if (index >= 0 && index < (this.testCasesList?.length || 0)) {
      this.selectedTestCaseIndex = index;
    }
  }
  compileError: any;
  totalCorrectCases: number = 0;
  visibleCorrectCases: number = 0;
  visibleTestCaseCount: number = 0;
  compileCodingQuestion() {
    this.testCaseProcessing = true;
    this.compiledCode = null;
    this.isLoading = true;
    this.loading=true;
    this.isExecutingCode = true;
    this.testCasesList = [];
    this._examinationService
      .getCodingQuestionOutput(this.codingQuestionDto)
      .subscribe(
        (response) => {
          if (response && response.statusCode === HttpStatusCode.Ok) {
            // if (response.data.output != null) {
            //   this.compiledCode = response.data.output;
            // }
            this.compileError = response.data.compileError;
            if (response.data.testCases?.length > 0) {
              const testCases = response.data.testCases;
              let totalTestCases = testCases.length;
              // overall correct count (all cases)
              this.totalCorrectCases = testCases.filter(
                (testCase: any) => testCase.correct === true
              ).length;
              // visible slice (first 5) correct count
              const visible = testCases.slice(0, 50);
              this.visibleTestCaseCount = visible.length;
              this.visibleCorrectCases = visible.filter(
                (testCase: any) => testCase.correct === true
              ).length;
              this.compiledCode = `${this.visibleCorrectCases}/${this.visibleTestCaseCount} Test Cases Passed`;

              if (this.currentQuestionIndex != null) {
                this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
                this.visibleCorrectCasesMap[this.currentQuestionIndex] = this.visibleCorrectCases;
                this.visibleTestCaseCountMap[this.currentQuestionIndex] = this.visibleTestCaseCount;
                this.totalCorrectCasesMap[this.currentQuestionIndex] = this.totalCorrectCases;
              }

              this.testCasesList = testCases.map((testCase: any) => ({
                input:
                  testCase.ExpectedInput ||
                  testCase.input ||
                  testCase.Input ||
                  '',
                output: testCase.actualOutput || testCase.output || '',
                expectedOutput:
                  testCase.ExpectedOutPut ||
                  testCase.ExpectedOutput ||
                  testCase.Expected_Output ||
                  '',
                passed: !!testCase.correct,
                correct: !!testCase.correct,
                status:
                  testCase.testCaseStatus ||
                  testCase.testCaseStatus ||
                  testCase.status ||
                  '',
                runtimeError: testCase.runtimeError || null,
                compileError: testCase.compileError || null,
                executionTime: testCase.executionTime || null,
                memoryUsed: testCase.memoryUsed || null,
                raw: testCase,
              }));
              this.selectedTestCaseIndex = 0;
              this.testCaseProcessing = false;
            } else {
              this.compiledCode = 'Code Exited With Errors';
              if (this.currentQuestionIndex != null) {
                this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
                this.visibleCorrectCasesMap[this.currentQuestionIndex] = 0;
                this.visibleTestCaseCountMap[this.currentQuestionIndex] = 0;
                this.totalCorrectCasesMap[this.currentQuestionIndex] = 0;
              }
              this.testCaseProcessing = false;
            }
            this.isLoading = false;
            this.loading=false;
            this.isInputValue = false;
            this.isExecutingCode = false;
            this.testCaseProcessing = false;
            // let codingData: any[] = [];
            //   response.data.filter(element => {
            //     codingData.push(element);
            //   });

            //   // Convert list into a string
            //   let codingDataString: string = codingData.map(x => x.output).join(`\n`);
            //   this.compiledCode = codingDataString;
          }
        },
        (error) => {
          if (error.statusCode >= 500) {
            this.toastr.error('Something went wrong');
          } 
          else {
            this.toastr.error(error?.error?.message);
          }
          this.isLoading = false;
          this.loading=false;
          this.isExecutingCode = false;
          this.testCaseProcessing = false;
        }
      );
  }

  testCases: any;
  getSqlQuestionOutput() {
    this.compiledCode = null;
    this.isLoading = true;
    this.testCaseProcessing = true;
    this.isExecutingCode = true;
    this.testCasesList = [];
    this._examinationService
      .getSqlQuestionOutput(this.codingQuestionDto)
      .subscribe(
        (response) => {
          if (response && response.statusCode === HttpStatusCode.Ok) {
            // if (response.data.output != null) {
            //   this.compiledCode = response.data.output;
            // }
            if (response.data.testCases?.length > 0) {
              const testCases = response.data.testCases;
              let totalTestCases = testCases.length;
              // overall correct count (all cases)
              this.totalCorrectCases = testCases.filter(
                (testCase: any) => testCase.correct === true
              ).length;
              // visible slice (first 50) correct count
              const visible = testCases.slice(0, 50);
              this.visibleTestCaseCount = visible.length;
              this.visibleCorrectCases = visible.filter(
                (testCase: any) => testCase.correct === true
              ).length;
              this.compiledCode = `${this.visibleCorrectCases}/${this.visibleTestCaseCount} Test Cases Passed`;

              if (this.currentQuestionIndex != null) {
                this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
                this.visibleCorrectCasesMap[this.currentQuestionIndex] = this.visibleCorrectCases;
                this.visibleTestCaseCountMap[this.currentQuestionIndex] = this.visibleTestCaseCount;
                this.totalCorrectCasesMap[this.currentQuestionIndex] = this.totalCorrectCases;
              }

              this.testCasesList = testCases.map((testCase: any) => ({
                input:
                  testCase.ExpectedInput ||
                  testCase.input ||
                  testCase.Input ||
                  '',
                output: testCase.actualOutput || testCase.output || '',
                expectedOutput:
                  testCase.ExpectedOutPut ||
                  testCase.ExpectedOutput ||
                  testCase.Expected_Output ||
                  '',
                passed: !!testCase.correct,
                correct: !!testCase.correct,
                status: testCase.testCaseStatus || testCase.status || '',
                runtimeError: testCase.runtimeError || null,
                compileError: testCase.compileError || null,
                executionTime: testCase.executionTime || null,
                memoryUsed: testCase.memoryUsed || null,
                raw: testCase,
              }));
              this.selectedTestCaseIndex = 0;
              this.testCaseProcessing = false;
            } else {
              this.compiledCode = 'Code Exited With Errors';
              if (this.currentQuestionIndex != null) {
                this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
                this.visibleCorrectCasesMap[this.currentQuestionIndex] = 0;
                this.visibleTestCaseCountMap[this.currentQuestionIndex] = 0;
                this.totalCorrectCasesMap[this.currentQuestionIndex] = 0;
              }
              this.testCaseProcessing = false;
            }
            this.isLoading = false;
            this.isInputValue = false;
            this.isExecutingCode = false;
            this.testCaseProcessing = false;
          }
        },
        (error) => {
          if (error.statusCode >= 500) {
            this.toastr.error('Something went wrong');
          } 
          else {
            this.toastr.error(error?.error?.message);
          }
          this.isLoading = false;
          this.isExecutingCode = false;
          this.testCaseProcessing = false;
        }
      );
  }

 encryptValue(data: any) {
  return btoa(unescape(encodeURIComponent(data)));
}

  enteredInputValue: string;
  isInputValue: boolean;
  onEnterPress(value: any) {
    const lineCount = value.lineCount();
    let allCapturedNumbers = [];

    for (let i = 0; i < lineCount; i++) {
      const currentLine = value.getLine(i).trim();
      const numbers = currentLine.match(/\d+/g);

      if (numbers) {
        allCapturedNumbers.push(numbers.map(Number).join('')); // Join numbers if multiple
      }
    }

    if (allCapturedNumbers) {
      const joinedNumbers = allCapturedNumbers.join('\n'); // Join numbers with a newline delimiter
      this.enteredInputValue = joinedNumbers;
    } else {
      console.log('No numbers found in the entered string.');
    }

    this.isInputValue = true;
    // this.getCodingQuestionOutput();
  }

  resetCodingQuestion() {
    if (
      this.allQuestionsData?.questionType === 'CODING_TYPE' ||
      this.allQuestionsData?.questionType === 'SQL_CODING'
    ) {
      const currentAnswer = this.answers[this.currentQuestionIndex];
      // Prefer savedLanguage (set only on actual code saves) over selectedLanguage (set on every
      // language pick) so that switching language without typing doesn't desync the dropdown.
      const currentLanguage =
        (currentAnswer != null && this.allQuestions[this.currentQuestionIndex]?.savedLanguage)
          ? this.allQuestions[this.currentQuestionIndex].savedLanguage
          : this.allQuestions[this.currentQuestionIndex]?.selectedLanguage;
      if (
        currentAnswer != null &&
        currentLanguage?.name != 'Jupyter Notebook'
      ) {
        this.jupyterNotebookEnabled = false;
        this.codeEditor = true;
        this.code = currentAnswer;
        this.selectedLanguage = currentLanguage?.name;
        this.selectedLanguageId = currentLanguage?.id;
        this.updateEditorMode(currentLanguage?.id);
        this.codingLanguages.forEach((language: any) => {
          language.selected = language.id === currentLanguage?.id;
        });

        this.selectCodeLanguage = false;
      } else if (
        currentLanguage?.name == 'Jupyter Notebook' &&
        !this.isSubmitApiCalled
      ) {
        this.codeEditor = false;
        this.jupyterNotebookEnabled = true;
        this.inputBoilerCode();
        this.selectedLanguage = currentLanguage?.name;
        this.selectedLanguageId = currentLanguage?.id;
        this.codingLanguages.forEach((language: any) => {
          language.selected = language.id === currentLanguage?.id;
        });
        this.selectCodeLanguage = false;
      } else {
        this.code = '';
        this.selectedLanguageId = '';
        this.selectedLanguage = '';
        this.codeEditor = false;
        this.jupyterNotebookEnabled = false;
        this.selectCodeLanguage = true;
      }

      this.loading = false;
      this.compiledCode = null;
      this.IDECompiledTestCase = null;
      this.IDELoader = false;
      this.minimizeQuestionSection = true;
      this.maximizeQuestionSection = false;
      this.bottomPanelExpanded = false;
      // this.testCasesList = [];
    }

    this.chatGptSection = false;
  }

  onCodeChange(updatedCode: any) {
    console.log(updatedCode,'updatedCode');

    this.answers[this.currentQuestionIndex] = updatedCode;
    console.log(this.answers[this.currentQuestionIndex],'this.answers[this.currentQuestionIndex]');

    this.allQuestions[this.currentQuestionIndex].selectedAnswers = updatedCode;
    console.log(this.allQuestions[this.currentQuestionIndex].selectedAnswers ,'this.allQuestions[this.currentQuestionIndex].selectedAnswers ');

    // Sync savedLanguage so resetCodingQuestion can restore the language that was active when code was last saved.
    // This prevents language-state mismatch when a user switches language without typing.
    if (this.selectedLanguage && this.selectedLanguageId) {
      this.allQuestions[this.currentQuestionIndex].savedLanguage = { name: this.selectedLanguage, id: this.selectedLanguageId };
    }

    // TODO: REMOVE LATER - Custom refresh logic for drive_id 102980 and 244403 and 239424 and 239424 in onCodeChange
    // Refresh language filtering when user starts typing (for drive_id 102980, 244403)
    if (['102980', '244403', '239424','715158'].includes(this.driveData) &&
        this.allQuestionsData?.questionType === 'CODING_TYPE' &&
        updatedCode &&
        updatedCode.trim() !== '' &&
        this.allQuestions[this.currentQuestionIndex]?.selectedLanguage) {
      // Delay to avoid interfering with boilerplate code generation
      setTimeout(() => {
        this.applyLogicToCodingLanguages();
      }, 2500);
    }
    // TODO: REMOVE LATER - End of custom refresh logic
  }

  // Audio Questions

  audioStopTimeout: any;
  audioAnsId: any;
  mediaRecorderAudio: MediaRecorder;
  recordedAudioAns: boolean = false;
  percent: number = 0;

  // ===== Audio/Video question response time limits (seconds) =====
  // Default used when BE sends no per-section limit (e.g. non-interview sections).
  defaultRecordingTime: number = 180; // 3 min fallback
  maxExplainRecordingTime: number = 180; // explain / verify-response video max (3 min)

  /**
   * Per-question response time (seconds) for the CURRENT section.
   * Driven by sectionDto.questionDurationInMins (in minutes) sent by BE on exam start.
   * Falls back to the 3-min default when absent or invalid.
   */
  get questionDurationSeconds(): number {
    const mins = Number(this.allQuestionsDataForTopBar?.questionDurationInMins);
    return mins > 0 ? mins * 60 : this.defaultRecordingTime;
  }
  // Same limit applies to both audio and video answers.
  get maxRecordingTime(): number {
    return this.questionDurationSeconds;
  }
  get maxVideoRecordingTime(): number {
    return this.questionDurationSeconds;
  }

  // Whole-minute labels for the "Max Time" text in the template.
  get maxVideoRecordingMinutes(): number {
    return Math.floor(this.maxVideoRecordingTime / 60);
  }
  get maxAudioRecordingMinutes(): number {
    return Math.floor(this.maxRecordingTime / 60);
  }

  startRecordingAudio() {
    this.isRecording = true;
    this.percent = 0;
    this.emptyRecordedFilePreviewUrl();
    this.recordedAudioAns = false;
    this.recorderOne = false;
    this.audioAnsId = '';
    navigator.mediaDevices
      .getUserMedia({ audio: { echoCancellation: true } })
      .then((stream) => {
        this.recordedChunksFile = [];

        this.mediaRecorderAudio = new MediaRecorder(stream);

        this.mediaRecorderAudio.ondataavailable = (event) => {
          if (event.data.size > 0) {
            this.recordedChunksFile.push(event.data);
          } else {
            console.warn('Empty chunk received, might be network delay');
          }
        };

        this.mediaRecorderAudio.onstop = () => {
          setTimeout(() => {
            this.handleAudioRecordingStop();
          }, 500);
        };

        this.audioRecordingInterval = setInterval(() => {
          this.audioRecordingTime++;
          this.percent =
            (this.audioRecordingTime / this.maxRecordingTime) * 100;
        }, 1000);

        this.mediaRecorderAudio.start();
        this.isRecording = true;

        this.videoStopTimeout = setTimeout(() => {
          this.stopRecordingAudio();
        }, this.maxRecordingTime * 1000); // audio answer max time
      })
      .catch((error) => {
        console.error('Error accessing microphone:', error);
      });
  }

  stopRecordingAudio() {
    if (
      this.mediaRecorderAudio &&
      this.mediaRecorderAudio.state !== 'inactive'
    ) {
      this.recordedAudioAns = true;
      this.mediaRecorderAudio.stop();
      this.isRecording = false;
      this.recordedAudioTime = this.formatTime(this.audioRecordingTime);
       this.seconds = 0;
      if (this.allQuestionsData) {
        this.allQuestionsData.recordedAudioTime = this.recordedAudioTime;
      }
      clearTimeout(this.audioStopTimeout);
      clearInterval(this.audioRecordingInterval);
      this.mediaRecorderAudio = null;
      this.audioRecordingTime = 0;
    }
  }

  timerForAudioQuestion: any;
  async handleAudioRecordingStop() {
    this.stopAudioTimer(); // stop timer
    this.playAudio = true;
    this.openPopUpForVideoQuestion = true;
    this.isUploading = true;
    this.startTimerForAudioQuestion(60);
    const audioBlob = new Blob(this.recordedChunksFile, { type: 'audio/webm' });
    const audioUrl = URL.createObjectURL(audioBlob);
    var file = new File([audioBlob], 'file', { type: audioBlob.type });
    const formData: FormData = new FormData();
    formData.append('file', file);
    // console.log(file,'size');

    // Create a download link for the recorded file.
    // const url = window.URL.createObjectURL(audioBlob);
    // const a = document.createElement('a');
    // a.style.display = 'none';
    // a.href = url;
    // a.download = 'audio.webm';
    // document.body.appendChild(a);
    // a.click();
    // window.URL.revokeObjectURL(url);
    // document.body.removeChild(a);
    //////////////////////////////////

    const audioPlayer = document.getElementById(
      'audioPlayer'
    ) as HTMLAudioElement;

    if (!this.autoSubmitExam) {
      audioPlayer.src = audioUrl;
    }

    const existingIndex = this.fileInformationList.findIndex(
      (obj) => obj.currentQuestionIndex === this.currentQuestionIndex
    );

    if (existingIndex !== -1) {
      this.fileInformationList[existingIndex] = {
        filePreviewUrl: audioUrl,
        currentQuestionIndex: this.currentQuestionIndex,
      };
    } else {
      this.fileInformationList.push({
        filePreviewUrl: audioUrl,
        currentQuestionIndex: this.currentQuestionIndex,
      });
    }

    localStorage.setItem(
      'fileInformationList',
      JSON.stringify(this.fileInformationList)
    );

    // this._examinationService
    //   .audioSaveAssessment(
    //     file,
    //     this.userAssessmentDriveSetIdForVideo,
    //     this.allQuestionsData.sectionQuestionId
    //   )
    //   .subscribe(
    //     (res) => {
    //       // Handle success
    //       this.audioAnsId = res?.data?.fileId;
    //       this.selectedAnswer(null, this.currentQuestionIndex, this.audioAnsId);
    //       this.getOptionSelectedOrNot(
    //         null,
    //         this.currentQuestionIndex,
    //         this.audioAnsId
    //       );

    //       if (
    //         res &&
    //         (res.statusCode === HttpStatusCode.Ok ||
    //           res.status == HttpStatusCode.Ok)
    //       ) {
    //         this.openPopUpForVideoQuestion = false;
    //         clearInterval(this.timerForAudioQuestion);
    //         if (this.autoSubmitExam) {
    //           this.autoSubmitForVideoQuestions();
    //         }
    //       }
    //     },
    //     (error) => {
    //       this.openPopUpForVideoQuestion = false;
    //       clearInterval(this.timerForAudioQuestion);
    //       if (this.autoSubmitExam) {
    //         this.autoSubmitForVideoQuestions();
    //       }
    //       console.error('API error:', error);
    //     }
    //   );
    try {
      const res = await this._examinationService
        .audioSaveAssessment(
          file,
          this.userAssessmentDriveSetIdForVideo,
          this.allQuestionsData.sectionQuestionId
        )
        .toPromise(); 

      // Handle success
      this.audioAnsId = res?.data?.fileId;
      this.selectedAnswer(null, this.currentQuestionIndex, this.audioAnsId);
      this.getOptionSelectedOrNot(
        null,
        this.currentQuestionIndex,
        this.audioAnsId
      );

      if (
        res &&
        (res.statusCode === HttpStatusCode.Ok ||
          res.status == HttpStatusCode.Ok)
      ) {
        this.openPopUpForVideoQuestion = false;
        clearInterval(this.timerForAudioQuestion);
        this.isUploading = false;
        if (this.autoSubmitExam) {
          this.autoSubmitForVideoQuestions();
        }
      }
    } catch (error) {
      this.openPopUpForVideoQuestion = false;
      clearInterval(this.timerForAudioQuestion);
      this.isUploading = false;
      if (this.autoSubmitExam) {
        this.autoSubmitForVideoQuestions();
      }
    }

  }

  @ViewChild('audioPlayer') audioPlayerRef!: ElementRef<HTMLAudioElement>;
  playAudio: boolean = true;
  toggleAudio() {
    const audioPlayer = this.audioPlayerRef.nativeElement;
    // 1. If the audio is ended OR the timer hit zero, reset to the start
  if (audioPlayer.ended) {
    this.seconds = 0;
    audioPlayer.currentTime = 0; // Rewind the actual audio file
    this.stopAudioTimer();
  }
    else{
      if (audioPlayer.paused ) {
        this.start();
        audioPlayer.play();
        this.playAudio = false;
      } else {
        this.stopAudioTimer();
        audioPlayer.pause();
        this.playAudio = true;
      }
    }
  }

  audioEnded() {
    console.log('ended');
    const audioPlayer = this.audioPlayerRef.nativeElement;
    this.stopAudioTimer(); // stop timer
     this.seconds = 0;
    this.playAudio = true;
  }

  resumeExaminatioTimer() {
    sessionStorage.removeItem('isExaminationTimerStopped');
    this.verifySurroundingModal = false;
  }

  originalQuestionType: any;
  enableChatGpt() {
    this.originalQuestionType = this.allQuestionsData.questionType;
    this.codeEditor = false;
    this.jupyterNotebookEnabled = false;
    this.selectCodeLanguage = false;
    this.chatGptSection = true;
    // this.allQuestionsData.questionType = '';
  }

  backToCodeEditor() {
    if (!this.selectedLanguage) {
      this.selectCodeLanguage = true;
    } else if (this.selectedLanguage === 'Jupyter Notebook') {
      this.loading = true;
      this.jupyterNotebookEnabled = true;
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    } else {
      this.codeEditor = true;
    }

    this.chatGptSection = false;
    this.allQuestionsData.questionType = this.originalQuestionType;
    this.minimizeQuestionSection = true;
  }

  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  userInput: string = '';
  chatHistory: { message: string; type: 'user' | 'bot' }[] = [];
  sendMessage() {
    if (this.userInput.trim()) {
      this.chatHistory.push({ message: this.userInput, type: 'user' });

      const loadingBotMessage: any = {
        message: '',
        type: 'bot',
        loading: true,
      };
      this.chatHistory.push(loadingBotMessage);

      const requestBody: any = {
        model: 'gpt-4.1',
        messages: [{ role: 'user', content: this.userInput }],
        max_tokens: 150,
        temperature: 0.5,
      };

      this._examinationService.openAIChatCompletion(requestBody).subscribe(
        (response) => {
          const botMessage = response.choices[0].message.content.trim();
          loadingBotMessage.loading = false;
          this.simulateTypingEffect(botMessage);
        },
        (error) => {
          console.error('Error:', error);
          this.chatHistory.push({
            message: 'An error occurred: ' + error.message,
            type: 'bot',
          });
        }
      );
      this.userInput = '';
    }
  }

  simulateTypingEffect(fullText: string) {
    let displayedText = '';
    const typingSpeed = 10;
    let index = 0;

    const typingInterval = setInterval(() => {
      if (index < fullText.length) {
        displayedText += fullText[index];
        index++;
        if (this.chatHistory[this.chatHistory.length - 1].type === 'bot') {
          this.chatHistory[this.chatHistory.length - 1].message = displayedText;
        } else {
          this.chatHistory.push({ message: displayedText, type: 'bot' });
        }
      } else {
        clearInterval(typingInterval);
      }
    }, typingSpeed);
  }

  getMobileQRLink() {
    let driveId = sessionStorage.getItem('driveId');
    this._examinationService.getQrCodeLink(driveId).subscribe({
      next: (res: any) => {
        let imagePath: any = this._sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + res.data
        );
        this.linkForQrCode = imagePath;
      },
    });
  }
  get reportedQuestionsArray() {
    return Array.from(this.questionReportMap.values());
  }
  

  openReportQuestionPopup() {
    this.atleastOneQuestionReported=true;
    this.toastr.success(
      'Reported successfully! Please provide feedback on reported questions at the end of the section.'
    );
    // this.reportQuestionPopup = true;
    // sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
    this.getQuestionObject(this.currentQuestionIndex).isReported = true;
    this.QuestionReportDto.appUserId = this.loginUser.id;
    this.QuestionReportDto.driveId = this.driveData;
    this.QuestionReportDto.questionId = this.allQuestionsData.questionId;
    this.QuestionReportDto.subCategoryId = this.subCategoriesId;
      const report={
        ...this.QuestionReportDto,
        allQuestionData: this.allQuestionsData
      };
      this.questionReportMap.set(report.questionId, report);
      console.log(this.questionReportMap);
      
  }

  submitVerifiedResponse() {
    if (!this.recordedVideoAns || this.isRecording) {
      this.toastr.error(
        'Please record and Submit the video to proceed',
        'Error'
      );
      return;
    }

    this.verifyUserResponseModal = false;
    this.toastr.success(
      'video response submitted successfully. Thank you! ',
      'Success'
    );
    if (this.isLastSection === false && this.autoSubmitAssessment === false) {
      if (this.sectionBreakTime > 0) {
        if(this.atleastOneQuestionReported){
          this.newReportedQuestionsPopup='openReport';
          sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
        }
        else{
          this.breakTimeScreen = true;
          this.startTimer(this.sectionBreakTime);
        }
      } else {
        if(this.atleastOneQuestionReported){
          this.newReportedQuestionsPopup='openReport';
          sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
        }
        else{
          this.breakTimeScreen = false;
          this.startNextSection();
        }
      }
    } else if (
      this.isLastSection === true ||
      this.autoSubmitAssessment === true
    ) {
      if(this.atleastOneQuestionReported){
        this.newReportedQuestionsPopup='openReport';
        sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
      }
      else{
        this.submitLastSection();
      }
    }
  }

  submitLastSection() {
    //  this.isSyncModalVisible = true;
    if (this.isLastSection == true || this.autoSubmitAssessment) {
      if (this.recordedChunks.length > 0) {
      if (this.isDesktopApp) {
        this.uploadVideo();
      } else {
        this.uploadScreenVideoOnWeb();
      }
      }
      if (this.chunks.length > 0) {
      if (this.isDesktopApp) {
        this.uploadVideoForWebCam(ChunkType.WEB_FEED);
      } else {
        this.uploadVideoForWebCamOnWeb(ChunkType.WEB_FEED);
      }
      }

      this.getExtentionDisabled();
      this.breakTimeScreen = false;
      this.isSectionStarted = false;
      // if (this.connectedDriveId == this.driveId) {
        this.stopScreenAndFeed();
      // }
      this.startedExamination = false;
      // if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      //   this.stopAllContainers();
      //   clearInterval(this.retryInterval);
      // }
      // if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      //   this.stopAllJupyterContainers();
      //   clearInterval(this.retryInterval);
      // }
      // this.isSyncModalVisible = true;
      sessionStorage.removeItem('enableStep5');

      // Simulate data sync process and navigate after completion
      setTimeout(() => {
        // this.isSyncModalVisible = false;
        this._router.navigate([
          this._commonService.Navigations.SUBMIT_SUCCESS_PAGE,
        ]);
        this._commonService.getAssessmentSubmitDetails.next(
          this.submitLastSectionResponse
        );
        if (this.connectedDriveId == this.driveId) {
          this.exitFullScreen();
        }
      }, 3000); // Show sync modal for 3 seconds
    } else {
      this.sectionTimer = 0;
      this.appTopBar.startTimerManually(
        this.sectionTimer,
        this.allQuestionsDataForTopBar
      );
      this.currentQuestionIndex = 0;
      this.subSectionDto.sectionQuestionList = [];
    }
  }

  selectedOption: string;
  getSelectedOption(selectedId: string): string {
    const options = this.selectedQuestionForExplanation.questionDto.options;
    const index = options.findIndex((res: any) => res.id === selectedId[0]);

    if (index !== -1) {
      const letter = String.fromCharCode(65 + index);
      this.selectedOption = letter;
      return `(${letter}) ${options[index].Option}`;
    }

    return 'Option not found';
  }

  isAudioType: boolean = false;
  handleExplainRecordingStop() {
    this.openPopUpForVideoQuestion = true;
    this.startTimerForVideoQuestion(60);
    const videoBlob = new Blob(this.recordedChunksFile, { type: 'video/webm' });
    const videoUrl = URL.createObjectURL(videoBlob);
    var file = new File([videoBlob], 'file', { type: videoBlob.type });
    const formData: FormData = new FormData();
    formData.append('file', file);

    const videoPlayer = document.getElementById(
      'videoPlayer'
    ) as HTMLVideoElement;

    if (!this.autoSubmitExam) {
      videoPlayer.src = videoUrl;
    }

    const questionId = this.selectedQuestionForExplanation.questionDto?.id;
    const sectionId =
      this.allQuestionsDataForTopBar?.id ||
      this.selectedQuestionForExplanation?.sectionId;

    this._examinationService
      .saveExplainedQuestion(
        this.userAssessmentDriveSetId,
        sectionId,
        questionId,
        this.isAudioType,
        file
      )
      .subscribe(
        (res) => {
          if (
            res &&
            (res.statusCode === HttpStatusCode.Ok ||
              res.status === HttpStatusCode.Ok)
          ) {
            this.openPopUpForVideoQuestion = false;
            clearInterval(this.timerForVideoQuestion);
            if (this.autoSubmitExam) {
              this.autoSubmitForVideoQuestions();
            }
          }
        },
        (error) => {
          this.openPopUpForVideoQuestion = false;
          clearInterval(this.timerForVideoQuestion);
          if (this.autoSubmitExam) {
            this.autoSubmitForVideoQuestions();
          }
          console.error('API error:', error);
        }
      );
  }

  showIDE: boolean = false;
  IDECodeOutput: boolean = false;
  toggleIDE() {
    this.loading = true;
    this.showIDE = true;
    setTimeout(() => {
      this.loading = false;
    }, 2000);
  }

  runIDECode() {
    this.IDECodeOutput = true;
  }

  goBackFromIDE() {
    this.showIDE = false;
    this.IDECodeOutput = false;
    // Clear any execution result/error 
    this.compile_execution_error = null;
    this.showExecutionError = false;
    this.IDECompiledTestCase = null;
  }

  showIDEWidth = 60;
  resizing = false;
  startResize(event: MouseEvent): void {
    this.resizing = true;

    // Create an overlay to capture mouse events
    const overlay = this.renderer.createElement('div');
    this.renderer.addClass(overlay, 'resize-overlay');
    this.renderer.appendChild(document.body, overlay);

    const startX = event.clientX;
    const initialWidth = this.showIDEWidth;

    const onMouseMove = (moveEvent: MouseEvent) => {
      if (!this.resizing) return;
      const diff = moveEvent.clientX - startX;
      const newWidth = Math.min(
        100,
        Math.max(0, initialWidth + (diff / window.innerWidth) * 100)
      );
      this.showIDEWidth = newWidth;
    };

    const onMouseUp = () => {
      this.resizing = false;
      this.renderer.removeChild(document.body, overlay);
      window.removeEventListener('mousemove', onMouseMove);
      window.removeEventListener('mouseup', onMouseUp);
    };

    window.addEventListener('mousemove', onMouseMove);
    window.addEventListener('mouseup', onMouseUp);
  }

  timeoutDuration: any = 2000;
  checkNetworkSpeedForCode() {
    const conn = (navigator as any).connection;
    // let networkSpeed = conn.downlink * 1000;
    // console.log(conn.downlink,'downnnn');
    const downlink = conn?.downlink ?? null;
    if (downlink === null) {
      this.timeoutDuration = 8000;
      return;
    }
  
    const networkSpeed = downlink * 1000;
    

    // console.log(networkSpeed, 'networkSpeed');
    if (networkSpeed < 100) {
      this.timeoutDuration = 10000;
    } else if (networkSpeed < 500) {
      this.timeoutDuration = 8000;
    } else if (networkSpeed < 1000) {
      this.timeoutDuration = 6000;
    } else if (networkSpeed < 2000) {
      this.timeoutDuration = 4000;
    } else {
      this.timeoutDuration = 2000;
    }
  }

  inputBoilerCode() {
    this.loading = true;
    this.currentMessageIndex = 0;
    if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      const jupyterLang = this.codingLanguages?.find(
        (lang) => lang.name === 'Jupyter Notebook'
      );
      if (jupyterLang) {
        this.codingLanguages.forEach((lang) => (lang.selected = false));
        jupyterLang.selected = true;
        this.selectedLanguage = jupyterLang.name;
        this.selectedLanguageId = jupyterLang.id;
        this.allQuestions[this.currentQuestionIndex].selectedLanguage =
          jupyterLang;
      }
    }

    setTimeout(() => {
      console.log(this.codingLanguages, 'this.codingLanguages');

      let selectedLanguage = this.codingLanguages?.find((res: any) => {
        return (
          (res.id === '92' || res.id === '70' || res.id === '62' || res.id === '01' || res.id === '110' || res.id === '105' || res.id === '51') &&
          res.selected
        );
      });

      if (!selectedLanguage) {
        selectedLanguage =(this.selectedLanguageId? this.codingLanguages?.find((res:any)=> String(res.id)===String(this.selectedLanguageId)):null) ||  this.codingLanguages?.find((lang: any) => ['92','70','62','01','110','105','51'].includes(lang.id)) ||
          this.codingLanguages[0];

        if (selectedLanguage) {
          this.codingLanguages.forEach((lang: any) => (lang.selected = false));
          selectedLanguage.selected = true;
          this.selectedLanguage = selectedLanguage.name;
          this.selectedLanguageId = selectedLanguage.id;
          this.updateEditorMode(selectedLanguage.id);
          if (this.allQuestions && this.allQuestions[this.currentQuestionIndex]) {
            this.allQuestions[this.currentQuestionIndex].selectedLanguage = selectedLanguage;
          }
        }
      }

      console.log(selectedLanguage, 'selectedLanguage');

      let selectedLanguageName = selectedLanguage?.name?.replace(/\s+/g, '');
      
      if(selectedLanguage.id === '110') {
        selectedLanguageName = 'c';
      }
      else if(selectedLanguage.id === '105') {
        selectedLanguageName = 'cplus';
      }
      else if(selectedLanguage.id === '51') {
        selectedLanguageName = 'csharp';
      }

      const boilerPayload = {
        questionId: this.allQuestionsData?.questionId,
        userAssessmentDriveSetId: this.userAssessmentDriveSetId,
        LanguageType: selectedLanguageName,
      };

      if (selectedLanguage && selectedLanguage.selected) {
        this._examinationService
          .getMultipleBoilerPlateCode(boilerPayload)
          .subscribe(
            (response) => {
              if (response && response.statusCode === HttpStatusCode.Ok) {
                this.code = response.data?.data?.BoilerPlateCode;
                // Restore previously typed code for this language if available (per-language persistence)
                this.testCasesList = [];
                const savedPerLangCode = this.allQuestions[this.currentQuestionIndex]?.languageCodeMap?.[selectedLanguage.id];
                if (savedPerLangCode != null && savedPerLangCode !== '') {
                  this.code = savedPerLangCode;
                  this.answers[this.currentQuestionIndex] = savedPerLangCode;
                  this.allQuestions[this.currentQuestionIndex].selectedAnswers = savedPerLangCode;
                  this.allQuestions[this.currentQuestionIndex].savedLanguage = { name: selectedLanguage.name, id: selectedLanguage.id };
                }
                this.loading = false;
                if (response.data?.jupyterResponse?.url) {
                  this.jupyterLoader = true;
                  this.jupyterContainerName = response.data?.jupyterResponse?.container_name;
                  const jupyterUrl = response.data?.jupyterResponse?.url;

                  if (jupyterUrl && jupyterUrl.startsWith('https://')) {
                    this.jupyterNotebookName = this._sanitizer.bypassSecurityTrustResourceUrl(jupyterUrl);
                    sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));
                    this.cycleJupyterMessages();

                    const navQuestionId = this.allQuestionsData?.questionId;
                    if (this.jupyterBoilerLoaderOffTimer) {
                      clearTimeout(this.jupyterBoilerLoaderOffTimer);
                    }
                    this.jupyterBoilerLoaderOffTimer = setTimeout(() => {
                      this.jupyterBoilerLoaderOffTimer = null;
                      if (this.allQuestionsData?.questionId !== navQuestionId) return;
                      sessionStorage.removeItem('isExaminationTimerStopped');
                      this.jupyterLoader = false;
                    }, 36000);
                  } else {
                    console.warn('Blocked potentially unsafe Jupyter URL:', jupyterUrl);
                    this.jupyterNotebookName = null;
                    this.loading = false;
                    this.jupyterLoader = false;
                  }
                }
              }
            },
            (error) => {
              this.loading = false;
              if (error.statusCode >= 500) {
                this.toastr.error('Something went wrong');
              } 
              else {
                this.toastr.error(error?.error?.message);
              }
              console.error('API error:', error);
            }
          );
      } else {
        this.loading = false;
      }
    }, 1000);
  }

  idToStopJupyterContainer: any;
  // inputBoilerCode() {
  //   this.loading = true;
  //   this.IDELoader = true;
  //   this.jupyterLoader = true
  //   this.currentMessageIndex = 0;

  //   // Handle default language selection for Jupyter
  //   if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
  //     const jupyterLang = this.codingLanguages.find(
  //       (lang) => lang.name === 'Jupyter Notebook'
  //     );

  //     if (jupyterLang) {
  //       this.codingLanguages.forEach((lang) => (lang.selected = false));
  //       jupyterLang.selected = true;
  //       this.selectedLanguage = jupyterLang.name;
  //       this.selectedLanguageId = jupyterLang.id;
  //       this.allQuestions[this.currentQuestionIndex].selectedLanguage =
  //         jupyterLang;
  //     }
  //   }

  //   setTimeout(() => {
  //     const selectedLanguage = this.codingLanguages.find((res: any) => {
  //       return ['92', '70', '62', '01'].includes(res.id) && res.selected;
  //     });

  //     const selectedLanguageName = selectedLanguage.name.replace(/\s+/g, '');

  //     const boilerPayload = {
  //       // questionId: this.allQuestionsData.questionId,
  //       // userAssessmentDriveSetId: this.userAssessmentDriveSetId,
  //       LanguageType: selectedLanguageName,
  //       question_id: this.allQuestionsData.questionId,
  //       candidate_id: this.loginUser.id,
  //       userAssessmentDriveSetId: this.userAssessmentDriveSetId,
  //       driveId: this.driveData,
  //     };

  //     this._examinationService
  //       .createJupyterServer(boilerPayload)
  //       .subscribe(
  //         (response) => {
  //           this.loading = false;

  //           if (response?.statusCode === 200) {
  //             console.log(response, 'BoilerPlateCode response');

  //             this.code = response.data?.BoilerPlateCode;

  //             // 🚀 If Jupyter container needs polling
  //             // if (response.data?.jupyterResponse?.container_name) {
  //               // const containerId = response.data.jupyterResponse.container_name;
  //               const containerId = this.loginUser.id + '-' + this.allQuestionsData.questionId;
  //               console.log('Starting Jupyter polling:', containerId);

  //               this.pollContainerStatus(
  //                 containerId,
  //                 (statusResponse) => this.bindJupyterUrls(statusResponse), // callback
  //                 50, // attempts
  //                 2000 // interval
  //               );
  //             // }
  //           }
  //         },
  //         (error) => {
  //           this.loading = false;
  //           console.error('API error:', error);
  //         }
  //       );
  //   }, 1000);
  // }

  private bindJupyterUrls(response: any) {
    this.IDEContainerUrl = null;
    this.loading = true;
    this.jupyterLoader = true;
    this.jupyterNotebookName = null;
    const existingIframe = document.getElementById('jupyter-iframe');
    if (existingIframe) {
      existingIframe.remove();
    }

    let jupyterUrl = response.ideUrls?.jupyter_lab;
    const containerName = response.containerName;
    // jupyterUrl = jupyterUrl + '?t=' + Date.now();
    jupyterUrl =
      response.ideUrls.jupyter_lab + '?reset&disableSW=1&t=' + Date.now();
    // jupyterUrl = response.ideUrls?.jupyter_lab + '?reset=1&force=1&t=' + Date.now();

    this.jupyterContainerName = containerName;
    this.idToStopJupyterContainer = this.allQuestionsData.questionId;
    this.jupyterNotebookName =
      this._sanitizer.bypassSecurityTrustResourceUrl(jupyterUrl);
    // this.markCurrentQuestionAttempted();
    this.markCurrentQuestionOpened();
    this.statusApiCallTime = 2000;

    sessionStorage.setItem('isExaminationTimerStopped', JSON.stringify(true));

    // this.cycleJupyterMessages();

    const navQuestionId = this.allQuestionsData?.questionId;
    if (this.jupyterLoaderOffTimer) {
      clearTimeout(this.jupyterLoaderOffTimer);
    }
    this.jupyterLoaderOffTimer = setTimeout(() => {
      this.jupyterLoaderOffTimer = null;
      if (this.allQuestionsData?.questionId !== navQuestionId) return;
      sessionStorage.removeItem('isExaminationTimerStopped');
      this.jupyterLoader = false;
      this.loading = false;
      this.IDELoader = false;
    }, 2000); // same as your old logic

    const iframe = document.createElement('iframe');
    iframe.id = 'jupyter-iframe';
    iframe.src = jupyterUrl;
    iframe.width = '100%';
    iframe.height = '92%';
    iframe.style.border = 'none';
    iframe.setAttribute('tabindex', '-1');

    document.getElementById('jupyter-container')?.appendChild(iframe);
  }

  private pollContainerStatus(
    containerId: string,
    onRunning: (statusResponse: any) => void,
    maxAttempts: number = 50,
    interval: number = 2000
  ) {
    let attempts = 0;

    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }

    this.retryInterval = setInterval(() => {
      if (attempts >= maxAttempts) {
        console.log('❌ Jupyter container not running after max retries.');
        clearInterval(this.retryInterval);
        return;
    }

      attempts++;
      console.log(`🔁 Jupyter status attempt #${attempts}`);

      this._examinationService.containerStatusCheck(containerId).subscribe(
        (status) => {
          if (status?.status === 'RUNNING') {
            clearInterval(this.retryInterval);
            console.log('✅ Jupyter container is RUNNING');
            setTimeout(() => {
              onRunning(status);
            }, 5000);
          }
        },
        (err) => console.error('Jupyter status check failed:', err)
      );
    }, interval);
  }

  createJupyterServer() {
    // this.currentMessageIndex = 0;
    this.loading = true;
    this.isLoading = true;
    this.jupyterLoader = true;
    // const existingIframe = document.getElementById('jupyter-iframe');
    // if (existingIframe) {
    //   existingIframe.remove();
    // }

    const containerId =
      this.loginUser.id + '-' + this.allQuestionsData.questionId;

    this.idToStopJupyterContainer = this.allQuestionsData.questionId;

    const requestQuestionId = this.allQuestionsData?.questionId;
    let attempt = 0;
    let pending = false;

    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }

    const myInterval = setInterval(() => {
      if (pending) return;
      if (attempt >= 50) {
        console.log('⛔ Finished Jupyter status check retries.');
        clearInterval(myInterval);
        if (this.allQuestionsData?.questionId === requestQuestionId) {
          this.jupyterLoader = false;
          this.isLoading = false;
          this.loading = false;
          this.toastr?.error('Container not loaded, please switch to next question');
        }
        return;
      }

      attempt++;
      pending = true;
      console.log(`🔁 Jupyter container status attempt #${attempt}`);

      try {
        this._examinationService
          .containerStatusCheck(containerId)
          .subscribe({
        next: (statusResponse) => {
          pending = false;
          if (statusResponse && statusResponse.status === 'RUNNING') {
            clearInterval(myInterval);
            if (this.allQuestionsData?.questionId !== requestQuestionId) {
              // User navigated away before container was ready; drop stale response.
              return;
            }
                console.log('✅ Jupyter container is now RUNNING');
                this.bindJupyterUrls(statusResponse);
          }
        },
            error: () => { pending = false; }
      });
      } catch (err) {
        pending = false;
        console.error('❌ Error checking Jupyter container status:', err);
      }
    }, this.statusApiCallTime);
    this.retryInterval = myInterval;
  }

  onIframeLoad() {
    console.log('Jupyter iframe has finished loading.');
    this.loading = false;
  }

  getFeedsCount() {
    const webFeedCounter = localStorage.getItem('webFeedCounter');
    const screenShareCounter = localStorage.getItem('screenShareCounter');

    this.webFeedCounter = JSON.parse(webFeedCounter);
    this.screenShareCounter = JSON.parse(screenShareCounter);
    this.progressiveResponseData.countOfWebFeedChunks = this.webFeedCounter;
    this.progressiveResponseData.countOfScreeShareChunks =
      this.screenShareCounter;
  }

  isIDELoading: boolean;
  IDEContainerName: any;
  IDEContainerUrl: any;
  // IDEpreviewUrl: any = 'https://git.thrymr.net/preview/35328';
  // rawPreviewUrl: string = 'https://git.thrymr.net/preview/35328';
  loadingMessages: string[] = [
    'Initializing IDE...',
    'Installing dependencies...',
    'Installing libraries...',
    'Setting up your environment...',
    'Configuring project workspace...',
    'Loading essential tools...',
    'Getting things ready...',
    'Almost ready to code...',
  ];

  jupyterLoadingMessages: string[] = [
    'Initializing Jupyter Notebook...',
    'Setting up environment...',
    'Preparing your workspace...',
    'Loading kernels and extensions...',
    'Launching your notebook...',
    'Almost ready to code...',
  ];

  jupyterLoader: boolean = false;
  IDELoader: boolean;
  currentMessageIndex = 0;
  showPreviewPanel: boolean = false;
  rawPreviewUrl: any;
  IDEpreviewUrl: any;
  testCaseFolderPath: any;
  previewPort: any;
  idToStopContainer: any;
  // createCodeServer() {
  //   // this.loading = true;
  //   this.currentMessageIndex = 0;
  //   const oldIframe = document.getElementById('code-iframe');
  //   if (oldIframe) {
  //     oldIframe.remove();
  //   }

  //   const requestPayload = {
  //     // question_id: this.allQuestionsData.questionId,
  //     // candidate_id: this.loginUser.id,
  //     // userAssessmentDriveSetId: this.userAssessmentDriveSetId,
  //     // driveId: this.driveData,
  //     question_id: this.allQuestionsData.questionId,
  //     candidate_id: this.loginUser.id,
  //     userAssessmentDriveSetId: this.userAssessmentDriveSetId,
  //     driveId: this.driveData,
  //   };

  //   this._examinationService.createCodeServer(requestPayload).subscribe(
  //     (response) => {
  //       // this.loading = true;
  //       this.idToStopContainer = this.allQuestionsData.questionId;
  //       this.IDELoader = true;
  //       let attempt = 0;
  //       const retryInterval = setInterval(() => {
  //         if (attempt >= 15) {
  //           console.log('✅ Finished blind reload retries for containers.');
  //           clearInterval(retryInterval);
  //           return;
  //         }
  //         attempt++;
  //         console.log(
  //           `🔁 Blind reloadPreview attempt for container #${attempt}`
  //         );
  //         try {
  //           let d = response?.data?.candidateId + '-' + response?.data?.questionId;
  //           this._examinationService
  //             .containerStatusCheck(d)
  //             .subscribe((response) => {
  //               if (response) {
  //                 if (response.status === 'RUNNING') {
  //                   clearInterval(retryInterval);
  //                   const IDEUrl = response.ideUrls?.code_server;
  //                   const previewUrl = response.ideUrls?.preview;
  //                   this.previewPort = response.idePorts?.preview_port;
  //                   this.IDEContainerUrl =
  //                     this._sanitizer.bypassSecurityTrustResourceUrl(IDEUrl);

  //                   this.rawPreviewUrl = previewUrl;
  //                   this.IDEpreviewUrl =
  //                     this._sanitizer.bypassSecurityTrustResourceUrl(
  //                       previewUrl
  //                     );
  //                   this.IDELoader = true;
  //                   this.showIDE = true;
  //                   this.cycleMessages();

  //                   setTimeout(() => {
  //                     sessionStorage.removeItem('isExaminationTimerStopped');
  //                     this.IDELoader = false;
  //                     this.IDECodeOutput = true;
  //                     this.showPreviewPanel = false;
  //                     // this.reloadPreview();
  //                     // this.startBlindReloadRetries(20, 5000);
  //                   }, 1000);
  //                   const previousIframe =
  //                     document.getElementById('code-iframe');
  //                   if (previousIframe) {
  //                     previousIframe.remove();
  //                   }

  //                   const iframe = document.createElement('iframe');
  //                   iframe.id = 'code-iframe';
  //                   iframe.src = IDEUrl;
  //                   iframe.width = '100%';
  //                   iframe.height = '100%';
  //                   iframe.style.border = 'none';
  //                   iframe.setAttribute('tabindex', '-1');

  //                   document
  //                     .getElementById('iframe-container')
  //                     ?.appendChild(iframe);
  //                   this.isIDELoading = true;
  //                   this.loading = false;
  //                 }
  //                 console.log('✅ Blind status Api successful:', response);
  //               }
  //             });
  //         } catch (err) {
  //           console.error('Error during blind reloadPreview:', err);
  //           // Still continue — we’re blind anyway
  //         }
  //       }, 1000 * 30); // Retry every 30 seconds

  //       // if (response && response.statusCode === HttpStatusCode.Ok) {
  //       //   this.IDELoader = true;
  //       //   this.IDEContainerName = response.data?.container_name;
  //       //   const IDEUrl = response.data?.url;
  //       //   const previewUrl = response.data?.preview_url;
  //       //   this.testCaseFolderPath = response.data?.test_case_folder;
  //       //   this.previewPort = response.data?.preview_port;

  //       //   if (IDEUrl) {
  //       //     // this.IDEContainerUrl =
  //       //     //   this._sanitizer.bypassSecurityTrustResourceUrl(IDEUrl);

  //       //     // this.IDEpreviewUrl =
  //       //     //   this._sanitizer.bypassSecurityTrustResourceUrl(previewUrl);

  //       //     setTimeout(() => {
  //       //       sessionStorage.setItem(
  //       //         'isExaminationTimerStopped',
  //       //         JSON.stringify(true)
  //       //       );
  //       //       this.updatePreviewPort();

  //       //       this.IDEContainerUrl =
  //       //         this._sanitizer.bypassSecurityTrustResourceUrl(IDEUrl);

  //       //       this.rawPreviewUrl = previewUrl;
  //       //       this.IDEpreviewUrl =
  //       //         this._sanitizer.bypassSecurityTrustResourceUrl(previewUrl);
  //       //       this.IDELoader = true;

  //       //       this.cycleMessages();

  //       //       this.showIDE = true;

  //       //       setTimeout(() => {
  //       //         sessionStorage.removeItem('isExaminationTimerStopped');
  //       //         this.IDELoader = false;
  //       //         this.IDECodeOutput = true;
  //       //         this.showPreviewPanel = false;
  //       //         this.reloadPreview();
  //       //         this.startBlindReloadRetries(20, 5000);
  //       //       }, 80000);
  //       //       const previousIframe = document.getElementById('code-iframe');
  //       //       if (previousIframe) {
  //       //         previousIframe.remove();
  //       //       }

  //       //       const iframe = document.createElement('iframe');
  //       //       iframe.id = 'code-iframe';
  //       //       iframe.src = IDEUrl;
  //       //       iframe.width = '100%';
  //       //       iframe.height = '100%';
  //       //       iframe.style.border = 'none';
  //       //       iframe.setAttribute('tabindex', '-1');

  //       //       document.getElementById('iframe-container')?.appendChild(iframe);
  //       //       this.isIDELoading = true;
  //       //       this.loading = false;
  //       //     }, 5000);
  //       //   } else {
  //       //     console.error('No URL received in the response');
  //       //     this.loading = false;
  //       //   }
  //       // } else {
  //       //   this.loading = false;
  //       // }
  //     },
  //     (error) => {
  //       this.loading = false;
  //       console.error('API error:', error);
  //     }
  //   );
  // }
  retryInterval: any;
  createCodeServer() {
    this.loading = true;
    this.IDELoader = true;
    this.currentMessageIndex = 0;
    const existingIframe = document.getElementById('jupyter-iframe');
    if (existingIframe) {
      existingIframe.remove();
    }
    // const oldIframe = document.getElementById('code-iframe');
    // if (oldIframe) {
    //   oldIframe.remove();
    // }

    const containerId =
      this.loginUser.id + '-' + this.allQuestionsData.questionId;

    this.idToStopContainer = this.allQuestionsData.questionId;
    // this.IDELoader = true;
    const requestQuestionId = this.allQuestionsData?.questionId;
    let attempt = 0;
    let pending = false;
    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }

    const myInterval = setInterval(() => {
      if (pending) return;
      if (attempt >= 50) {
        console.log('✅ Finished container status check retries.');
        clearInterval(myInterval);
        if (this.allQuestionsData?.questionId === requestQuestionId) {
        this.IDELoader = false;
        this.loading = false;
        this.toastr?.error('Container not loaded, please switch to next question');
        }
        return;
      }
      attempt++;
      pending = true;
      console.log(`🔁 Container status check attempt #${attempt}`);

      try {
        // let containerId = response?.data?.candidateId + '-' + response?.data?.questionId;
        this._examinationService
          .containerStatusCheck(containerId)
          .subscribe({
            next: (statusResponse) => {
              pending = false;
              if (statusResponse && statusResponse.status === 'RUNNING') {
                clearInterval(myInterval);
                if (this.allQuestionsData?.questionId !== requestQuestionId) {
                  // User navigated away before container was ready; drop stale response.
                  return;
                }
                console.log('✅ Container is now running');
                this.bindIDEUrls(statusResponse);
              }
            },
            error: () => { pending = false; }
          });
      } catch (err) {
        pending = false;
        //     this.startNewContainer();
        console.error('Error during container status check:', err);
      }
    }, this.statusApiCallTime); //
    this.retryInterval = myInterval;
    // // First, check if container is already running
    // this._examinationService.containerStatusCheck(containerId).subscribe(
    //   (statusResponse) => {
    //     if (statusResponse && statusResponse.status === 'RUNNING') {
    //       // Container is already running, just bind the URLs
    //       console.log('✅ Container already running, binding URLs');
    //       this.bindIDEUrls(statusResponse);
    //     } else {
    //       // // Container is not running, create new container
    //       // console.log('🔄 Container not running, creating new container');
    //       // this.startNewContainer();
    //     }
    //   },
    //   (error) => {
    //     // If status check fails (container doesn't exist), create new one
    //     console.log('⚠️ Status check failed, creating new container');
    //     this.startNewContainer();
    //   }
    // );
  }

  createCodeServerOnSwitch() {
    this.loading = true;
    // this.IDELoader = true;
    // this.currentMessageIndex = 0;
    // const oldIframe = document.getElementById('code-iframe');
    // if (oldIframe) {
    //   oldIframe.remove();
    // }

    const containerId =
      this.loginUser.id + '-' + this.allQuestionsData.questionId;

    this.idToStopContainer = this.allQuestionsData.questionId;
    // this.IDELoader = true;
    const requestQuestionId = this.allQuestionsData?.questionId;
    let attempt = 0;
    let pending = false;
    if (this.retryInterval) {
      clearInterval(this.retryInterval);
    }

    const myInterval = setInterval(() => {
      if (pending) return;
      if (attempt >= 50) {
        console.log('✅ Finished container status check retries.');
        clearInterval(myInterval);
        if (this.allQuestionsData?.questionId === requestQuestionId) {
        this.IDELoader = false;
        this.loading = false;
        this.toastr?.error('Container not loaded, please switch to next question');
        }
        return;
      }
      attempt++;
      pending = true;
      console.log(`🔁 Container status check attempt #${attempt}`);

      try {
        // let containerId = response?.data?.candidateId + '-' + response?.data?.questionId;
        this._examinationService
          .containerStatusCheck(containerId)
          .subscribe({
            next: (statusResponse) => {
              pending = false;
              if (statusResponse && statusResponse.status === 'RUNNING') {
                clearInterval(myInterval);
                if (this.allQuestionsData?.questionId !== requestQuestionId) {
                  // User navigated away before container was ready; drop stale response.
                  return;
                }
                console.log('✅ Container is now running');
                this.bindIDEUrls(statusResponse);
              }
            },
            error: () => { pending = false; }
          });
      } catch (err) {
        pending = false;
        //     this.startNewContainer();
        console.error('Error during container status check:', err);
      }
    }, this.statusApiCallTime); // Retry every 20 seconds
    this.retryInterval = myInterval;
    // // First, check if container is already running
    // this._examinationService.containerStatusCheck(containerId).subscribe(
    //   (statusResponse) => {
    //     if (statusResponse && statusResponse.status === 'RUNNING') {
    //       // Container is already running, just bind the URLs
    //       console.log('✅ Container already running, binding URLs');
    //       this.bindIDEUrls(statusResponse);
    //     } else {
    //       // // Container is not running, create new container
    //       // console.log('🔄 Container not running, creating new container');
    //       // this.startNewContainer();
    //     }
    //   },
    //   (error) => {
    //     // If status check fails (container doesn't exist), create new one
    //     console.log('⚠️ Status check failed, creating new container');
    //     this.startNewContainer();
    //   }
    // );
  }

  private bindIDEUrls(response: any) {
    this.IDEContainerUrl = null;
    this.jupyterNotebookName = null;
    // const oldIframe = document.getElementById('code-iframe');
    // if (oldIframe) {
    //   oldIframe.remove();
    // }

    this.idToStopContainer = this.allQuestionsData.questionId;
    this.loading = true;
    this.IDELoader = true;
    this.clearPreviewConsole();
    const IDEUrl = response.ideUrls?.code_server;
    const previewUrl = response.ideUrls?.preview;
    this.previewPort = response.idePorts?.preview_port;
    this.testCaseFolderPath = response.containerZipName;
    this.IDEContainerUrl =
      this._sanitizer.bypassSecurityTrustResourceUrl(IDEUrl);
    this.rawPreviewUrl = previewUrl;
    this.IDEpreviewUrl =
      this._sanitizer.bypassSecurityTrustResourceUrl(previewUrl);
    // this.markCurrentQuestionAttempted();
    this.markCurrentQuestionOpened();

    this.showIDE = true;
    this.cycleMessages();
    this.statusApiCallTime = 2000;

    const navQuestionId = this.allQuestionsData?.questionId;
    if (this.ideLoaderOffTimer) {
      clearTimeout(this.ideLoaderOffTimer);
    }
    this.ideLoaderOffTimer = setTimeout(() => {
      this.ideLoaderOffTimer = null;
      if (this.allQuestionsData?.questionId !== navQuestionId) return;
      sessionStorage.removeItem('isExaminationTimerStopped');
      this.loading = false;
      this.IDELoader = false;
      this.IDECodeOutput = true;
      this.showPreviewPanel = false;
      this.isIDELoading = true;
      this.IDECompiledTestCase = null;
    }, 2000);

    // const previousIframe = document.getElementById('code-iframe');
    // if (previousIframe) {
    //   previousIframe.remove();
    // }

    // const iframe = document.createElement('iframe');
    // iframe.id = 'code-iframe';
    // iframe.src = IDEUrl;
    // iframe.width = '100%';
    // iframe.style.height = 'calc(100vh - 20rem)';
    // iframe.style.border = 'none';
    // iframe.setAttribute('tabindex', '-1');

    // const previousIframes = document.getElementById('code-iframe');
    // if (previousIframes) {
    //   previousIframes.remove();
    // }

    // document.getElementById('ide-code-container')?.appendChild(iframe);
    // this.loading = false;
  }

  private startNewContainer() {
    const requestPayload = {
      question_id: this.allQuestionsData.questionId,
      candidate_id: this.loginUser.id,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
    };

    this._examinationService.createCodeServer(requestPayload).subscribe(
      (response) => {
        this.idToStopContainer = this.allQuestionsData.questionId;
        this.IDELoader = true;
        let attempt = 0;

        const retryInterval = setInterval(() => {
          if (attempt >= 15) {
            console.log('✅ Finished container status check retries.');
            clearInterval(retryInterval);
            return;
          }
          attempt++;
          console.log(`🔁 Container status check attempt #${attempt}`);

          try {
            let containerId =
              response?.data?.candidateId + '-' + response?.data?.questionId;
            this._examinationService
              .containerStatusCheck(containerId)
              .subscribe((statusResponse) => {
                if (statusResponse && statusResponse.status === 'RUNNING') {
                  clearInterval(retryInterval);
                  console.log('✅ Container is now running');
                  this.bindIDEUrls(statusResponse);
                }
              });
          } catch (err) {
            console.error('Error during container status check:', err);
          }
        }, this.statusApiCallTime); // Retry every 20 seconds
      },
      (error) => {
        this.loading = false;
        console.error('API error:', error);
      }
    );
  }

  stopCodeServer() {
    this.loading = true;
    this.StopCodeServerDto.question_id = this.allQuestionsData.questionId;
    this.StopCodeServerDto.candidate_id = this.loginUser.id;
    this.StopCodeServerDto.userAssessmentDriveSetId =
      this.userAssessmentDriveSetId;
    this.StopCodeServerDto.driveId = this.driveData;
    this.StopCodeServerDto.container_name = this.IDEContainerName;

    const requestPayload = {
      question_id: this.idToStopContainer,
      candidate_id: this.loginUser.id,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
      // questionId: this.allQuestionsData.questionId,
      // candidateId: this.loginUser.id,
      // assessmentDriveId: this.userAssessmentDriveSetId,
      // driverId: this.driveData,
    };

    this._examinationService.stopCodeServer(requestPayload).subscribe({
      next: (response) => {
        if (response && response.statusCode === HttpStatusCode.Ok) {
          if (
            (!this.isLastSection || this.startedExamination) &&
            (!this.autoSubmitAssessment || !this.lastSectionAndLastQuestion)
          ) {
            this.createCodeServerOnSwitch();
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 5000);
          } else {
            this.loading = false;
          }
        }
      },
      error: (error) => {
        this.loading = false;
        console.error('API error:', error);
      },
    });
  }
  stopAllJupyterContainers() {
    if (this.allJupyterQuestionsIds.length === 0) return;
    this.loading = true;
    this.StopCodeServerDto.question_id = this.allQuestionsData.questionId;
    this.StopCodeServerDto.candidate_id = this.loginUser.id;
    this.StopCodeServerDto.userAssessmentDriveSetId =
      this.userAssessmentDriveSetId;
    this.StopCodeServerDto.driveId = this.driveData;
    this.StopCodeServerDto.container_name = this.IDEContainerName;

    this.allJupyterQuestionsIds.forEach((questionId) => {
      console.log(questionId, 'questionId to stop container');

      const requestPayload = {
        question_id: questionId,
        candidate_id: this.loginUser.id,
        userAssessmentDriveSetId: this.userAssessmentDriveSetId,
        driveId: this.driveData,
        // questionId: this.allQuestionsData.questionId,
        // candidateId: this.loginUser.id,
        // assessmentDriveId: this.userAssessmentDriveSetId,
        // driverId: this.driveData,
      };

      this._examinationService.stopCodeServer(requestPayload).subscribe({
        next: (response) => {
          if (response && response.statusCode === HttpStatusCode.Ok) {
            // if (
              // (!this.isLastSection || this.startedExamination) &&
              // (!this.autoSubmitAssessment || !this.lastSectionAndLastQuestion)
            // ) {
              // this.createJupyterServer();
              // this.loading = true;
              // setTimeout(() => {
              //   this.loading = false;
              // }, 5000);
            // } else {
              this.loading = false;
            // }
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('API error:', error);
        },
      });
    });
  }

  stopAllContainers() {
    this.loading = true;
    // this.StopCodeServerDto.question_id = this.allQuestionsData.questionId;
    // this.StopCodeServerDto.candidate_id = this.loginUser.id;
    // this.StopCodeServerDto.userAssessmentDriveSetId =
    //   this.userAssessmentDriveSetId;
    // this.StopCodeServerDto.driveId = this.driveData;
    // this.StopCodeServerDto.container_name = this.IDEContainerName;

    this.allIDEQuestionsIds.forEach((questionId) => {
      console.log(questionId, 'questionId to stop container');

      const requestPayload = {
        question_id: questionId,
        candidate_id: this.loginUser.id,
        userAssessmentDriveSetId: this.userAssessmentDriveSetId,
        driveId: this.driveData,
        // questionId: this.allQuestionsData.questionId,
        // candidateId: this.loginUser.id,
        // assessmentDriveId: this.userAssessmentDriveSetId,
        // driverId: this.driveData,
      };

      this._examinationService.stopCodeServer(requestPayload).subscribe({
        next: (response) => {
          if (response && response.statusCode === HttpStatusCode.Ok) {
            // if (
            //   (!this.isLastSection || this.startedExamination) &&
            //   (!this.autoSubmitAssessment || !this.lastSectionAndLastQuestion)
            // ) {
            //   this.createCodeServer();
            //   this.loading = true;
              // setTimeout(() => {
              //   this.loading = false;
              // }, 5000);
            // } else {
              this.loading = false;
            // }
          }
        },
        error: (error) => {
          this.loading = false;
          console.error('API error:', error);
        },
      });
    });
  }

  verifyUserData: any;
  verifyInviteLink(verifyToken: string) {
    this.loading = true;
    this._examinationService.verifyInviteLink(verifyToken).subscribe(
      (response) => {
        if (response && response.statusCode === HttpStatusCode.Ok) {
          this.verifyUserData = response.data;
          sessionStorage.setItem('driveId', this.verifyUserData?.driveId);
          this.loggedInUserService.setLoggedInUser(
            LoggedInUserKeys.DRIVE_DETAILS,
            this.verifyUserData?.driveId
          );
          this.setAllocation(this.verifyUserData?.driveId);
          this.loading = false;
        }
      },
      (error) => {
        this.loading = false;
        console.error('API error:', error);
      }
    );
  }

  setAllocation(data) {
    this._examinationService
      .getSetAllocationDetails(data)
      .subscribe((response) => {
        if (response.statusCode === HttpStatusCode.Ok) {
          this._router.navigate([
            this._commonService.Navigations.INSTALL_PLUGIN_PAGE,
          ]);
          this.toastr.success(response.message, 'Success');
        } else {
          this.toastr.success(response.message, 'Error');
        }
      });
  }

  maximizeQuestionSection: boolean = false;
  toggleMaximizeQuestionSection() {
    if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      this.isFullWidthIDEQuestion = !this.isFullWidthIDEQuestion;
    } else {
      this.maximizeQuestionSection = !this.maximizeQuestionSection;
    }
  }

  searchText = '';
  showIframe = true;

  previewConsoleLogs: Array<{ level: string; message: string; ts: number }> =
    [];
  showPreviewConsole = false;
  previewConsoleErrorCount = 0;
  private readonly PREVIEW_CONSOLE_MAX = 500;
  private previewMessageHandler = (event: MessageEvent) =>
    this.onPreviewConsoleMessage(event);

  private onPreviewConsoleMessage(event: MessageEvent) {
    if (!this.rawPreviewUrl || event.data?.source !== 'iqigai-preview-console')
      return;
    // only accept messages from the preview's own origin (code-server and
    // other frames also post messages)
    let previewOrigin: string;
    try {
      previewOrigin = new URL(this.rawPreviewUrl).origin;
    } catch {
      return;
    }
    if (event.origin !== previewOrigin) return;

    const entries = Array.isArray(event.data.entries)
      ? event.data.entries
      : [];
    for (const entry of entries) {
      this.previewConsoleLogs.push({
        level: typeof entry.level === 'string' ? entry.level : 'log',
        message: typeof entry.message === 'string' ? entry.message : '',
        ts: entry.ts || Date.now(),
      });
      if (entry.level === 'error') this.previewConsoleErrorCount++;
    }
    if (this.previewConsoleLogs.length > this.PREVIEW_CONSOLE_MAX) {
      this.previewConsoleLogs.splice(
        0,
        this.previewConsoleLogs.length - this.PREVIEW_CONSOLE_MAX
      );
    }
    setTimeout(() => {
      const el = document.getElementById('preview-console-body');
      if (el) el.scrollTop = el.scrollHeight;
    });
  }

  clearPreviewConsole() {
    this.previewConsoleLogs = [];
    this.previewConsoleErrorCount = 0;
  }

  previewConsoleHeight = 35; // % of the preview pane
  private isConsoleDragging = false;
  private consoleDragStartY = 0;
  private consoleDragStartHeight = 0;
  private consoleDragMove = (event: MouseEvent) =>
    this.onConsoleDragging(event);
  private consoleDragUp = () => this.onConsoleDragEnd();

  onConsoleDragStart(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();
    this.isConsoleDragging = true;
    this.consoleDragStartY = event.clientY;
    if (!this.showPreviewConsole) this.showPreviewConsole = true;
    this.consoleDragStartHeight = this.previewConsoleHeight;
    // iframes swallow mouse events and break the drag
    document.querySelectorAll('iframe').forEach((iframe) => {
      iframe.style.pointerEvents = 'none';
    });
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'row-resize';
    document.addEventListener('mousemove', this.consoleDragMove);
    document.addEventListener('mouseup', this.consoleDragUp);
  }

  private onConsoleDragging(event: MouseEvent) {
    if (!this.isConsoleDragging) return;
    const panel = document.getElementById('preview-console-panel');
    const containerHeight =
      panel?.parentElement?.clientHeight || window.innerHeight;
    const deltaPercent =
      ((this.consoleDragStartY - event.clientY) / containerHeight) * 100;
    this.previewConsoleHeight = Math.max(
      10,
      Math.min(80, this.consoleDragStartHeight + deltaPercent)
    );
  }

  private onConsoleDragEnd() {
    if (!this.isConsoleDragging) return;
    this.isConsoleDragging = false;
    document.querySelectorAll('iframe').forEach((iframe) => {
      iframe.style.pointerEvents = 'auto';
    });
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
    document.removeEventListener('mousemove', this.consoleDragMove);
    document.removeEventListener('mouseup', this.consoleDragUp);
  }

  reloadPreview() {
    this.clearPreviewConsole();
    this.showIframe = false;
    setTimeout(() => {
      // const refreshedUrl = this.rawPreviewUrl + '?r=' + new Date().getTime();
      const refreshedUrl = this.rawPreviewUrl;
      this.IDEpreviewUrl =
        this._sanitizer.bypassSecurityTrustResourceUrl(refreshedUrl);
      this.showIframe = true;
    }, 100);
  }

  startBlindReloadRetries(maxRetries: number, intervalMs: number) {
    let attempt = 0;

    const retryInterval = setInterval(() => {
      if (attempt >= maxRetries) {
        console.log('✅ Finished blind reload retries.');
        clearInterval(retryInterval);
        return;
      }

      attempt++;
      console.log(`🔁 Blind reloadPreview attempt #${attempt}`);
      try {
        this.reloadPreview();
      } catch (err) {
        console.error('Error during blind reloadPreview:', err);
        // Still continue — we’re blind anyway
      }
    }, intervalMs);
  }

  openInNewTab() {
    window.open(this.rawPreviewUrl, '_blank');
  }

  // saveTechnicalQuestion(userAssessmentDriveSetId: any) {
  //   this.technicalQuestionDto.userAssessmentDriveSetId =
  //     userAssessmentDriveSetId;
  //   this.technicalQuestionDto.driveId = this.driveData;
  //   this.technicalQuestionDto.mobileNumber = this.loginUser.phoneNumber;
  //   this._examinationService
  //     .saveTechnicalQuestion(this.technicalQuestionDto)
  //     .subscribe((response) => {
  //       if (response.statusCode === HttpStatusCode.Ok) {
  //       } else {
  //         this.toastr.error(response.message, 'Error');
  //       }
  //     });
  // }

  // saveFFFQuestion(totalQuestion: any, candidateResumeURL: any) {
  //   // const base64File = localStorage.getItem('fileBase64');
  //   // if (!totalQuestion || totalQuestion === 0) {
  //   //   console.error('Total questions cannot be zero');
  //   //   return;
  //   // }

  //   // const blob = this.dataURLtoBlob(base64File);
  //   // const file = new File([blob], 'resume.pdf', { type: blob.type });
  //   // const formData = new FormData();
  //   // formData.append('file', file);
  //   // formData.append('num_fff_questions', totalQuestion);

  //   const payload: any = {
  //     resume: candidateResumeURL,
  //     num_fff_questions: totalQuestion,
  //   };

  //   this._authService.saveResumeForFFF(payload).subscribe({
  //     next: (res) => {
  //       let getfffQuestionList = res.data?.fff_question;

  //       if (!getfffQuestionList || getfffQuestionList.length === 0) {
  //         this.loading = false;
  //         return;
  //       }
  //       this.saveMultipleAudioQuestion(getfffQuestionList);

  //       this.loading = false;
  //     },
  //     error: (err) => {
  //       console.error('Error saving FFF question:', err);
  //       this.loading = false;
  //     },
  //   });
  // }

  // saveMultipleAudioQuestion(getfffQuestionList: any) {
  //   const payload = {
  //     candidateId: this.loginUser?.id,
  //     mobileNumber: this.loginUser?.phoneNumber,
  //     audioQuestionTexts: getfffQuestionList,
  //     questionType: 'Fit For Fractal',
  //   };

  //   this._authService.saveMultipleAudioQuestion(payload).subscribe({
  //     next: (res) => {
  //       if (res.statusCode === HttpStatusCode.Ok) {
  //         this.toastr.success(res.message, 'Success');
  //       } else {
  //         this.toastr.error(res.message, 'Error');
  //       }
  //     },
  //     error: (err) => {
  //       this.toastr.error('Failed to save audio question', 'Error');
  //     },
  //   });
  // }

  stopJupyterServer() {
    const requestPayload = {
      question_id: this.idToStopJupyterContainer,
      candidate_id: this.loginUser.id,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
      // questionId: this.allQuestionsData.questionId,
      // candidateId: this.loginUser.id,
      // assessmentDriveId: this.userAssessmentDriveSetId,
      // driverId: this.driveData,
    };

    this._examinationService.stopCodeServer(requestPayload).subscribe({
      next: (res) => {
        if (res.statusCode === HttpStatusCode.Ok) {
          // this.toastr.success(res.message, 'Success');
          if (
            (!this.isLastSection || this.startedExamination) &&
            (!this.autoSubmitAssessment || !this.lastSectionAndLastQuestion)
          ) {
            this.createJupyterServer();
            this.loading = true;
            setTimeout(() => {
              this.loading = false;
            }, 5000);
          } else {
            this.loading = false;
          }
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err) => {
        this.toastr.error('Failed to stop Jupyter server', 'Error');
      },
    });
  }

  // dataURLtoBlob(dataURL: string): Blob {
  //   const byteString = atob(dataURL.split(',')[1]);
  //   const mimeString = dataURL.split(',')[0].split(':')[1].split(';')[0];
  //   const ab = new ArrayBuffer(byteString.length);
  //   const ia = new Uint8Array(ab);
  //   for (let i = 0; i < byteString.length; i++) {
  //     ia[i] = byteString.charCodeAt(i);
  //   }
  //   return new Blob([ab], { type: mimeString });
  // }

  intervalId: any;
  cycleMessages() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.currentMessageIndex =
        (this.currentMessageIndex + 1) % this.loadingMessages.length;
    }, 10000);
  }

  cycleJupyterMessages() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.currentMessageIndex =
        (this.currentMessageIndex + 1) % this.jupyterLoadingMessages.length;
    }, 6000);
  }

  private ideLoaderOffTimer: any = null;
  private jupyterLoaderOffTimer: any = null;
  private jupyterBoilerLoaderOffTimer: any = null;

  private showLoaderForCurrentQuestion(): void {
    const type = this.allQuestionsData?.questionType;
    if (type === 'IDE_TYPE') {
      this.IDELoader = true;
      this.loading = true;
    } else if (type === 'JUPYTER_NOTEBOOK') {
      this.jupyterLoader = true;
      this.loading = true;
    }
  }

  private clearPendingLoaderTimers(): void {
    if (this.ideLoaderOffTimer) {
      clearTimeout(this.ideLoaderOffTimer);
      this.ideLoaderOffTimer = null;
    }
    if (this.jupyterLoaderOffTimer) {
      clearTimeout(this.jupyterLoaderOffTimer);
      this.jupyterLoaderOffTimer = null;
    }
    if (this.jupyterBoilerLoaderOffTimer) {
      clearTimeout(this.jupyterBoilerLoaderOffTimer);
      this.jupyterBoilerLoaderOffTimer = null;
    }
    this.isIDETestCaseLoading = false;
  }

  get showLoader(): boolean {
    return (
      (this.allQuestionsData?.questionType === 'IDE_TYPE' && this.IDELoader) ||
      (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK' &&
        this.jupyterLoader)
    );
  }

  get currentLoadingMessage(): string {
    if (this.allQuestionsData?.questionType === 'IDE_TYPE') {
      return this.loadingMessages[this.currentMessageIndex];
    } else if (this.allQuestionsData?.questionType === 'JUPYTER_NOTEBOOK') {
      return this.jupyterLoadingMessages[this.currentMessageIndex];
    }
    return '';
  }

  previewPanelWidth: number = 30;
  isDragging = false;
  dragStartX = 0;
  initialWidth = 50;
  containerWidth = 0;
  containerEl!: HTMLElement;
  lastMouseX = 0;
  lastUpdateTime = 0;
  rafId: number | null = null;

  private readonly onDraggingBound = this.onDragging.bind(this);
  private readonly onDragEndBound = this.onDragEnd.bind(this);

  // Drag functionality methods
  onDragStart(event: MouseEvent) {
    event.preventDefault();
    event.stopPropagation();

    // Initialize dragging state
    this.containerEl = document.querySelector('.ide-container') as HTMLElement;
    if (!this.containerEl) return;

    this.isDragging = true;
    this.dragStartX = event.clientX;
    this.lastMouseX = event.clientX;
    this.initialWidth = this.previewPanelWidth;
    this.containerWidth = this.containerEl.getBoundingClientRect().width;
    this.lastUpdateTime = performance.now();

    // Add event listeners with capture phase to ensure they fire first
    document.addEventListener('mousemove', this.onDraggingBound, true);
    document.addEventListener('mouseup', this.onDragEndBound, true);

    // Prevent iframe from capturing mouse events
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      iframe.style.pointerEvents = 'none';
    });

    // Disable text selection and set cursor
    document.body.style.userSelect = 'none';
    document.body.style.cursor = 'col-resize';
  }

  onDragging(event: MouseEvent) {
    if (!this.isDragging) return;

    // Prevent default behavior and stop propagation
    event.preventDefault();
    event.stopPropagation();

    // Store the current mouse position
    this.lastMouseX = event.clientX;

    // Use requestAnimationFrame for smooth updates
    if (!this.rafId) {
      this.rafId = requestAnimationFrame(() => this.updateWidth());
    }
  }

  private updateWidth() {
    this.rafId = null;
    if (!this.isDragging || !this.containerEl) return;

    const currentTime = performance.now();
    const deltaTime = currentTime - this.lastUpdateTime;
    this.lastUpdateTime = currentTime;

    // Get current container dimensions
    const rect = this.containerEl.getBoundingClientRect();

    // Calculate new width with the current mouse position
    const mouseX = this.lastMouseX - rect.left;
    const rightSideWidth = rect.width - mouseX;

    // Calculate the new width percentage with smoothing
    const targetWidthPercent = (rightSideWidth / rect.width) * 100;
    const clampedWidth = Math.max(20, Math.min(80, targetWidthPercent));

    // Apply smooth transition based on frame time
    const smoothFactor = Math.min(1, deltaTime / 16.67); // 60fps = 16.67ms per frame
    const newWidth =
      this.previewPanelWidth +
      (clampedWidth - this.previewPanelWidth) * smoothFactor;

    // Update the preview panel width
    this.previewPanelWidth = newWidth;

    // Schedule next frame if still dragging
    if (this.isDragging) {
      this.rafId = requestAnimationFrame(() => this.updateWidth());
    }
  }

  onDragEnd(event?: MouseEvent) {
    if (!this.isDragging) return;

    // Cancel any pending animation frame
    if (this.rafId !== null) {
      cancelAnimationFrame(this.rafId);
      this.rafId = null;
    }

    // Clean up event listeners
    document.removeEventListener('mousemove', this.onDraggingBound, true);
    document.removeEventListener('mouseup', this.onDragEndBound, true);

    // Re-enable iframe interactions
    const iframes = document.querySelectorAll('iframe');
    iframes.forEach((iframe) => {
      iframe.style.pointerEvents = 'auto';
    });

    // Reset dragging state
    this.isDragging = false;
    document.body.style.userSelect = '';
    document.body.style.cursor = '';
  }

  IDECompiledTestCase: any;
  isIDETestCaseLoading: boolean;
  backendTestCase: any;
  frontEndTestCase: any;
  compile_execution_error:any;
  showExecutionError = false;
  
    @ViewChild('execErrorWrap') execErrorWrapRef: ElementRef;
  
    @HostListener('document:click', ['$event'])
    closeExecErrorOnOutsideClick(event: MouseEvent): void {
      if (!this.showExecutionError) return;
      const wrap = this.execErrorWrapRef?.nativeElement;
      if (wrap && !wrap.contains(event.target as Node)) {
        this.showExecutionError = false;
      }
    }
  
  runIDETestCase() {
    if (this.isIDETestCaseLoading) {
      return;
    }
    this.isIDETestCaseLoading = true;
    this.IDECompiledTestCase = '';
    this.compile_execution_error = null;
    this.showExecutionError = false;
    const requestQuestionId = this.allQuestionsData?.questionId;

    const payload = {
      questionId: this.allQuestionsData.questionId,
      userAssessmentDriveSetId: this.userAssessmentDriveSetId,
      driveId: this.driveData,
      projectPath: this.testCaseFolderPath,
      questionType: this.getCurrentSubcategories()
        // .toLowerCase()
        // .replace(/\s+/g, '_'),
    };

    this._examinationService.runIDETestCases(payload).subscribe({
      next: (res) => {
        const isStale = this.allQuestionsData?.questionId !== requestQuestionId;
        this.isIDETestCaseLoading = false;
        if (isStale) return;
        if (res.statusCode === HttpStatusCode.Ok) {
          this.toastr.success("Test cases executed successfully.", "Success");
          this.backendTestCase = res.data?.backend_test_cases;
          this.frontEndTestCase = res.data?.frontend_test_cases;
          this.compile_execution_error=res.data?.execution_error;
          console.log(this.compile_execution_error);
          

          if (this.backendTestCase) {
            this.IDECompiledTestCase = `${this.backendTestCase} Test Case Passed`;
          } else if (this.frontEndTestCase) {
            this.IDECompiledTestCase = `${this.frontEndTestCase} Test Case Passed`;
          } else {
            this.IDECompiledTestCase = 'No Test Cases Found';
          }
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err) => {
        this.isIDETestCaseLoading = false;
        if (this.allQuestionsData?.questionId !== requestQuestionId) return;
        this.toastr.error('Failed to run IDE test case', 'Error');
      },
    });
  }

    matchesFrontendCoding(): boolean {
    const subcategories = this.getCurrentSubcategories();
    const feKeywords = [
      'frontend',
      'front-end',
      'frontend_coding',
      'frontend coding',
      'fe',
      'react',
      'angular',
      'angularjs',
      'vue',
      'html',
      'css',
      'ui'
    ];

    const isFrontend = (value: string): boolean => {
      const lowerValue = value.toLowerCase();

      return feKeywords.some((keyword) =>
        lowerValue.includes(keyword)
      );
    };

    if (typeof subcategories === 'string') {
      return isFrontend(subcategories);
    }

    if (Array.isArray(subcategories)) {
      return subcategories.some((sub) => isFrontend(sub));
    }

    return false;
  }

  updatePreviewPort() {
    const payload = {
      candidate_folder: this.testCaseFolderPath,
      container_name: this.IDEContainerName,
      preview_port: String(this.previewPort),
    };

    this._examinationService.updatePreviewPort(payload).subscribe({
      next: (res) => {
        if (res.statusCode === HttpStatusCode.Ok) {
          // this.toastr.success(res.message, 'Success');
        } else {
          this.toastr.error(res.message, 'Error');
        }
      },
      error: (err) => {
        this.toastr.error('Failed to update IDE preview port', 'Error');
      },
    });
  }

  disablePrintKeys(): void {
    // Override browser's print functionality
    window.addEventListener('beforeprint', (e) => {
      if (
        this.startedExamination &&
        !['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(
          this.allQuestionsData?.questionType
        )
      ) {
        e.preventDefault();
        this.toastr.info('', 'Printing is disabled during examination');
      }
    });

    // Override Ctrl+P and Cmd+P
    window.addEventListener(
      'keydown',
      (e) => {
        if (
          this.startedExamination &&
          !['CODING_TYPE', 'SQL_CODING', 'JUPYTER_NOTEBOOK'].includes(
            this.allQuestionsData?.questionType
          )
        ) {
          if (
            (e.ctrlKey || e.metaKey) &&
            (e.key === 'p' || e.key === 'P' || e.keyCode === 80)
          ) {
            e.cancelBubble = true;
            e.preventDefault();
            e.stopImmediatePropagation();
            this.toastr.info('', 'Printing is disabled during examination');
          }
        }
      },
      true
    );
  }

  // private disableScreenCapture(): void {
  //   // Prevent various screenshot methods
  //   document.addEventListener(
  //     'keydown',
  //     (e) => {
  //       if (this.startedExamination) {
  //         const key = e.key.toLowerCase();
  //         const isPrintScreen =
  //           key === 'printscreen' ||
  //           key === 'prtsc' ||
  //           e.keyCode === 44 ||
  //           (e.code && e.code.toLowerCase() === 'printscreen');

  //         const hasModifier =
  //           e.ctrlKey ||
  //           e.metaKey ||
  //           e.altKey ||
  //           e.shiftKey ||
  //           e.getModifierState('Fn');

  //         if (
  //           isPrintScreen ||
  //           (hasModifier &&
  //             (key === 's' || key === '3' || key === '4' || key === '5'))
  //         ) {
  //           e.preventDefault();
  //           e.stopPropagation();
  //           navigator.clipboard.writeText('');
  //           this.toastr.info('', 'Screenshots are disabled during examination');
  //         }
  //       }
  //     },
  //     true
  //   );

  //   // Clear clipboard on print screen
  //   document.addEventListener(
  //     'keyup',
  //     (e) => {
  //       if (this.startedExamination) {
  //         if (e.key === 'PrintScreen' || e.keyCode === 44) {
  //           navigator.clipboard.writeText('');
  //         }
  //       }
  //     },
  //     true
  //   );
  // }

  handleDisconnect(response: WebSocketResponse): void {
    console.warn('WebSocket disconnect:', response.disconnectReason);
    this.isMobileFeedConnected = false;
    this.mobileConnectionModal = true;
    sessionStorage.setItem('isMobileConnectionLost', 'true');
    if (response.disconnectReason) {
      this.toastr.warning(response.disconnectReason);
    }
  }

  private handleWebSocketResponse(response: WebSocketResponse): void {
    if (typeof response.status === 'boolean') {
      const previousStatus = this.mobileFeedDto.mobileFeedCaptured;
      this.mobileFeedDto.mobileFeedCaptured = response.status;

      if (previousStatus !== response.status) {
        // this.toastr.info(response.status ? 'Mobile feed connected' : 'Mobile feed disconnected');

        // Send updated status
        const loggedInUserRaw = localStorage.getItem('loggedInUser');
        const userAssessmentIdRaw = sessionStorage.getItem(
          'userAssessmentDriveSetId'
        );
        if (!loggedInUserRaw || !userAssessmentIdRaw) {
          throw new Error('Missing required credentials');
        }
        // Parse user data and get token
        const parsedUser = JSON.parse(loggedInUserRaw);
        const token = parsedUser?.authToken;
        this.mobileFeedWebSocketService.sendMobileFeedStatus(
          token,
          userAssessmentIdRaw
        );
      }
    }

    if (response.data) {
      this.mobileFeedDto = {
        ...this.mobileFeedDto,
        ...response.data,
      };
    }

    if (response.message) {
      // this.toastr.info(response.message);
    }
  }

  executeReadOnlyQuery(query: string, db: any) {
    console.log(query);

    // Layer 1: Quick validation (blocks obvious attacks)
    const validation = this.basicValidation(query);
    if (!validation.isValid) {
      this.isLoading = false;
      this.isExecutingCode = false;
      return {
        success: false,
        error: validation.error,
        type: 'validation',
      };
    }

    // Layer 2: Execute with rollback (safety net)
    try {
      db.run('BEGIN TRANSACTION');
      const results = db.exec(query);
      db.run('ROLLBACK');
      this.isLoading = false;
      this.isExecutingCode = false;
      return {
        success: true,
        data: results,
      };
    } catch (error) {
      try {
        db.run('ROLLBACK');
      } catch (e) {}
      this.isLoading = false;
      this.isExecutingCode = false;
      return {
        success: false,
        error: error.message,
        type: 'execution',
      };
    } finally {
      this.isLoading = false;
      this.isExecutingCode = false;
    }
  }

  private basicValidation(query: string): { isValid: boolean; error?: string } {
    const upperQuery = query.trim().toUpperCase();

    if (!/^(WITH|SELECT)\s+/i.test(upperQuery)) {
      return {
        isValid: false,
        error: 'Data modification and schema change operations are not allowed',
      };
    }

    // const forbidden = ['DROP', 'CREATE', 'ALTER', 'TRUNCATE', 'PRAGMA', 'ATTACH'];
    const found = this.disallowedCommands.find((kw) =>
      new RegExp(`\\b${kw}\\b`, 'i').test(upperQuery)
    );

    if (found) {
      return { isValid: false, error: `Keyword ${found} not allowed` };
    }

    return { isValid: true };
  }

  async initializeAllQuestions(allQuestionIds: string[]) {
    try {
      const zipBuffer = await firstValueFrom(
        this._examinationService.getSqlQuestionFile(allQuestionIds)
      );
      this.storeExtractedSqlFiles(zipBuffer);
    } catch (err) {
      console.error('Error fetching or extracting ZIP:', err);
    }
  }

  async storeExtractedSqlFiles(zipBuffer: ArrayBuffer) {
    const zip = await JSZip.loadAsync(zipBuffer);
    for (const [filename, file] of Object.entries(zip.files)) {
      if (!file.dir && filename.endsWith('.sqlite')) {
        const buffer = await file.async('arraybuffer');
        await this.sqlStorageService.saveFile(filename, buffer);
      }
    }
    console.log('All SQLite files saved to IndexedDB');
  }
  // async initaializeSqlDb(questionId: string) {

  //     this.loading = true;
  //     try {
  //       // Check if database already has data
  //       this.dbHasData = await this.sql_evaluator_service.hasData();

  //       if (!this.dbHasData) {
  //         console.log('No existing data found, creating tables...');
  //         this.dbHasData = true;
  //       } else {
  //         console.log('Database loaded from IndexedDB with existing data');
  //         const tables = await this.sql_evaluator_service.getTables();
  //       }
  //     } catch (error) {
  //       console.error('Error initializing database:', error);
  //       this.error = 'Failed to initialize database';
  //     } finally {
  //       this.loading = false;
  //     }
  //   }

  async executeQueryForQuestion(questionId: string): Promise<number> {
    this.compiledCode = null;
    this.isLoading = true;
    this.testCaseProcessing = true;
    this.isExecutingCode = true;
    this.testCasesList = [];
    const allKeys = await this.sqlStorageService.getAllKeys();
    if (allKeys instanceof Error) {
      this.compiledCode = allKeys.message;
      console.error('Error fetching keys:', allKeys.message);
      return 0;
    }

    const testCaseKeys = allKeys.filter((k) =>
      k.startsWith('all-sqlite-files/' + questionId + '/')
    );

    if (!testCaseKeys.length) {
      console.warn('No test case DB found for this question');
      return 0;
    }

    const SQL = await initSqlJs({ locateFile: (file) => `assets/${file}` });
    let passed = 0;

    // Get user's SQL query
    const userQuery = this.answers[this.currentQuestionIndex];
    if (!userQuery) {
      this.error = 'Please enter a SQL query to test';
      return 0;
    }
    // Loop over each test case database
    for (const key of testCaseKeys) {
      const buffer = await this.sqlStorageService.getFile(key);
      if (!buffer) continue;

      const db = new SQL.Database(new Uint8Array(buffer));
      try {
        const { success, error, type, data } = this.executeReadOnlyQuery(
          userQuery.toString(),
          db
        );
        console.log(success, error, type, data);
        this.testCaseProcessing = false;
        if (error) {
          this.compiledCode = error;
          this.isLoading = false;
          this.testCaseProcessing = false;
          this.isExecutingCode = false;
          this.testCasesList.push({
            outPut: error,
            passed: false,
          });
        } else {
          const candidateOutput =
            this.sqlStorageService.formatQueryOutput(data);
          const matchedTestCases = this.allQuestionsData.testCaseDtos.filter(
            (t: any) => {
              const expectedPath = t.ExpectedInput || '';
              // const expectedFileName = expectedPath.split("/").pop();
              // const keyFileName = key.split("/").pop();
              return key?.includes(expectedPath);
            }
          );

          if (matchedTestCases.length > 0) {
            matchedTestCases.forEach((tc) => {
              const expectedOutput = this.sqlStorageService.parseExpectedOutput(
                tc.ExpectedOutPut
              );
              console.log(expectedOutput);

              const isMatch = this.sqlStorageService.compareOutputs(
                candidateOutput,
                expectedOutput
              );
              tc.correct = isMatch;
              tc.testCaseStatus = isMatch ? 'PASSED' : 'FAILED';
              tc.status = isMatch ? 'ACCEPTED' : 'WRONG_ANSWER';
              tc.actualOutput = candidateOutput;
              this.testCasesList.push({
                outPut: tc.actualOutput,
                passed: tc.correct,
              });
              if (isMatch) passed++;
            });
            this.compiledCode = `${passed}/${this.allQuestionsData.testCaseDtos.length} Test Cases Passed`;
            // compute visible (first 5) counts and persist per-question
            const visible = (this.allQuestionsData.testCaseDtos || []).slice(0, 5);
            this.visibleTestCaseCount = visible.length;
            this.visibleCorrectCases = visible.filter((t: any) => t.correct).length;
            this.totalCorrectCases = passed;
            if (this.currentQuestionIndex != null) {
              this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
              this.visibleCorrectCasesMap[this.currentQuestionIndex] = this.visibleCorrectCases;
              this.visibleTestCaseCountMap[this.currentQuestionIndex] = this.visibleTestCaseCount;
              this.totalCorrectCasesMap[this.currentQuestionIndex] = this.totalCorrectCases;
            }
          } else {
            console.warn('No expected output found for key:', key);
          }
        }
      } catch (e: any) {
        this.compiledCode = e;
        if (this.currentQuestionIndex != null) {
          this.compiledCodeMap[this.currentQuestionIndex] = this.compiledCode;
          this.visibleCorrectCasesMap[this.currentQuestionIndex] = 0;
          this.visibleTestCaseCountMap[this.currentQuestionIndex] = 0;
          this.totalCorrectCasesMap[this.currentQuestionIndex] = 0;
        }
        console.error('Query error on', key, e);

        const testCase = this.allQuestionsData.testCaseDtos.find((t: any) =>
          key.includes(t?.testCaseId)
        );
        if (testCase) {
          testCase.correct = false;
          testCase.testCaseStatus = 'FAILED';
          testCase.status = 'ERROR';
          testCase.runtimeError = e.message;
        }
      } finally {
        db.close();
      }
    }
    return passed;
  }

  isIqigaiLiteApp() {
    console.log(
      this.isDesktopApp,
      environment.DESKTOP_IQIGAI_LITE,
      this.isIqigaiOfflineDrive
    );
    if (
      this.isDesktopApp &&
      environment.DESKTOP_IQIGAI_LITE &&
      this.isIqigaiOfflineDrive
    ) {
      console.log('inside iqigaiLite', this.isLiteAppVersion);
      this.isLiteAppVersion = true;
      return;
    }
    this.isLiteAppVersion = false;
  }

  autoResize(index: number) {
    const textarea = document.getElementById(
      `fib-input-${index}`
    ) as HTMLTextAreaElement;
    if (textarea) {
      textarea.style.height = 'auto';
      const contentHeight = textarea.scrollHeight;
      textarea.style.height = `${contentHeight}px`;
      const lineHeight = 20;
      const maxLines = 18;
      const maxHeight = maxLines * lineHeight;
      if (contentHeight > maxHeight) {
        textarea.style.height = `${maxHeight}px`;
        textarea.style.overflowY = 'auto';
      } else {
        textarea.style.overflowY = 'hidden';
      }
    }
  }

  convertBlobToBase64(blob: Blob): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result as string);
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  }

  currentStep = 0;
  steps = [0, 1, 2];

  handleNext() {
    if (this.currentStep < this.steps.length - 1) {
      this.currentStep++;
    }
  }

  handleBack() {
    if (this.currentStep > 0) {
      this.currentStep--;
    }
  }

  getImageForStep(): string {
    const images = [
      this._commonService.Images.IDE_WAITING_SCREEN_01,
      this._commonService.Images.IDE_WAITING_SCREEN_02,
      this._commonService.Images.IDE_WAITING_SCREEN_03,
    ];
    return images[this.currentStep] || images[0];
  }

  liteExamStart() {
    this.enablestepOne = false;
    this.enableStepThree = false;
    this.enableStepFour = false;
    this.enableStepFive = true;
    this.startedExamination = true;
    this.sectionBreakTime = 0;
    this.startTimer(this.sectionBreakTime);
    this.breakTimeScreen = false;
  }

  startCamera() {
    // The Audio & Video setup step now renders <app-audio-video-setup> (which
    // owns its own preview), so the #videoPlayer element is no longer present.
    if (!this.videoElement?.nativeElement) {
      return;
    }
    navigator.mediaDevices
      .getUserMedia({ video: true, audio: false })
      .then((stream) => {
        this.videoElement.nativeElement.srcObject = stream;
      })
      .catch((err) => {
        console.error('Error accessing camera:', err);
        // Optionally show fallback UI or error message
      });
  }

  /**
   * Result of the in-proctoring audio/video check (record + listen-back
   * consent). Gates the "Continue" button on the Audio & Video setup step.
   */
  onAudioVideoTestPassed(passed: boolean): void {
    this.audioVideoTestPassed = passed;
  }

  navToDriveHomePage() {
    this._router
      .navigate([this._commonService.Navigations.DASHBOARD_ASSESSMENT])
      .then(() => {
        window.location.reload();
      });
  }

  normalizeEmpty(arr: any[]) {
    if (!arr || arr.length === 0) return [];
    const filtered = arr.filter((v) => v !== '');
    return filtered.length === 0 ? [] : filtered;
  }

  get isLastQuestion() {
    return (
      this.currentQuestionIndex ===
      this.getTotalQuestionsInSection(this.allQuestionsDataForTopBar) - 1
    );
  }

  bottomPanelExpanded: boolean = false;
  toggleBottomPanel() {
    this.bottomPanelExpanded = !this.bottomPanelExpanded;
    console.log(this.bottomPanelExpanded, 'this.bottomPanelExpanded');
  }

  getButtonClasses(
    i: number,
    tc: { correct?: boolean } | null | undefined,
    selectedTestCase:
      | { compileError?: string; correct?: boolean }
      | null
      | undefined,
    selectedTestCaseIndex: number
  ) {
    const classes = [
      'rounded-lg',
      'px-3',
      'py-2',
      'text-xs',
      'flex',
      'items-center',
      'gap-2',
    // cursor
      // i <= 1 ? 'cursor-pointer' : 'cursor-not-allowed',
    // text/bg highlights
      selectedTestCaseIndex === i && tc?.correct
        ? '!text-[#7ca755]'
        : '',
      selectedTestCaseIndex === i && tc?.correct
        ? '!bg-[#caf2c9]'
        : '',
      selectedTestCaseIndex === i && !tc?.correct
        ? '!text-[#ff2626]'
        : '',
      selectedTestCaseIndex === i && !tc?.correct
        ? '!bg-[#ffbfbf]'
        : '',
      selectedTestCaseIndex !== i ? 'text-primary_Text_Color' : '',
    ].filter(Boolean);

    // Border logic — single source of truth
    // Index 0: solid gray
    // if (i === 0) {
    //   classes.push('!border', '!border-[#D4D8DE]', '!border-solid');
    // }
    // Index 1: solid green/red regardless of compile error
    if (i <= 1) {
      classes.push(
        '!border',
        tc?.correct ? '!border-[#7ca755]' : '!border-[#ff2626]',
        '!border-solid'
      );
    }
    // Index >= 2:
    else {
      const noCompileError =
        selectedTestCase?.compileError === 'No compilation errors.';
      if (tc?.correct) {
        // passed → dashed green
        classes.push('!border', '!border-[#7ca755]', '!border-dashed');
      } else if (noCompileError) {
        // failed w/o compile error → dashed red
        classes.push('!border', '!border-[#ff2626]', '!border-dashed');
      } else {
        // failed with compile error → dashed gray, thicker
        classes.push('!border-2', '!border-[#D4D8DE]', '!border-dashed');
      }
    }

    return classes;
  }

 getPanelHeight(): string {
   const screenHeight = window.innerHeight;  
   if((this.driveData === '102980' || this.driveData === '244403' || this.driveData === '239424' || this.driveData === '715158') && this.allQuestionsData?.questionType === 'CODING_TYPE'){
    if (this.bottomPanelExpanded) {
      return screenHeight <= 720 ? '5vh' : '10vh';
    } else {
      if (!this.fullScreenModeEnabled) {
        return '25vh';
      } else if (screenHeight < 850) {
        return '30vh';
      } else if (screenHeight <945 && screenHeight >= 850) {
        return '35vh';
      }else {
        return '45vh';
      }
    }
   } else if (
      this.allQuestionsData?.questionType === 'CODING_TYPE' ||
      this.allQuestionsData?.questionType === 'SQL_CODING'
    ) {
      if (this.bottomPanelExpanded) {
        return screenHeight <= 720 ? '5vh' : '10vh';
      } else {
        if (!this.fullScreenModeEnabled) {
          return '35vh';
        } else if (screenHeight <= 720) {
          return '45vh';
        } else {
          return '50vh';
        }
      }
    }
    return '';
  }

private parse(time: string): number {
    const [m, s] = time.split(':').map(Number);
    return m * 60 + s;
}  

stopAudioTimer() {
    clearInterval(this.timerRef);
    this.timerRef = null;
}

get displayTime(): string {
  // Ensure we don't have negative numbers
  const time = Math.max(0, this.seconds); 

  const minutes = Math.floor(time / 60);
  const seconds = time % 60;

  const minStr = minutes.toString().padStart(2, '0');
  const secStr = seconds.toString().padStart(2, '0');

  // Returning a consistent format to match your "05:00 min" target
  return `${minStr}:${secStr} `;
} 

get displayAudioRecordingTimeInUnits(){
  let totalSeconds = this.parse(this.recordedAudioTime);
  const totalMin = Math.floor(totalSeconds / 60);
  return  `${this.recordedAudioTime} ${totalMin>0 ?' min':''}`
} 

start() {
   if (this.timerRef) return;

  // Optional: If starting fresh, set seconds to 0
  // this.seconds = 0; 

  this.timerRef = setInterval(() => {
    const limit = this.parse(this.recordedAudioTime);

    if (this.seconds < limit) {
      this.seconds++;
    } else {
       this.seconds = 0;
      // Optional: Stop or Reset when it reaches the limit
      // this.stop(); // Stop the timer
      // this.seconds = 0; // Or reset to 0 if you want it to loop
    }
  }, 1000);
  }


  get panelClass() {
  let classes = '';
  if (this.bottomPanelExpanded) {
    classes += !this.fullScreenModeEnabled ? '!min-h-[30vh]' : '!min-h-[45vh]';
    classes += ' overflow-auto';
  } else {
    classes += '!min-h-[5vh]';
    classes += ' overflow-hidden';
  }
  return classes;
}

// get panelClass() {
//   if (this.bottomPanelExpanded) {
//     return !this.fullScreenModeEnabled ? '!min-h-[30vh]' : '!min-h-[45vh]';
//   } else {
//     return '!min-h-[5vh]';
//   }
// }
goBack(){
  this.showUnattemptedModal = false;
  if (this.allQuestionsData?.questionType === 'SQL_CODING') {
    const currentAnswer = this.answers[this.currentQuestionIndex];
    if (!currentAnswer) {
      this.getCodingLanguageSelected();
    }
  }
 }
 closeEndAssessment(){
  this.ristrictExitingAssessment=!this.ristrictExitingAssessment;
  this.endSection=false;
}

}

export class questionDto {
  selectedAnswers: string[] = [];
  id: number;
  question: string;
  questionId: string;
  options: optionDto[] = [];
  questionType: string;
  attempted: boolean;
  visited: boolean;
  skipped: boolean;
  opened?: boolean;
  answer: string;
  startTime: any;
  selectedLanguage: any;
  savedLanguage:any;
  isReported:boolean;
  languageCodeMap:any;
}
export class optionDto {
  answer: string;
  id: string;
}

export class RecordedVideoDto {
  questionId: string;
  videoId: string;
}

export class CodingQuestionDto {
  sourceCode?: string;
  languageId?: string;
  stdIn?: any;
  mquestionId?: any;
  mQuestionId?: any;
  languageType?:string
  questionId?:string
}

export interface TestCaseDto {
  id: number | null;
  textCaseResult: string | null;
  actualOutput: string | null;
  testCaseStatus: string | null;
  status: string | null;
  compileError: string | null;
  runtimeError: string | null;
  executionTime: number | null;
  memoryUsed: number | null;
  correct: boolean;
  ExpectedOutPut: string;
  ExpectedInput: string;
  dataset_type: string | null;
}
